// import {
//   Backdrop,
//   FormControl,
//   Radio,
//   RadioGroup,
//   TextareaAutosize,
//   TextField,
//   InputLabel,
//   MenuItem,
//   Select,
// } from "@mui/material";
// import React, { useEffect } from "react";
// import "../../../../src/assets/css/material-dashboard_1.css";
// import MessageChannelSelect from "./MessageChannelSelect";
// import MessageRouteSelect from "./MessageRouteSelect";
// import MessageTextSelect from "./MessageTextSelect";
// import SenderIdSelector from "./SenderIdSelector";
// import TestRadio from "./TestRadio";
// import TemplateSelect from "./MessageTemplateSelect";
// import { useRef } from "react";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
// import { useState } from "react";
// import TargettedSelect from "./TargettedSelect";
// import BulkSelect from "./BulkSelect";
// import Button from "@mui/material/Button";
// import BulkSelect1 from "./BulkSelect1";
// import { ThemeProvider, createTheme } from "@mui/material";
// import { Formik, useFormik } from "formik";
// import * as yup from "yup";
// import NativePickers from "./ScheduleTimeDate";
// import MessageTemplateSelect from "./MessageTemplateSelect";
// import InfoIcon from "@mui/icons-material/Info";
// import IconButton from "@mui/material/IconButton";
// import Tooltip from "@mui/material/Tooltip";
// import { common_axios } from "../../../App";
// import { toast } from "react-toastify";
// import Loader from "../../../components/Loader";
// import ArrowRightAltRoundedIcon from "@mui/icons-material/ArrowRightAltRounded";
// import Accordion from "@mui/material/Accordion";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import Typography from "@mui/material/Typography";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import contactfile1 from "../../../file/voice_campaign.xlsx";
// import contactfile2 from "../../../file/referencecsv.csv";
// import contactfile3 from "../../../file/campaigntext.txt";
// import CancelIcon from "@mui/icons-material/Cancel";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import Chip from "@mui/material/Chip";
// import DoneIcon from "@mui/icons-material/Done";
// import moment from "moment";
// import dayjs from "dayjs";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { Link } from "react-router-dom";
// import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import ContactsIcon from "@mui/icons-material/Contacts";
// import ForumIcon from "@mui/icons-material/Forum";
// import { useDispatch } from "react-redux";
// import { setDropDown } from "../../../redux/features/CampaignSlice";
// import { setCampaignState } from "../../../redux/actions/campaignAction";
// import SmsIcon from "@mui/icons-material/Sms";
// import { actionid } from "../../../redux/features/pageSlices";
// import Box from "@mui/material/Box";
// import Skeleton from "@mui/material/Skeleton";
// import Swal from "sweetalert2";
// import { CoPresentOutlined, InsertLinkOutlined } from "@mui/icons-material";
// import Switch from '@mui/material/Switch';

// export default function Sendsms() {
//   const history = useHistory();
//   const dispatch = useDispatch();
//   // ...................................Theme Provider....................................//
//   const theme = createTheme({
//     components: {
//       MuiInputLabel: {
//         styleOverrides: {
//           asterisk: { color: "red" },
//           // "&$error": {
//           //   color: "#db3131",
//           // },
//         },
//       },
//     },
//   });
//   const [disableMobileNumber, setDisableMobileNumber] = React.useState([]);
//   const [data, setData] = useState([]);
//   const [personName, setPersonName] = React.useState([]);
//   const [expandedinter, setExpandedinter] = React.useState(false);
//   const [disableNext, setdisableNext] = useState(true);
//   const [disableNext1, setdisableNext1] = useState(false);
//   const [buttonDisable, setbuttonDisable] = useState(false);
//   const handleChange = (panel) => (event, newExpanded) => {
//     setExpandedinter(newExpanded ? panel : false);
//   };
//   const [expanded, setexpanded] = useState(true);
//   const [expanded1, setexpanded1] = useState(false);
//   const [checkicon, setcheckicon] = useState(false);
//   const [checkicon1, setcheckicon1] = useState(false);
//   // const [cancleicon, setcancleicon] = useState(false);
//   const [radiobutton, setradiobutton] = useState(undefined);
//   const [RadioGroupValues, setRadioGroupValues] = useState("");
//   // console.log("09o", radiobutton);
//   // const [RadioGroupValues1, setRadioGroupValues1] = useState();
//   const [val, setval] = useState(false);
//   const [scheduleTime, setscheduleTime] = useState();
//   const [scheduleDate, setscheduleDate] = useState();
//   const [TargettedArray, setTargettedArray] = useState();
//   const [TemplateArray, setTemplateArray] = useState();
//   const [open, setOpen] = useState();
//   const [FilesImage, setFilesImage] = useState(null);
//   // console.log("kkk", FilesImage);
//   const [Textarea, setTextarea] = useState("");
//   const [Textarea1, setTextarea1] = useState("");
//   const [Textareadisabled, setTextareadisabled] = useState(false);
//   const [senderId, setsenderId] = useState("");
//   const [showradioerror, setshowradioerror] = useState(false);
//   const [Language, setLanguage] = useState("");
//   const [MSG, setMSG] = useState("");
//   const [MSR, setMSR] = useState("");
//   const [MST, setMST] = useState({});
//   const [Bulkselector1, setBulkselector1] = useState([]);
//   const [Bulkselector, setBulkselector] = useState([]);
//   const [Target, setTarget] = useState("");
//   const [pairdisable, setpairdisable] = useState(true);
//   const [showchoosevalue, setshowchoosevalue] = useState(false);
//   // const [value, setValue] = React.useState(null);
//   const [value, setValue] = React.useState(
//     moment(new Date()).subtract(5.5, "hours").add(20, "minutes")
//   );
//   // console.log("mkkk",value)
//   const [calenderSchedule, setCalenderSchedule] = useState();
//   const [testcampaign, settestcampaign] = useState("");
//   const [hideSkeleton, setHideSkeleton] = useState();
//   const customId1 = "custom-id-yess";
//   const [onchangeradio, setOnchangeRadio] = useState();
//   const [onchangeradioBulkGroup, setonchangeradioBulkGroup] = useState();
//   const [TextArea1, setTextArea1] = useState("");
//   const [valueResponse, setValueResponse] = useState("");
//   const [CamapaignDropdown, setCamapaignDropdown] = useState(true);
//   const [LanguageData, setLanguageData] = useState([]);
//   const [LangId, setLangId] = useState(undefined);
//   const [lang, setLang] = useState();
//   const [mobileNumbers, setMobileNumbers] = React.useState("");
//   const [Radiosdisabled, setRadiosdisabled] = useState({
//     textarea: true,
//     bulk: true,
//     bulk1: true,
//     choose: true,
//   });

//   const [state, setState] = React.useState({
//     files: [],
//   });
//   const [checked, setChecked] = React.useState(false);
//   const handleChangetoogle = (event) => {
//     setChecked(event.target.checked);
//   };
//   const [checkedRecurring, setCheckedRecurring] = React.useState(false);

//   const handleChangetoogleRecurring = (event) => {
//     setCheckedRecurring(event.target.checked);
//     setStatusDropDown(null)
//   };

//   const [statusDropDown, setStatusDropDown] = React.useState("");
//   const handleChangeRecurring = (event) => {
//     setStatusDropDown(event.target.value);
//   };

//   //  console.log("first", checkedRecurring);
//   const [ContactArray, SetContactArray] = useState([]);
//   //  console.log("0999", checked);
//   //  console.log("ab", statusDropDown);

//   const FirstNext = () => {
//     setexpanded1(true);
//     setexpanded(false);
//   };
//   const SecondNext = () => {
//     setexpanded1(false);
//     // setexpanded(false);
//   };
//   const cuttt = useRef();
//   const datereff = useRef();
//   const initialValues = {
//     campaignname: `SMS_CAMP_${Math.floor(Math.random() * 10000000000)}`,
//     textarea: "",
//     textarea1: "",
//   };
//   const regex = /^[0-9,]+$/;

//   const validationSchema = yup.object({
//     campaignname: yup
//       .string()
//       //   .min(1000000000, "Please type atleast 10 digits")
//       //   .max(10000000000, "Maximum length of mobile number is 10")
//       .required("Required"),
//     textarea: yup
//       .string("enter")
//       .matches(regex, "Msisdn should be of type number only!")
//       //   .min(1000000000, "Please type atleast 10 digits")
//       //   .max(10000000000, "Maximum length of mobile number is 10")
//       // .required("Required"),
//       .nullable(),
//     textarea1: yup
//       .string()
//       //   .min(1000000000, "Please type atleast 10 digits")
//       //   .max(10000000000, "Maximum length of mobile number is 10")
//       // .required("Required"),
//       .nullable(),
//   });
//   // console.log("5t5t5t5t5t", RadioGroupValues, radiobutton);
//   const formik = useFormik({
//     initialValues: initialValues,
//     validateOnChange: false,
//     validationSchema: validationSchema,

//     onSubmit: async (values) => {
//       if (checkicon == false) {
//         // alert("enter");
//         // setexpanded(true);
//       } else {
//         if (radiobutton == "1" || radiobutton == undefined) {
//           // alert("select 1");
//           setshowradioerror(false);
//           try {
//             setOpen(true);

//             const result = await common_axios.post(
//               `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,

//               {
//                 keywordRequest: {
//                   keyword: values.textarea1,
//                 },
//               }
//               // `http://192.168.167.66:4900/user/phone-books/v1/list`
//             );
//             if (result.data.statusDescription.statusCode == 200) {
//               setOpen(false);

//               if (result.data) {
//                 try {
//                   setOpen(true);
//                   // alert("working");
//                   const result = await common_axios.post(
//                     `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign`,
//                     {
//                       campaignName: values.campaignname,
//                       senderId: senderId.senderId,
//                       channel: "web",
//                       route: "quyeru",
//                       templateId: MST == null ? "" : MST?.id,
//                       templateMessage: values.textarea1,
//                       smsType: MSG,
//                       language: lang,
//                       unicode: LangId == 1 ? "0" : "1",
//                       message: values.textarea1,
//                       campaignType: "Individual",
//                       // manualMsisdnArray: values.textarea,
//                       manualMsisdnArray: mobileNumbers,
//                       campaignSource: "own_numbers_manual",
//                       isRoleOver:checked,
//                       // scheduledDatetime:"null"
//                     }
//                   );
//                   // console.log("resultttttmainnnn", result);
//                   if (result.data.statusDescription.statusCode == 200) {
//                     setOpen(false);
//                     // await setsenderId();
//                     // await setMST("");
//                     formik.handleReset();
//                     setValue();
//                     setCamapaignDropdown(!CamapaignDropdown);
//                     dispatch(setCampaignState(!CamapaignDropdown));
//                     setRadioGroupValues("");
//                     dispatch(actionid("-1"));
//                     //   dispatch(actionid("-1"));
//                     history.replace("/dashboard/CampaignControl");
//                     // dispatch(setDropDown(!true));
//                     // setOnchangeRadio(null)
//                     // formik.values.textarea==""
//                     // alert("200");
//                     // toast.success(result.data.statusDescription.statusMessage, {
//                     //   theme: "colored",
//                     //   toastId: customId1,
//                     // });
//                     Swal.fire({
//                       icon: "success",
//                       //  title: "Oops...",
//                       text: result.data.statusDescription.statusMessage,
//                       // footer: '<a href="">Why do I have this issue?</a>'
//                     });
//                     // history.replace("/dashboard/Smsdelivery");
//                     // setTargettedArray(result?.data?.responseObject);
//                   } else {
//                     setOpen(false);
//                     // toast.error(result.data.statusDescription.statusMessage, {
//                     //   toastId: customId1,
//                     //   theme: "colored",
//                     // });
//                     Swal.fire({
//                       icon: "error",
//                       title: "Oops...",
//                       text: result.data.statusDescription.statusMessage,
//                       // footer: '<a href="">Why do I have this issue?</a>'
//                     });
//                   }
//                 } catch (error) {
//                   // alert("catch block");
//                   setOpen(false);

//                   // console.log(error);
//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: "Please Check Your Network",
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } else {
//                 setOpen(false);
//                 // toast.error("Keyword is Blocked", {
//                 //   toastId: customId1,
//                 //   theme: "colored",
//                 // });
//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: result.data.statusDescription.statusdescription,
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//               // setValueResponse(result.data.value)
//             } else if (result.data.statusDescription.statusCode == 204) {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//           } catch (error) {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: "Please Check Your Network",
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } else if (
//           (radiobutton == "2" && RadioGroupValues == 2) ||
//           RadioGroupValues == "on"
//           // expandedinter === "panel2"
//         ) {
//           // alert("select 2");
//           setshowradioerror(false);
//           try {
//             setOpen(true);

//             const result = await common_axios.post(
//               `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
//               // {
//               //   msisdn: "",
//               //   msisdn_code: "",
//               //   numberTypeB: "",
//               //   numberTypeA: "",
//               //   message: values.textarea1,
//               // }
//               {
//                 keywordRequest: {
//                   keyword: values.textarea1,
//                 },
//               }
//               // `http://192.168.167.66:4900/user/phone-books/v1/list`
//             );
//             if (result.data.statusDescription.statusCode == 200) {
//               setOpen(false);

//               if (result.data) {
//                 try {
//                   setOpen(true);
//                   // alert("working");
//                   const result = await common_axios.post(
//                     `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign`,
//                     {
//                       campaignName: values.campaignname,
//                       senderId: senderId.senderId,
//                       channel: "web",
//                       route: "quyeru",
//                       templateId: MST == null ? "" : MST?.id,
//                       language: lang,
//                       templateMessage: values.textarea1,
//                       smsType: MSG,
//                       unicode: LangId == 1 ? "0" : "1",
//                       message: values.textarea1,
//                       campaignType: "Individual",
//                       // manualMsisdnArray: values.textarea,
//                       campaignSource: "own_numbers_phoneBook",
//                       phoneBookId: Bulkselector,
//                       isRoleOver:checked,

//                     }
//                   );
//                   // console.log("resultttttmainnnn", result);
//                   if (result.data.statusDescription.statusCode == 200) {
//                     setOpen(false);
//                     // alert("ok");
//                     formik.handleReset();
//                     setCamapaignDropdown(!CamapaignDropdown);
//                     dispatch(setCampaignState(!CamapaignDropdown));
//                     dispatch(actionid("-1"));
//                     history.replace("/dashboard/CampaignControl");
//                     Swal.fire({
//                       icon: "success",
//                       //  title: "Oops...",
//                       text: result.data.statusDescription.statusMessage,
//                       // footer: '<a href="">Why do I have this issue?</a>'
//                     });
//                     // history.replace("/dashboard/Smsdelivery");
//                     // setTargettedArray(result?.data?.responseObject);
//                   } else {
//                     setOpen(false);
//                     Swal.fire({
//                       icon: "error",
//                       title: "Oops...",
//                       text: result.data.statusDescription.statusMessage,
//                       // footer: '<a href="">Why do I have this issue?</a>'
//                     });
//                   }
//                 } catch (error) {
//                   setOpen(false);
//                   // });
//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: "Please Check Your Network",
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } else {
//                 // toast.error("Keyword is Blocked", {
//                 //   toastId: customId1,
//                 //   theme: "colored",
//                 // });
//                 // });
//                 setOpen(false);
//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: result.data.statusDescription.statusdescription,
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//               // setValueResponse(result.data.value)
//             } else if (result.data.statusDescription.statusCode == 204) {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//           } catch (error) {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: "Please Check Your Network",
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } else if (
//           (radiobutton == "2" || radiobutton == undefined) &&
//           RadioGroupValues == 3
//         ) {
//           // alert("select 3");
//           setshowradioerror(false);
//           try {
//             setOpen(true);

//             const result = await common_axios.post(
//               `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
//               // `http://192.168.167.66:4900/user/phone-books/v1/list`
//               {
//                 keywordRequest: {
//                   keyword: values.textarea1,
//                 },
//               }
//             );
//             if (result.data.statusDescription.statusCode == 200) {
//               setOpen(false);

//               if (result.data) {
//                 try {
//                   setOpen(true);
//                   // alert("working");
//                   const result = await common_axios.post(
//                     `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign`,
//                     {
//                       campaignName: values.campaignname,
//                       senderId: senderId.senderId,
//                       channel: "web",
//                       route: "quyeru",
//                       templateId: MST == null ? "" : MST?.id,
//                       language: lang,
//                       templateMessage: values.textarea1,
//                       smsType: MSG,
//                       unicode: LangId == 1 ? "0" : "1",
//                       message: values.textarea1,
//                       campaignType: "Individual",
//                       // manualMsisdnArray: values.textarea,
//                       campaignSource: "own_numbers_bulkPhoneBook",
//                       bulkPhoneBookId: Bulkselector1,
//                       isRoleOver:checked,

//                     }
//                   );
//                   // console.log("resultttttmainnnn", result);
//                   if (result.data.statusDescription.statusCode == 200) {
//                     setOpen(false);
//                     // alert("ok");
//                     formik.handleReset();
//                     setCamapaignDropdown(!CamapaignDropdown);
//                     dispatch(setCampaignState(!CamapaignDropdown));
//                     dispatch(setDropDown(!true));
//                     await dispatch(actionid("-1"));
//                     history.replace("/dashboard/CampaignControl");

//                     Swal.fire({
//                       icon: "success",
//                       //  title: "Oops...",
//                       text: result.data.statusDescription.statusMessage,
//                       // footer: '<a href="">Why do I have this issue?</a>'
//                     });

//                     // history.replace("/dashboard/Smsdelivery");
//                     // setTargettedArray(result?.data?.responseObject);
//                   } else {
//                     setOpen(false);
//                     Swal.fire({
//                       icon: "error",
//                       title: "Oops...",
//                       text: result.data.statusDescription.statusMessage,
//                       // footer: '<a href="">Why do I have this issue?</a>'
//                     });
//                     // toast.error(result.data.statusDescription.statusMessage, {
//                     //   theme: "colored",
//                     //   toastId: customId1,
//                     // });
//                   }
//                 } catch (error) {
//                   setOpen(false);

//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: "Please Check Your Network",
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } else {
//                 setOpen(false);
//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: result.data.statusDescription.statusdescription,
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//               // setValueResponse(result.data.value)
//             } else if (result.data.statusDescription.statusCode == 204) {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//           } catch (error) {
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: "Please Check Your Network",
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } else if (
//           (radiobutton == "1" || radiobutton == undefined) &&
//           RadioGroupValues == 4
//           //   ||
//           // RadioGroupValues
//         ) {
//           // alert("select 4");
//           setshowradioerror(false);
//         } else if (
//           radiobutton == "1" ||
//           (radiobutton == undefined && RadioGroupValues == "")
//         ) {
//           // alert("choose numbers ");
//           setshowradioerror(true);
//           setexpanded(false);
//           setexpanded1(true);
//         }
//         // else {
//         //   // alert("choose numbers ");
//         //   setshowradioerror(true);
//         //   setexpanded(false);
//         //   setexpanded1(true);
//         // }
//         else if (radiobutton == "4") {
//           // alert("radio 3");
//           setshowradioerror(false);
//           setRadioGroupValues("");
//           try {
//             setOpen(true);

//             const result = await common_axios.post(
//               `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
//               {
//                 keywordRequest: {
//                   keyword: values.textarea1,
//                 },
//               }
//               // `http://192.168.167.66:4900/user/phone-books/v1/list`
//             );
//             if (result.data.statusDescription.statusCode == 200) {
//               setOpen(false);
//               if (result.data) {
//                 try {
//                   setOpen(true);
//                   const formData = new FormData();
//                   // formData.append("contactListFile", FilesImage);
//                   // console.log("rr", formData);

//                   // formData.append("contactList", FilesImage);
//                   state?.files?.map((file) => {
//                     formData.append("contactList", file);
//                   });
//                   formData.append("campaignName", values.campaignname);
//                   formData.append("senderId", senderId.senderId);
//                   formData.append("channel", "web");
//                   formData.append("route", "quyeru");
//                   formData.append("templateId", MST == null ? "" : MST?.id);
//                   formData.append("templateMessage", values.textarea1);
//                   formData.append("smsType", MSG);
//                   formData.append("unicode", LangId == 1 ? "0" : "1");
//                   // unicode: LangId ==1 ? "0" : "1",

//                   formData.append("language", lang);
//                   formData.append("message", values.textarea1);
//                   formData.append("campaignType", "Individual");
//                   formData.append("isRoleOver", checked);

//                   formData.append("campaignSource", "own_numbers_file");

//                   // alert("working");
//                   const result = await common_axios.post(
//                     `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v2/create-campaign/file`,
//                     formData
//                   );
//                   // console.log("resultttttmainnnn", result);
//                   if (result.data.statusDescription.statusCode == 200) {
//                     setOpen(false);
//                     setValue();
//                     // document.getElementById("fileName").value = "";
//                     document.getElementById("formFileLg").value = "";
//                     // setState([]);
//                     formik.handleReset();
//                     setCamapaignDropdown(!CamapaignDropdown);
//                     dispatch(setCampaignState(!CamapaignDropdown));
//                     dispatch(actionid("-1"));
//                     history.replace("/dashboard/CampaignControl");

//                     Swal.fire({
//                       icon: "success",
//                       //  title: "Oops...",
//                       text: result.data.statusDescription.statusMessage,
//                       // footer: '<a href="">Why do I have this issue?</a>'
//                     });
//                     // history.replace("/dashboard/Smsdelivery");
//                     // setTargettedArray(result?.data?.responseObject);
//                   } else {
//                     setOpen(false);
//                     Swal.fire({
//                       icon: "error",
//                       title: "Oops...",
//                       text: result.data.statusDescription.statusMessage,
//                       // footer: '<a href="">Why do I have this issue?</a>'
//                     });
//                   }
//                 } catch (error) {
//                   // console.log("dd", error);
//                   setOpen(false);
//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: "Please Check Your Network",
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } else {
//                 setOpen(false);
//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: result.data.statusDescription.statusdescription,
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//               // setValueResponse(result.data.value)
//             } else if (result.data.statusDescription.statusCode == 204) {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//           } catch (error) {
//             // console.log("ff", error);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: "Please Check Your Network",
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } else if (radiobutton == "3") {
//           //  alert("radio 3");
//           setshowradioerror(false);
//           setRadioGroupValues("");
//           try {
//             setOpen(true);

//             const result = await common_axios.post(
//               `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
//               {
//                 keywordRequest: {
//                   keyword: values.textarea1,
//                 },
//               }
//               // `http://192.168.167.66:4900/user/phone-books/v1/list`
//             );
//             if (result.data.statusDescription.statusCode == 200) {
//               setOpen(false);
//               if (result.data) {
//                 try {
//                   setOpen(true);
//                   // alert("working");
//                   const result = await common_axios.post(
//                     `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign`,
//                     {
//                       campaignName: values.campaignname,
//                       senderId: senderId.senderId,
//                       channel: "web",
//                       route: "quyeru",
//                       templateId: MST == null ? "" : MST?.id,
//                       language: lang,
//                       templateMessage: values.textarea1,
//                       smsType: MSG,
//                       unicode: LangId == 1 ? "0" : "1",
//                       message: values.textarea1,
//                       campaignType: "Individual",
//                       // manualMsisdnArray: values.textarea,
//                       campaignSource: "all_numbers",
//                       userId: Number(localStorage.getItem("UserId")),
//                       isRoleOver:checked,

//                     }
//                   );
//                   // console.log("resultttttmainnnn", result);
//                   if (result.data.statusDescription.statusCode == 200) {
//                     setOpen(false);
//                     setValue();
//                     formik.handleReset();
//                     setCamapaignDropdown(!CamapaignDropdown);
//                     // dispatch(setCampaignState(!CamapaignDropdown));
//                     dispatch(actionid("-1"));
//                     history.replace("/dashboard/CampaignControl");

//                     Swal.fire({
//                       icon: "success",
//                       //  title: "Oops...",
//                       text: result.data.statusDescription.statusMessage,
//                       // footer: '<a href="">Why do I have this issue?</a>'
//                     });
//                     // history.replace("/dashboard/Smsdelivery");
//                     // setTargettedArray(result?.data?.responseObject);
//                   } else {
//                     setOpen(false);
//                     Swal.fire({
//                       icon: "error",
//                       title: "Oops...",
//                       text: result.data.statusDescription.statusMessage,
//                       // footer: '<a href="">Why do I have this issue?</a>'
//                     });
//                   }
//                 } catch (error) {
//                   setOpen(false);

//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: "Please Check Your Network",
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } else {
//                 setOpen(false);
//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: result.data.statusDescription.statusdescription,
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//               // setValueResponse(result.data.value)
//             } else if (result.data.statusDescription.statusCode == 204) {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//           } catch (error) {
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: "Please Check Your Network",
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         }
//       }
//     },
//   });

//   const accordionchange = () => {
//     // if (expanded != undefined) {
//     setexpanded(!expanded);
//     // setexpanded1(!expanded1);
//     // }
//     // await
//   };
//   const accordionchange1 = () => {
//     // if (expanded != undefined) {
//     setexpanded1(!expanded1);
//     // setexpanded(!expanded);
//   };
//   const CallbackSender = (child) => {
//     // console.log(child, "ddeessenedndndrr");
//     setsenderId(child);
//   };
//   const CallbackMessage = (child) => {
//     // console.log(child, "ui");
//     setLanguage(child?.year);
//     setLangId(child?.id);
//     setLang(child?.lang);
//   };
//   const callbackMSG = (child) => {
//     // console.log(child);
//     setMSG(child?.label);
//   };
//   const callbackMSR = (child) => {
//     // console.log(child);
//     setMSR(child?.label);
//   };
//   const callbackMST = async (child) => {
//     // console.log("88776655", child);
//     await setMST(child);

//     // formik.setFieldValue("textarea1", child?.year, false);
//     // setTextarea1(child?.year);
//   };
//   const callbackTarget = (child) => {
//     // console.log("targetted value", child);
//     setTarget(child);
//   };
//   const callbackBulkSelector = (child) => {
//     // console.log("parentcallfkhfsbjsb", child);
//     setBulkselector(child);
//   };
//   // console.log("nhh", Bulkselector);
//   const callbackBulkSelector1 = (child) => {
//     // console.log("callbackSchedule1", child);
//     setBulkselector1(child);
//   };
//   const callbackSchedule = (child) => {
//     setscheduleTime(child?.slice("11", "16"));
//     setscheduleDate(child?.slice("0", "10"));
//     // setTarget(child);
//   };
//   const callbackRadio = (child) => {
//     setradiobutton(child);
//   };

//   useEffect(() => {
//     setFilesImage(null);
//   }, [radiobutton]);

//   useEffect(() => {
//     setBulkselector([]);
//     setBulkselector1([]);
//   }, [radiobutton]);

//   const handleChangeRadio = (e) => {
//     if (e.target.checked == true) {
//       setRadioGroupValues(e.target.value);
//     }

//     // setFilesImage(null)
//   };

//   const getImage = (e, index) => {
//     let img = e.target.files;
//     // console.log("imp--", img);
//     let temp = [];

//     for (let i = 0; i < img.length; i++) {
//       temp.push(img[i]);
//     }
//     const allowedExtensions = [".csv", ".txt"];
//     if (img?.length < 6) {
//       for (let j = 0; j < img.length; j++) {
//         const file = img[j];
//         const fileExtension = file.name.split(".").pop();

//         if (!allowedExtensions.includes(`.${fileExtension}`)) {
//           // Handle invalid file extension
//           // console.log(`Invalid file extension: ${file.name}`);
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Csv and txt files are allowed!",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });

//           document.getElementById("fileName").value = "";

//           return;
//         } else {
//           setFilesImage(temp);
//         }
//       }
//     } else {
//       setFilesImage(null);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "You can only upload upto 5 files!",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };

//   // };

//   const gettemplate = async () => {
//     try {
//       setHideSkeleton(true);
//       // alert("working");
//       const res1 = await common_axios.get(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/admin/templates/status`
//       );
//       // console.log("resultttttaaa", res1);
//       if (res1.data.statusDescription.statusCode == 200) {
//         setHideSkeleton(false);
//         // alert("ok");
//         // toast.success("api hitted");
//         setTemplateArray(res1?.data?.listOfTemplates);
//       } else {
//         setHideSkeleton(false);
//         // toast.error(res1.data.statusDescription.statusMessage, {
//         //   theme: "colored",
//         // });
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res1.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       setHideSkeleton(false);

//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };

//   const scheduleapi = async (e) => {
//     e.preventDefault();
//     // alert("shedule is working");

//     if (checkicon == false) {
//       // alert("enter");
//       // setexpanded(true);
//     } else {
//       if (radiobutton == "1" || radiobutton == undefined) {
//         // alert("select 1");
//         setshowradioerror(false);
//         try {
//           setOpen(true);

//           const result = await common_axios.post(
//             `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,

//             {
//               keywordRequest: {
//                 keyword: formik.values.textarea1,
//               },
//             }
//           );
//           if (result.data.statusDescription.statusCode == 200) {
//             setOpen(false);

//             if (result.data) {
//               try {
//                 setOpen(true);
//                 // alert("working");
//                 const result = await common_axios.post(
//                   `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/schedule-campaign`,
//                   {
//                     campaignName: formik.values.campaignname,
//                     senderId: senderId.senderId,
//                     channel: "web",
//                     route: "quyeru",
//                     templateId: MST == null ? "" : MST?.id,
//                     templateMessage: formik.values.textarea1,
//                     smsType: MSG,
//                     unicode: LangId == 1 ? "0" : "1",
//                     message: formik.values.textarea1,
//                     language: lang,
//                     // campaignType: "Individual",
//                     campaignType: checkedRecurring == true ? "Recurring Campaign" : "Individual",
//                     // manualMsisdnArray: formik.values.textarea,
//                     manualMsisdnArray: mobileNumbers,
//                     campaignSource: "own_numbers_manual",
//                     scheduledDatetime: moment(value)?.format(
//                       "YYYY-MM-DD HH:mm:ss"
//                     ),
//                     reccuringType: statusDropDown,
//                     isRoleOver: checked,
//                   }
//                 );
//                 // console.log("resultttttmainnnn", result);
//                 if (result.data.statusDescription.statusCode == 200) {
//                   setOpen(false);
//                   // alert("ok");
//                   formik.handleReset();
//                   setCamapaignDropdown(!CamapaignDropdown);
//                   dispatch(setCampaignState(!CamapaignDropdown));
//                   // dispatch(setDropDown(!true));

//                   Swal.fire({
//                     icon: "success",
//                     //  title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                   dispatch(actionid("1"));
//                   history.replace("/dashboard/CampaignControl");
//                   // setTargettedArray(result?.data?.responseObject);
//                 } else {
//                   setOpen(false);

//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } catch (error) {
//                 setOpen(false);

//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: "Please Check Your Network",
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//             // setValueResponse(result.data.value)
//           } else if (result.data.statusDescription.statusCode == 204) {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           } else {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } catch (error) {
//           setOpen(false);

//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Please Check Your Network",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       } else if (
//         (radiobutton == "2" && RadioGroupValues == 2) ||
//         RadioGroupValues == "on"
//         // expandedinter === "panel2"
//       ) {
//         // alert("select 2");
//         setshowradioerror(false);
//         try {
//           setOpen(true);

//           const result = await common_axios.post(
//             `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
//             {
//               keywordRequest: {
//                 keyword: formik.values.textarea1,
//               },
//             }
//           );
//           if (result.data.statusDescription.statusCode == 200) {
//             setOpen(false);

//             if (result.data) {
//               try {
//                 setOpen(true);
//                 // alert("working");
//                 const result = await common_axios.post(
//                   `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/schedule-campaign`,
//                   {
//                     campaignName: formik.values.campaignname,
//                     senderId: senderId.senderId,
//                     channel: "web",
//                     route: "quyeru",
//                     templateId: MST == null ? "" : MST?.id,
//                     templateMessage: formik.values.textarea1,
//                     smsType: MSG,
//                     unicode: LangId == 1 ? "0" : "1",
//                     language: lang,
//                     message: formik.values.textarea1,
//                     campaignType: "Individual",
//                     campaignSource: "own_numbers_phoneBook",
//                     phoneBookId: Bulkselector,
//                     scheduledDatetime: moment(value)?.format(
//                       "YYYY-MM-DD HH:mm:ss"
//                     ),
//                     reccuringType: statusDropDown,
//                     isRoleOver: checked,
//                   }
//                 );
//                 if (result.data.statusDescription.statusCode == 200) {
//                   setOpen(false);
//                   formik.handleReset();
//                   setCamapaignDropdown(!CamapaignDropdown);
//                   dispatch(setCampaignState(!CamapaignDropdown));
//                   dispatch(actionid("1"));
//                   history.replace("/dashboard/CampaignControl");
//                   Swal.fire({
//                     icon: "success",
//                     //  title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 } else {
//                   setOpen(false);
//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } catch (error) {
//                 setOpen(false);

//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: "Please Check Your Network",
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//             // setValueResponse(result.data.value)
//           } else if (result.data.statusDescription.statusCode == 204) {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           } else {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } catch (error) {
//           setOpen(false);
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Please Check Your Network",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       } else if (
//         (radiobutton == "2" || radiobutton == undefined) &&
//         RadioGroupValues == 3
//       ) {
//         // alert("select 3");
//         setshowradioerror(false);
//         try {
//           setOpen(true);

//           const result = await common_axios.post(
//             `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
//             {
//               keywordRequest: {
//                 keyword: formik.values.textarea1,
//               },
//             }
//           );
//           if (result.data.statusDescription.statusCode == 200) {
//             setOpen(false);

//             if (result.data) {
//               try {
//                 setOpen(true);
//                 // alert("working");
//                 const result = await common_axios.post(
//                   `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/schedule-campaign`,
//                   {
//                     campaignName: formik.values.campaignname,
//                     senderId: senderId.senderId,
//                     channel: "web",
//                     route: "quyeru",
//                     templateId: MST == null ? "" : MST?.id,
//                     language: lang,
//                     templateMessage: formik.values.textarea1,
//                     smsType: MSG,
//                     unicode: LangId == 1 ? "0" : "1",
//                     message: formik.values.textarea1,
//                     campaignType: "Individual",
//                     campaignSource: "own_numbers_bulkPhoneBook",
//                     bulkPhoneBookId: Bulkselector1,
//                     scheduledDatetime: moment(value)?.format(
//                       "YYYY-MM-DD HH:mm:ss"
//                     ),
//                     reccuringType: statusDropDown,
//                     isRoleOver: checked,
//                   }
//                 );
//                 // console.log("resultttttmainnnn", result);
//                 if (result.data.statusDescription.statusCode == 200) {
//                   setOpen(false);
//                   formik.handleReset();
//                   setCamapaignDropdown(!CamapaignDropdown);
//                   dispatch(setCampaignState(!CamapaignDropdown));
//                   dispatch(actionid("1"));
//                   history.replace("/dashboard/CampaignControl");
//                   // dispatch(setDropDown(!true));
//                   // alert("ok");
//                   Swal.fire({
//                     icon: "success",
//                     //  title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 } else {
//                   setOpen(false);
//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } catch (error) {
//                 setOpen(false);
//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: "Please Check Your Network",
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//           } else if (result.data.statusDescription.statusCode == 204) {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           } else {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } catch (error) {
//           setOpen(false);
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Please Check Your Network",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       } else if (
//         (radiobutton == "1" || radiobutton == undefined) &&
//         RadioGroupValues == 4
//         //   ||
//         // RadioGroupValues
//       ) {
//         // alert("select 4");
//         setshowradioerror(false);
//       } else if (
//         radiobutton == "1" ||
//         (radiobutton == undefined && RadioGroupValues == "")
//       ) {
//         // alert("choose numbers ");
//         setshowradioerror(true);
//         setexpanded(false);
//         setexpanded1(true);
//       }
//       // else {
//       //   // alert("choose numbers ");
//       //   setshowradioerror(true);
//       //   setexpanded(false);
//       //   setexpanded1(true);
//       // }
//       else if (radiobutton == "4") {
//         // alert("radio 3");
//         setshowradioerror(false);
//         setRadioGroupValues("");
//         try {
//           setOpen(true);

//           const result = await common_axios.post(
//             `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
//             {
//               keywordRequest: {
//                 keyword: formik.values.textarea1,
//               },
//             }
//             // `http://192.168.167.66:4900/user/phone-books/v1/list`
//           );
//           if (result.data.statusDescription.statusCode == 200) {
//             setOpen(false);

//             if (result.data) {
//               try {
//                 setOpen(true);
//                 const formData = new FormData();
//                 // formData.append("contactListFile", FilesImage);
//                 // console.log("rr", formData);
//                 // formData.append("contactList", FilesImage);
//                 state?.files.map((file) => {
//                   formData.append("contactList", file);
//                 });

//                 formData.append("campaignName", formik.values.campaignname);
//                 formData.append("senderId", senderId.senderId);
//                 formData.append("channel", "web");
//                 formData.append("route", "quyeru");
//                 formData.append("templateId", MST == null ? "" : MST?.id);
//                 formData.append("templateMessage", formik.values.textarea1);
//                 formData.append("smsType", MSG);
//                 formData.append("unicode", LangId == 1 ? "0" : "1");
//                 // unicode: LangId ==1 ? "0" : "1",
//                 formData.append("language", lang);
//                 formData.append("message", formik.values.textarea1);
//                 // formData.append("campaignType", "Individual");
//                 formData.append("campaignType", checkedRecurring == true ? "Recurring Campaign" : "Individual",);

//                 formData.append("campaignSource", "own_numbers_file");
//                 formData.append("isRoleOver", checked);
//                 formData.append("reccuringType", statusDropDown);
//                 formData.append(
//                   // "scheduledDatetime",
//                   // // new Date().toJSON().slice(0, 16)
//                   // moment(new Date())?.format("YYYY-MM-DD hh:mm:ss")
//                   "scheduledDatetime",
//                   moment(value)?.format("YYYY-MM-DD HH:mm:ss")
//                 );
//                 // scheduledDatetime: moment(value?.$d)?.format(
//                 //   "YYYY-MM-DD HH:mm:ss"
//                 // ),
//                 // alert("working");
//                 const result = await common_axios.post(
//                   `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v2/schedule-campaign/file`,
//                   formData
//                 );
//                 // console.log("resultttttmainnnn", result);
//                 if (result.data.statusDescription.statusCode == 200) {
//                   setOpen(false);
//                   // document.getElementById("fileName").value = "";
//                   document.getElementById("formFileLg").value = "";
//                   formik.handleReset();
//                   setCamapaignDropdown(!CamapaignDropdown);
//                   dispatch(setCampaignState(!CamapaignDropdown));
//                   dispatch(actionid("1"));
//                   history.replace("/dashboard/CampaignControl");
//                   Swal.fire({
//                     icon: "success",
//                     //  title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                   // history.replace("/dashboard/Smsdelivery");
//                   // setTargettedArray(result?.data?.responseObject);
//                 } else {
//                   setOpen(false);
//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } catch (error) {
//                 setOpen(false);

//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: "Please Check Your Network",
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//             // setValueResponse(result.data.value)
//           } else if (result.data.statusDescription.statusCode == 204) {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           } else {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } catch (error) {
//           setOpen(false);

//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Please Check Your Network",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       } else if (radiobutton == "3") {
//         //  alert("radio 3");
//         setshowradioerror(false);
//         setRadioGroupValues("");
//         try {
//           setOpen(true);

//           const result = await common_axios.post(
//             `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
//             {
//               keywordRequest: {
//                 keyword: formik.values.textarea1,
//               },
//             }
//             // `http://192.168.167.66:4900/user/phone-books/v1/list`
//           );
//           if (result.data.statusDescription.statusCode == 200) {
//             setOpen(false);
//             if (result.data) {
//               try {
//                 setOpen(true);
//                 // alert("working");
//                 const result = await common_axios.post(
//                   `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/schedule-campaign/file`,
//                   {
//                     campaignName: formik.values.campaignname,
//                     senderId: senderId.senderId,
//                     channel: "web",
//                     route: "quyeru",
//                     templateId: MST == null ? "" : MST?.id,
//                     language: lang,
//                     templateMessage: formik.values.textarea1,
//                     smsType: MSG,
//                     unicode: LangId == 1 ? "0" : "1",
//                     message: formik.values.textarea1,
//                     campaignType: "Individual",
//                     // manualMsisdnArray: values.textarea,
//                     campaignSource: "all_numbers",
//                     userId: Number(localStorage.getItem("UserId")),
//                     reccuringType: statusDropDown,
//                     isRoleOver: checked,
//                   }
//                 );
//                 // console.log("resultttttmainnnn", result);
//                 if (result.data.statusDescription.statusCode == 200) {
//                   setOpen(false);
//                   setValue();
//                   formik.handleReset();
//                   setCamapaignDropdown(!CamapaignDropdown);
//                   // dispatch(setCampaignState(!CamapaignDropdown));
//                   dispatch(actionid("-1"));
//                   history.replace("/dashboard/CampaignControl");

//                   Swal.fire({
//                     icon: "success",
//                     //  title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                   // history.replace("/dashboard/Smsdelivery");
//                   // setTargettedArray(result?.data?.responseObject);
//                 } else {
//                   setOpen(false);
//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } catch (error) {
//                 setOpen(false);

//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: "Please Check Your Network",
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//             // setValueResponse(result.data.value)
//           } else if (result.data.statusDescription.statusCode == 204) {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           } else {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } catch (error) {
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Please Check Your Network",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       }
//     }
//   };

//   const TestCampaign = async (e) => {
//     cuttt?.current?.click();
//     e.preventDefault();
//     try {
//       // setOpen(true);
//       // if (result.data.statusDescription.statusCode == 200) {
//       //   setOpen(false);
//       //   // alert("ok");
//       //   cuttt?.current?.click();
//       //   toast.success("Campaign Tested Successfully", {
//       //     theme: "colored",
//       //   });
//       //   // setshowsendnow(true);
//       //   // setshowtextsuccessofschedule(true);
//       //   // history.replace("/dashboard/ViewVoiceCampaigns");
//       //   // setTargettedArray(result?.data?.responseObject);
//       // } else {
//       //   setOpen(false);
//       //   toast.error(result.data.statusDescription.statusMessage, {
//       //     theme: "colored",
//       //   });
//       //   cuttt?.current?.click();
//       // }
//     } catch (error) {
//       // alert("catch block");
//       cuttt?.current?.click();
//       setOpen(false);
//       // console.log(error);
//     }
//   };

//   React.useEffect(() => {
//     // getdetails();
//     // gettemplate();
//   }, []);

//   useEffect(() => {
//     if (MST == undefined) {
//       setTextareadisabled(false);
//       formik.setFieldValue("textarea1", "", false);
//     } else if (MST == null) {
//       setMST("");
//     } else {
//       setTextareadisabled(true);
//       formik.setFieldValue("textarea1", MST?.year, false);
//     }
//   }, [MST]);

//   useEffect(() => {
//     if (RadioGroupValues == 1) {
//       setRadiosdisabled({
//         textarea: false,
//         bulk: true,
//         bulk1: true,
//         choose: true,
//       });
//       setshowradioerror(false);
//     } else if (RadioGroupValues == 2) {
//       setRadiosdisabled({
//         textarea: true,
//         bulk: false,
//         bulk1: true,
//         choose: true,
//       });
//       setshowradioerror(false);
//     } else if (RadioGroupValues == 3) {
//       setRadiosdisabled({
//         textarea: true,
//         bulk: true,
//         bulk1: false,
//         choose: true,
//       });
//       setshowradioerror(false);
//     } else if (RadioGroupValues == 4) {
//       setRadiosdisabled({
//         textarea: true,
//         bulk: true,
//         bulk1: true,
//         choose: false,
//       });
//       setshowradioerror(false);
//     }
//   }, [RadioGroupValues]);
//   useEffect(() => {
//     if (Radiosdisabled.choose == true) {
//       setshowchoosevalue(true);
//     } else {
//       setshowchoosevalue(false);
//     }
//   }, [Radiosdisabled]);

//   useEffect(() => {
//     if (Radiosdisabled.textarea == true) {
//       // alert("run");
//       setTextarea("");
//       formik.setFieldValue("textarea", "", false);
//     }
//   }, [Radiosdisabled]);

//   useEffect(() => {
//     if (radiobutton != "1") {
//       setRadiosdisabled({
//         textarea: true,
//         bulk: true,
//         bulk1: true,
//         choose: true,
//       });
//       setRadioGroupValues("");
//     }
//   }, [radiobutton]);

//   // useEffect(() => {
//   //   document?.getElementById("area")?.addEventListener("input", function (e) {
//   //     var valueeee = e.target.value;
//   //     var valueeee = valueeee
//   //       ?.replace(/\D/g, "")
//   //       // const regex = /^[0-9\,]+$/;
//   //       const regex =  /^[0-9,]+$/;
//   //     formik.setFieldValue("textarea", valueeee[0], false);
//   //   });
//   // }, [RadioGroupValues]);

//   useEffect(() => {
//     if (
//       formik.values.textarea1 == "" ||
//       formik.values.campaignname == "" ||
//       senderId == undefined ||
//       MSG == undefined ||
//       LangId == undefined
//     ) {
//       // alert("runnerrr");
//       setcheckicon(false);
//       setdisableNext(true);
//     } else {
//       setcheckicon(true);
//       setdisableNext(false);
//     }
//   }, [
//     senderId,
//     MSG,
//     MSR,
//     Language,
//     formik.values.textarea1,
//     formik.values.campaignname,
//   ]);

//   useEffect(() => {
//     if (
//       (radiobutton === "1" || radiobutton == undefined) &&
//       (Bulkselector != undefined ||
//         Bulkselector1 != undefined ||
//         formik.values.textarea != "" ||
//         FilesImage != null)
//     ) {
//       // alert("runnner");
//       setcheckicon1(true);

//       setdisableNext1(false);
//     } else if (radiobutton === "3") {
//       // alert("runnner   3");
//       setcheckicon1(true);
//       setdisableNext1(false);
//     } else {
//       // alert("runnner else");
//       setcheckicon1(false);
//       setdisableNext1(true);
//     }
//   }, [
//     radiobutton,
//     Bulkselector1,
//     Bulkselector,
//     formik.values.textarea,
//     FilesImage,
//     Target,
//   ]);

//   useEffect(() => {
//     if (checkicon == true && checkicon1 == true) {
//       setpairdisable(false);
//     } else {
//       setpairdisable(true);
//     }
//     //  else if (showtextsuccessofschedule == true) {
//     //   setpairdisable(true);
//     // }
//   }, [checkicon1, checkicon]);
//   // .......................................Phonebook API.................................//

//   async function PhonebookGet(values) {
//     try {
//       setHideSkeleton(true);
//       let res = await common_axios.get(
//         `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/bulk-group/get/phone-book/list`
//       );
//       if (res.data.statusdescription.statusCode == 200) {
//         setHideSkeleton(false);
//         const mapp = res.data.listOfPlaysmsPhonebook.map(
//           (x) => x.phonebookDescription
//         );
//         if (!mapp.includes("Default")) {
//           const obj = {
//             id: 1,
//             phonebookName: "Default",
//           };
//           res.data.listOfPlaysmsPhonebook.push(obj);
//         }
//         SetContactArray(res.data.listOfPlaysmsPhonebook);
//       } else {
//         // setOpen(false);
//         setHideSkeleton(false);
//         // toast.error(res.data.statusdescription.statusDescription, {
//         //   toastId: customId1,
//         //   theme: "colored",
//         // });

//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusdescription.statusDescription,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       // setOpen(false);
//       setHideSkeleton(false);

//       // toast.error("Please Check Your Network", {
//       //   toastId: customId1,
//       //   theme: "colored",
//       // });
//     }
//   }
//   useEffect(() => {
//     PhonebookGet();
//   }, []);
//   // .....................................................................................//
//   // .....................................Bulk Group Get................................//
//   async function BulkGroupGet(values) {
//     try {
//       const result = await common_axios.get(
//         `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/get-bulk-group`,
//         {}
//         // `http://192.168.167.66:4900/user/phone-books/v1/list`
//       );
//       if (result.data.statusdescription.statusCode == 200) {
//         setHideSkeleton(false);
//         const mapp = result.data.playsmsGroupPhonebooks.map(
//           (x) => x.bulkGroupDescription
//         );
//         if (!mapp.includes("Default")) {
//           const obj = {
//             id: 1,
//             bulkGroupName: "Default",
//           };
//           result.data.playsmsGroupPhonebooks.push(obj);
//         }
//         setData(result.data.playsmsGroupPhonebooks);

//         // toast.success("Keyword deleted successfully!!", {
//         //   theme: "colored",
//         // });
//       } else {
//         setOpen(false);
//         // toast.error(result.data.statusdescription.statusDescription,{
//         //   toastId: customId1,
//         // });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   }
//   // ........................................................................................//
//   // .......................Keyword check api..............................................//
//   async function LanguageGet(values) {
//     try {
//       const result = await common_axios.get(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/language`
//         // `http://192.168.167.66:4900/user/phone-books/v1/list`
//       );
//       if (result.data.statusDescription.statusCode == 200) {
//         setLanguageData(result.data.languages);
//       } else {
//         setOpen(false);
//         // toast.error(result.data.statusdescription.statusDescription,{
//         //   toastId: customId1,
//         // });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   }

//   useEffect(() => {
//     BulkGroupGet();
//     LanguageGet();
//   }, []);
//   // useEffect(() => {
//   //   let temp_arr = [];
//   //   if (LangId != undefined) {
//   //     for (let i = 0; i < LanguageData.length; i++) {
//   //       if (LangId == LanguageData[i]?.id) {
//   //         let x = LanguageData[i].templateModel;
//   //         for (let j = 0; j < x.length; j++) {
//   //           temp_arr.push(x[j]);
//   //         }
//   //       }
//   //     }

//   //     console.log("lkk", temp_arr);
//   //     setTemplateArray(temp_arr);
//   //   }
//   // }, [LangId]);

//   async function TemplateLanguageData(values) {
//     try {
//       setHideSkeleton(true);

//       const result = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v2/admin/templates/status`,
//         // `http://192.168.167.66:4900/user/phone-books/v1/list`
//         {
//           language: LangId,
//         }
//       );
//       if (result.data.statusDescription.statusCode == 200) {
//         setHideSkeleton(false);

//         setTemplateArray(result.data.listOfTemplates);
//         // setLanguageData(result.data.languages);
//       } else {
//         // alert("hii");
//         setTemplateArray([]);

//         setHideSkeleton(false);
//         // toast.error(result.data.statusDescription.statusMessage,{
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       setHideSkeleton(false);

//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   }
//   useEffect(() => {
//     if (LangId != undefined) {
//       TemplateLanguageData();
//     }
//   }, [LangId]);

//   // .................10 digit Phone number...........................//
//   // console.log("first", mobileNumbers);
//   const [showErrorMsg, setShowErrorMsg] = useState(false);
//   const handleChange10 = (event) => {
//     let inputValue = event.target.value;
//     if (inputValue.length < mobileNumbers.length) {
//       // If a character was deleted
//       const lastChar = mobileNumbers.charAt(mobileNumbers.length - 1);
//       if (
//         lastChar === "," &&
//         inputValue.charAt(inputValue.length - 1) !== ","
//       ) {
//         // If the last character was a comma and the new value doesn't end with a comma
//         inputValue = mobileNumbers.slice(0, -1); // Remove the comma
//       }
//     } else {
//       // If a character was added
//       inputValue = inputValue.replace(/[^0-9]/g, ""); // Remove all non-numeric characters
//       inputValue = inputValue.replace(/(\d{11})/g, "$1,"); // Add a comma after every 10 digits
//     }
//     setMobileNumbers(inputValue);
//   };

//   React.useEffect(() => {
//     let field = mobileNumbers?.split(",")?.map((arg) => {
//       return arg.length == 11;
//     });

//     setDisableMobileNumber(field.splice(-1));
//     // if (
//     //   mobileNumbers?.split(",")?.length > 10 ||
//     //   mobileNumbers?.split(",")?.length == 0
//     // ) {
//     //   setShowErrorMsg(false);
//     // } else {
//     //   setShowErrorMsg(true);
//     // }
//   }, [mobileNumbers]);

//   // ...........................................................................................//
//   const UploadFiles = (e) => {
//     let fileArray = Array.from(e.target.files);
//     let arrr = state.files?.length > 0 ? [...state.files] : [];
//     for (let index = 0; index < fileArray.length; index++) {
//       const element = fileArray[index];
//       arrr.push(element);
//     }

//     arrr.concat(Array.from(e.target.files));
//     setState({
//       files: arrr,
//     });

//     let img = e.target.files;
//     // console.log("imp--", img);
//     let temp = [];

//     for (let i = 0; i < img.length; i++) {
//       temp.push(img[i]);
//     }
//     const allowedExtensions = [".csv", ".txt"];
//     if (img?.length < 6) {
//       for (let j = 0; j < img.length; j++) {
//         const file = img[j];
//         const fileExtension = file.name.split(".").pop();

//         if (!allowedExtensions.includes(`.${fileExtension}`)) {
//           // Handle invalid file extension
//           // console.log(`Invalid file extension: ${file.name}`);
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Csv and txt files are allowed!",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });

//           document.getElementById("formFileLg").value = "";
//           setState({
//             files: [],
//           });

//           return;
//         } else {
//           // setFilesImage(temp);
//         }
//       }
//     } else {
//       // setFilesImage(null);
//       document.getElementById("formFileLg").value = "";
//       setState({
//         files: [],
//       });
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "You can only upload upto 5 files!",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };

// // ........................CreateCampaignApi..........................//

//   const CreateCampaignApi = async () => {
//     // alert("kk")
//     // e.preventDefault();
//     // alert("shedule is working");

//     if (checkicon == false) {
//       // alert("enter");
//       // setexpanded(true);
//     } else {
//       if (radiobutton == "1" || radiobutton == undefined) {
//         // alert("select 1");
//         setshowradioerror(false);
//         try {
//           setOpen(true);

//           const result = await common_axios.post(
//             `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,

//             {
//               keywordRequest: {
//                 keyword: formik.values.textarea1,
//               },
//             }
//           );
//           if (result.data.statusDescription.statusCode == 200) {
//             setOpen(false);
// // alert("kkkii")
//             if (result.data) {

//               try {

//                 const formData = new FormData();
//                   // formData.append("contactList", "");
//                   state?.files.map((file) => {
//                     formData.append("contactList", "");
//                   });

//                 formData.append("campaignName", formik.values.campaignname);
//                 formData.append("senderId", senderId.senderId);
//                 formData.append("channel", "web");
//                 formData.append("route", "quyeru");
//                 formData.append("templateId", MST == null ? "" : MST?.id);
//                 formData.append("templateMessage", formik.values.textarea1);
//                 formData.append("smsType", MSG);
//                 formData.append("unicode", LangId == 1 ? "0" : "1");
//                 // unicode: LangId ==1 ? "0" : "1",
//                 formData.append("language", lang);
//                 formData.append("message", formik.values.textarea1);
//                 formData.append("campaignType", "Individual");
//                 formData.append("campaignSource", "own_numbers_manual");
//                 formData.append("manualMsisdnArray", mobileNumbers);
//                 formData.append("isRoleOver", checked);

//                 setOpen(true);
//                 // alert("working");
//                 const result = await common_axios.post(
//                   `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign/later`,
//                   formData
//                   // {
//                   //   campaignName: formik.values.campaignname,
//                   //   senderId: senderId.senderId,
//                   //   channel: "web",
//                   //   route: "quyeru",
//                   //   templateId: MST == null ? "" : MST?.id,
//                   //   templateMessage: formik.values.textarea1,
//                   //   smsType: MSG,
//                   //   unicode: LangId == 1 ? "0" : "1",
//                   //   message: formik.values.textarea1,
//                   //   language: lang,
//                   //   campaignType: "Individual",
//                   //   manualMsisdnArray: mobileNumbers,
//                   //   campaignSource: "own_numbers_manual",
//                   //   contactList: null,
//                   //   scheduledDatetime: moment(value)?.format(
//                   //     "YYYY-MM-DD HH:mm:ss"
//                   //   ),
//                   // }
//                 );
//                 // console.log("resultttttmainnnn", result);
//                 if (result.data.statusDescription.statusCode == 200) {
//                   setOpen(false);
//                   //  alert("ok");
//                   formik.handleReset();
//                   setCamapaignDropdown(!CamapaignDropdown);
//                   dispatch(setCampaignState(!CamapaignDropdown));
//                   // dispatch(setDropDown(!true));

//                   Swal.fire({
//                     icon: "success",
//                     //  title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                   dispatch(actionid("0"));
//                   history.replace("/dashboard/CampaignControl");
//                   // setTargettedArray(result?.data?.responseObject);
//                 } else {
//                   setOpen(false);

//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } catch (error) {
//                 setOpen(false);

//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: "Please Check Your Network",
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//             // setValueResponse(result.data.value)
//           } else if (result.data.statusDescription.statusCode == 204) {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           } else {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } catch (error) {
//           setOpen(false);

//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Please Check Your Network",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       } else if (
//         (radiobutton == "2" && RadioGroupValues == 2) ||
//         RadioGroupValues == "on"
//         // expandedinter === "panel2"
//       ) {
//         // alert("select 2");
//         setshowradioerror(false);
//         try {
//           setOpen(true);

//           const result = await common_axios.post(
//             `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
//             {
//               keywordRequest: {
//                 keyword: formik.values.textarea1,
//               },
//             }
//           );
//           if (result.data.statusDescription.statusCode == 200) {
//             setOpen(false);

//             if (result.data) {
//               try {
//                 setOpen(true);
//                 // alert("working");
//                 const result = await common_axios.post(
//                   `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign/later`,
//                   {
//                     campaignName: formik.values.campaignname,
//                     senderId: senderId.senderId,
//                     channel: "web",
//                     route: "quyeru",
//                     templateId: MST == null ? "" : MST?.id,
//                     templateMessage: formik.values.textarea1,
//                     smsType: MSG,
//                     unicode: LangId == 1 ? "0" : "1",
//                     language: lang,
//                     message: formik.values.textarea1,
//                     campaignType: "Individual",
//                     campaignSource: "own_numbers_phoneBook",
//                     phoneBookId: Bulkselector,
//                     scheduledDatetime: moment(value)?.format(
//                       "YYYY-MM-DD HH:mm:ss"
//                     ),
//                   }
//                 );
//                 if (result.data.statusDescription.statusCode == 200) {
//                   setOpen(false);
//                   formik.handleReset();
//                   setCamapaignDropdown(!CamapaignDropdown);
//                   dispatch(setCampaignState(!CamapaignDropdown));
//                   dispatch(actionid("0"));
//                   history.replace("/dashboard/CampaignControl");
//                   Swal.fire({
//                     icon: "success",
//                     //  title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 } else {
//                   setOpen(false);
//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } catch (error) {
//                 setOpen(false);

//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: "Please Check Your Network",
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//             // setValueResponse(result.data.value)
//           } else if (result.data.statusDescription.statusCode == 204) {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           } else {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } catch (error) {
//           setOpen(false);
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Please Check Your Network",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       } else if (
//         (radiobutton == "2" || radiobutton == undefined) &&
//         RadioGroupValues == 3
//       ) {
//         // alert("select 3");
//         setshowradioerror(false);
//         try {
//           setOpen(true);

//           const result = await common_axios.post(
//             `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
//             {
//               keywordRequest: {
//                 keyword: formik.values.textarea1,
//               },
//             }
//           );
//           if (result.data.statusDescription.statusCode == 200) {
//             setOpen(false);

//             if (result.data) {
//               try {
//                 setOpen(true);
//                 // alert("working");
//                 const result = await common_axios.post(
//                   `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign/later`,
//                   {
//                     campaignName: formik.values.campaignname,
//                     senderId: senderId.senderId,
//                     channel: "web",
//                     route: "quyeru",
//                     templateId: MST == null ? "" : MST?.id,
//                     language: lang,
//                     templateMessage: formik.values.textarea1,
//                     smsType: MSG,
//                     unicode: LangId == 1 ? "0" : "1",
//                     message: formik.values.textarea1,
//                     campaignType: "Individual",
//                     campaignSource: "own_numbers_bulkPhoneBook",
//                     bulkPhoneBookId: Bulkselector1,
//                     scheduledDatetime: moment(value)?.format(
//                       "YYYY-MM-DD HH:mm:ss"
//                     ),
//                   }
//                 );
//                 // console.log("resultttttmainnnn", result);
//                 if (result.data.statusDescription.statusCode == 200) {
//                   setOpen(false);
//                   formik.handleReset();
//                   setCamapaignDropdown(!CamapaignDropdown);
//                   dispatch(setCampaignState(!CamapaignDropdown));
//                   dispatch(actionid("0"));
//                   history.replace("/dashboard/CampaignControl");
//                   // dispatch(setDropDown(!true));
//                   // alert("ok");
//                   Swal.fire({
//                     icon: "success",
//                     //  title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 } else {
//                   setOpen(false);
//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } catch (error) {
//                 setOpen(false);
//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: "Please Check Your Network",
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//           } else if (result.data.statusDescription.statusCode == 204) {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           } else {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } catch (error) {
//           setOpen(false);
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Please Check Your Network",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       } else if (
//         (radiobutton == "1" || radiobutton == undefined) &&
//         RadioGroupValues == 4
//         //   ||
//         // RadioGroupValues
//       ) {
//         // alert("select 4");
//         setshowradioerror(false);
//       } else if (
//         radiobutton == "1" ||
//         (radiobutton == undefined && RadioGroupValues == "")
//       ) {
//         // alert("choose numbers ");
//         setshowradioerror(true);
//         setexpanded(false);
//         setexpanded1(true);
//       }
//       // else {
//       //   // alert("choose numbers ");
//       //   setshowradioerror(true);
//       //   setexpanded(false);
//       //   setexpanded1(true);
//       // }
//       else if (radiobutton == "4") {
//         // alert("radio 3");
//         setshowradioerror(false);
//         setRadioGroupValues("");
//         try {
//           setOpen(true);

//           const result = await common_axios.post(
//             `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
//             {
//               keywordRequest: {
//                 keyword: formik.values.textarea1,
//               },
//             }
//             // `http://192.168.167.66:4900/user/phone-books/v1/list`
//           );
//           if (result.data.statusDescription.statusCode == 200) {
//             setOpen(false);

//             if (result.data) {
//               try {
//                 setOpen(true);
//                 const formData = new FormData();
//                 // formData.append("contactListFile", FilesImage);
//                 // console.log("rr", formData);
//                 // formData.append("contactList", FilesImage);
//                 state?.files.map((file) => {
//                   formData.append("contactList", file);
//                 });

//                 formData.append("campaignName", formik.values.campaignname);
//                 formData.append("senderId", senderId.senderId);
//                 formData.append("channel", "web");
//                 formData.append("route", "quyeru");
//                 formData.append("templateId", MST == null ? "" : MST?.id);
//                 formData.append("templateMessage", formik.values.textarea1);
//                 formData.append("smsType", MSG);
//                 formData.append("unicode", LangId == 1 ? "0" : "1");
//                 // unicode: LangId ==1 ? "0" : "1",
//                 formData.append("language", lang);
//                 formData.append("message", formik.values.textarea1);
//                 formData.append("campaignType", "Individual");
//                 formData.append("campaignSource", "own_numbers_file");
//                 formData.append("isRoleOver", checked);
//                 // scheduledDatetime: moment(value?.$d)?.format(
//                 //   "YYYY-MM-DD HH:mm:ss"
//                 // ),
//                 // alert("working");
//                 const result = await common_axios.post(
//                   `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign/later`,
//                   formData
//                 );
//                 // console.log("resultttttmainnnn", result);
//                 if (result.data.statusDescription.statusCode == 200) {
//                   setOpen(false);
//                   // document.getElementById("fileName").value = "";
//                   document.getElementById("formFileLg").value = "";
//                   formik.handleReset();
//                   setCamapaignDropdown(!CamapaignDropdown);
//                   dispatch(setCampaignState(!CamapaignDropdown));
//                   dispatch(actionid("0"));
//                   history.replace("/dashboard/CampaignControl");
//                   Swal.fire({
//                     icon: "success",
//                     //  title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                   // history.replace("/dashboard/Smsdelivery");
//                   // setTargettedArray(result?.data?.responseObject);
//                 } else {
//                   setOpen(false);
//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } catch (error) {
//                 setOpen(false);

//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: "Please Check Your Network",
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//             // setValueResponse(result.data.value)
//           } else if (result.data.statusDescription.statusCode == 204) {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           } else {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } catch (error) {
//           setOpen(false);

//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Please Check Your Network",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       } else if (radiobutton == "3") {
//         //  alert("radio 3");
//         setshowradioerror(false);
//         setRadioGroupValues("");
//         try {
//           setOpen(true);

//           const result = await common_axios.post(
//             `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
//             {
//               keywordRequest: {
//                 keyword: formik.values.textarea1,
//               },
//             }
//             // `http://192.168.167.66:4900/user/phone-books/v1/list`
//           );
//           if (result.data.statusDescription.statusCode == 200) {
//             setOpen(false);
//             if (result.data) {
//               try {
//                 setOpen(true);
//                 // alert("working");
//                 const result = await common_axios.post(
//                   `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign/later`,
//                   {
//                     campaignName: formik.values.campaignname,
//                     senderId: senderId.senderId,
//                     channel: "web",
//                     route: "quyeru",
//                     templateId: MST == null ? "" : MST?.id,
//                     language: lang,
//                     templateMessage: formik.values.textarea1,
//                     smsType: MSG,
//                     unicode: LangId == 1 ? "0" : "1",
//                     message: formik.values.textarea1,
//                     campaignType: "Individual",
//                     // manualMsisdnArray: values.textarea,
//                     campaignSource: "all_numbers",
//                     userId: Number(localStorage.getItem("UserId")),
//                   }
//                 );
//                 // console.log("resultttttmainnnn", result);
//                 if (result.data.statusDescription.statusCode == 200) {
//                   setOpen(false);
//                   setValue();
//                   formik.handleReset();
//                   setCamapaignDropdown(!CamapaignDropdown);
//                   // dispatch(setCampaignState(!CamapaignDropdown));
//                   dispatch(actionid("0"));
//                   history.replace("/dashboard/CampaignControl");

//                   Swal.fire({
//                     icon: "success",
//                     //  title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                   // history.replace("/dashboard/Smsdelivery");
//                   // setTargettedArray(result?.data?.responseObject);
//                 } else {
//                   setOpen(false);
//                   Swal.fire({
//                     icon: "error",
//                     title: "Oops...",
//                     text: result.data.statusDescription.statusMessage,
//                     // footer: '<a href="">Why do I have this issue?</a>'
//                   });
//                 }
//               } catch (error) {
//                 setOpen(false);

//                 Swal.fire({
//                   icon: "error",
//                   title: "Oops...",
//                   text: "Please Check Your Network",
//                   // footer: '<a href="">Why do I have this issue?</a>'
//                 });
//               }
//             } else {
//               setOpen(false);
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: result.data.statusDescription.statusdescription,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//             // setValueResponse(result.data.value)
//           } else if (result.data.statusDescription.statusCode == 204) {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           } else {
//             setOpen(false);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: result.data.statusDescription.statusdescription,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }
//         } catch (error) {
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Please Check Your Network",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       }
//     }
//   };

// //...................................................................//

//   return (
//     <>
//       <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
//         <Backdrop
//           sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
//           open={open}
//           // onClick={handleClose}
//         >
//           <Loader />
//         </Backdrop>
//         <ThemeProvider theme={theme}>
//           <section className="cmp">
//             <div className="container-fluid">
//               {/* <div className="row"> */}
//               {/* <section className="col-md-9 right_panel px-0"> */}

//               <div
//                 className="container-fluid_1 p-0"

//                 // style={{ border: "2px solid black", backgroundColor: "white" }}
//               >
//                 <div className="card p-4">
//                   <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 mt_n4 position-absolute">
//                     <SmsIcon className="ttl_icon" />
//                   </div>
//                   <section className="mt-5">
//                     <section className="marquee_8 modl">
//                       <div className="d-flex justify-content-between">
//                         <marquee>
//                           This kind of ad campaign is a great wakeup call to
//                           give to your target audience that is hard to miss.
//                           Remind them why they should be excited about it.
//                         </marquee>
//                       </div>
//                     </section>

//                     <form
//                       id="accord_8"
//                       className="mt-4 m-0"
//                       onSubmit={formik.handleSubmit}
//                       role="form"
//                     >
//                       <Accordion
//                         //  expanded={true}
//                         expanded={expanded}
//                         onChange={(e) => accordionchange()}
//                       >
//                         <AccordionSummary
//                           expandIcon={<ExpandMoreIcon />}
//                           aria-controls="panel1a-content"
//                           id="panel1a-header"
//                         >
//                           <Typography>
//                             <ForumIcon style={{ fontSize: "15px" }} />{" "}
//                             <strong
//                               style={{
//                                 fontWeight: "500",
//                                 fontFamily: "inherit",
//                               }}
//                             >
//                               {" "}
//                               Compose New Message{" "}
//                             </strong>
//                           </Typography>
//                           <strong
//                             style={{
//                               color: "green",
//                               fontSize: "17px",
//                               // marginRight: "20px",
//                             }}
//                           >
//                             {formik?.values?.textarea1?.length}
//                           </strong>
//                         </AccordionSummary>

//                         <AccordionDetails>
//                           <Typography>
//                             {/* <div className="card shadow-none border bg_blue mt-5"> */}
//                             <section className="sms_form_1" id="sms_form">
//                               {/* <div className="row justify-content-between mx-0"> */}
//                               <div className="sms_form_2 w- mx-auto  p-0 p-4">
//                                 <div className="row">
//                                   <div className="col-md-6">
//                                     <TextField
//                                       autoComplete="on"
//                                       className="ms-4 w-50"
//                                       type="text"
//                                       label="Campaign Name"
//                                       name="campaignname"
//                                       variant="outlined"
//                                       size="small"
//                                       required
//                                       onChange={formik.handleChange}
//                                       value={formik.values.campaignname}
//                                       onBlur={formik.handleBlur}
//                                       error={
//                                         formik.touched.campaignname &&
//                                         Boolean(formik.errors.campaignname)
//                                       }
//                                       helperText={
//                                         formik.touched.campaignname &&
//                                         formik.errors.campaignname
//                                       }
//                                     />
//                                   </div>
//                                   <div className="col-md-6 mt_3">
//                                     <SenderIdSelector
//                                       parentCallback={CallbackSender}
//                                     />
//                                   </div>
//                                 </div>
//                                 <div className="row my-3">
//                                   <div className="col-md-6 position-relative">
//                                     <label
//                                       for="exampleInputText1"
//                                       className="float-start d-flex align-items-center"
//                                     ></label>

//                                     <MessageChannelSelect
//                                       required
//                                       parentCallback={callbackMSG}
//                                     />
//                                   </div>

//                                   <div className="col-md-6 mt_3">
//                                     <MessageTextSelect
//                                       parentCallback={CallbackMessage}
//                                       LanguageData={LanguageData}
//                                       MST={MST}
//                                     />
//                                   </div>
//                                 </div>
//                                 <div className="row">
//                                 <div className="col-md-6">
//                                     {hideSkeleton == true ? (
//                                       <>
//                                         <Box sx={{ width: "100%" }}>
//                                           <Skeleton />
//                                           <Skeleton animation="wave" />
//                                         </Box>
//                                       </>
//                                     ) : (
//                                       <>
//                                         <MessageTemplateSelect
//                                           parentCallback={callbackMST}
//                                           data={TemplateArray}
//                                           LangId={LangId}
//                                         />
//                                       </>
//                                     )}

//                                     <div className="switch d-flex align-items-center flex-wrap mt-3">
//                                       <div className="roll_over d-flex align-items-cente">
//                                         <span className="fw-bold w-100 ms-2">
//                                           Is it roll-over Campaign?
//                                         </span>
//                                       </div>
//                                       <Switch
//                                         checked={checked}
//                                         onChange={handleChangetoogle}
//                                         inputProps={{
//                                           "aria-label": "controlled",
//                                         }}
//                                         style={{ flex: "0 0 auto" }}
//                                       />
//                                     </div>
//                                   </div>

//                                   <div className="col-md-6 mt_3">
//                                     <TextareaAutosize
//                                       // id="area"
//                                       disabled={
//                                         (LangId == undefined ||
//                                           Textareadisabled) == true
//                                           ? true
//                                           : false
//                                       }
//                                       // disabled={Textareadisabled}
//                                       className={
//                                         formik.errors.message
//                                           ? "border-color-red w-100 p-2"
//                                           : "w-100  textarea_8 txtar_rad p-2"
//                                       }
//                                       textarea_8
//                                       aria-label="empty textarea"
//                                       placeholder=" Enter  Manually"
//                                       name="textarea1"
//                                       style={{
//                                         width: " 650px",
//                                         minHeight: "100px",
//                                         // borderColor: " #48a8dd",
//                                       }}
//                                       maxlength="1000"
//                                       // value={textarea}
//                                       // required={RadioGroupValues == 1}
//                                       required
//                                       onChange={formik.handleChange}
//                                       value={formik.values.textarea1}
//                                       error={
//                                         formik.touched.textarea1 &&
//                                         Boolean(formik.errors.textarea1)
//                                       }
//                                       helperText={
//                                         formik.touched.textarea1 &&
//                                         formik.errors.textarea1
//                                       }
//                                     />
//                                     <div className="d-flex justify-content-between align-items-center flex-wrap d_block mt-1">
//                                       <div className="d-flex d_fx_1 align-items-center">
//                                         <pre>
//                                           <code>
//                                             <p>
//                                               Character length used:
//                                               {
//                                                 formik?.values?.textarea1
//                                                   ?.length
//                                               }
//                                             </p>

//                                             <p>
//                                               Disclaimer: This is only estimated
//                                               counts
//                                             </p>
//                                             <p>
//                                               Number of message used:
//                                               {formik.values.lang == "English"
//                                                 ? parseInt(
//                                                     formik?.values?.textarea1
//                                                       ?.length /
//                                                       160 +
//                                                       1
//                                                   )
//                                                 : parseInt(
//                                                     formik?.values?.textarea1
//                                                       ?.length /
//                                                       70 +
//                                                       1
//                                                   )}
//                                             </p>
//                                             <p style={{ fontWeight: "bold" }}>
//                                               {" "}
//                                               <span
//                                                 style={{
//                                                   color: "red",
//                                                   fontWeight: "bold",
//                                                 }}
//                                               >
//                                                 *
//                                               </span>
//                                               Only 1000 characters are allowed
//                                             </p>
//                                           </code>
//                                         </pre>

//                                         <div className="d-flex align-items-center ms-3 m_0">
//                                           {/* <p className="text-capitalize m-0">
//                                             count 0
//                                           </p> */}

//                                           <a
//                                             href="#"
//                                             className="d-block mx-2 mx_2"
//                                             data-bs-toggle="modal"
//                                             data-bs-target="#exampleModal"
//                                           >
//                                             {/* <i className="fas fa-info-circle d-block btn_primary p-1"></i> */}
//                                           </a>
//                                         </div>
//                                       </div>

//                                       <div className="text-end mt-3">
//                                         <button
//                                           disabled={disableNext}
//                                           type="button"
//                                           // className="btn btn-success nx_pv m-0 opc_8"
//                                           className={
//                                             disableNext
//                                               ? "btn btn-success nx_pv m-0 opc_8"
//                                               : "btn btn-success nx_pv m-0"
//                                           }
//                                           onClick={FirstNext}
//                                         >
//                                           Next
//                                           <ArrowRightAltRoundedIcon />
//                                         </button>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                               {/* </div> */}
//                             </section>
//                             {/* </div> */}
//                           </Typography>
//                         </AccordionDetails>
//                       </Accordion>
//                       <Accordion
//                         disabled={
//                           formik.values.campaignname === "" ||
//                           formik.values.textarea1 === "" ||
//                           MSG === "" ||
//                           senderId === "" ||
//                           lang === ""
//                             ? true
//                             : false
//                         }
//                         expanded={expanded1}
//                         onChange={(e) => accordionchange1()}
//                       >
//                         <AccordionSummary
//                           expandIcon={<ExpandMoreIcon />}
//                           aria-controls="panel1a-content"
//                           id="panel1a-header"
//                         >
//                           <Typography>
//                             <ContactsIcon style={{ fontSize: "15px" }} />{" "}
//                             <strong
//                               style={{
//                                 fontWeight: "500",
//                                 fontFamily: "inherit",
//                               }}
//                             >
//                               Mobile Number
//                             </strong>
//                           </Typography>
//                         </AccordionSummary>
//                         <AccordionDetails>
//                           <Typography>
//                             <section
//                               className="sms_form_1 choose_file w-100"
//                               id="sms_form"
//                             >
//                               <div className="sms_form_2 w- mx-auto p-0 p-2">
//                                 <div className="">
//                                   {/* <label className="d-block text-capitalize">
//                                 numbers
//                               </label> */}
//                                   <TestRadio parentCallback={callbackRadio} />
//                                   {(radiobutton == "1" ||
//                                     radiobutton == undefined) && (
//                                     <>
//                                       <div id="bxg" className="bxg66">
//                                         <label
//                                           className="form-check-label"
//                                           for="flexRadioDefault4"
//                                         >
//                                           <TextareaAutosize
//                                             id="area"
//                                             typeof="number"
//                                             className={
//                                               formik.errors.message
//                                                 ? "border-color-red w-100 w_100"
//                                                 : "w-100 w_100 textarea_8 label_67 p-1"
//                                             }
//                                             textarea_8
//                                             aria-label="empty textarea"
//                                             placeholder="Enter contact number( e.g. 22212345678) with comma separated"
//                                             name="textarea"
//                                             style={{
//                                               width: " 650px",
//                                               minHeight: "70px",
//                                             }}
//                                             minlength="10"
//                                             required
//                                             onChange={handleChange10}
//                                             value={mobileNumbers}
//                                             onKeyPress={(event) => {
//                                               const keyCode =
//                                                 event.keyCode || event.which;

//                                               if (
//                                                 (keyCode >= 48 &&
//                                                   keyCode <= 57) ||
//                                                 keyCode == 44
//                                               ) {
//                                               } else {
//                                                 event.preventDefault();
//                                               }
//                                             }}
//                                           />
//                                           {mobileNumbers?.split(",").length >
//                                             10 && (
//                                             <>
//                                               <div>
//                                                 <label
//                                                   style={{
//                                                     color: "#d32f2f",
//                                                     textTransform: "initial",
//                                                     fontSize: "0.95rem",
//                                                     fontWeight: "400",
//                                                     fontFamily:
//                                                       '"Roboto","Helvetica","Arial",sans-serif',
//                                                   }}
//                                                 >
//                                                   Please provide max 10 mobile
//                                                   numbers only!!
//                                                 </label>
//                                               </div>
//                                             </>
//                                           )}
//                                           {showErrorMsg == true &&
//                                             disableMobileNumber[0] == false &&
//                                             mobileNumbers?.split(",")?.length <=
//                                               11 && (
//                                               <>
//                                                 <div>
//                                                   <label
//                                                     style={{
//                                                       color: "#d32f2f",
//                                                       textTransform: "initial",
//                                                       fontSize: "0.95rem",
//                                                       fontWeight: "400",
//                                                       fontFamily:
//                                                         '"Roboto","Helvetica","Arial",sans-serif',
//                                                     }}
//                                                   >
//                                                     {/* Please provide max 10 digits
//                                                     mobile number only!! */}
//                                                     Maximum length of mobile
//                                                     number is 8
//                                                   </label>
//                                                 </div>
//                                               </>
//                                             )}
//                                         </label>
//                                       </div>
//                                       {/* <span className="ms-4" style={{ fontSize: "13px" }}>
//                               (Only 10 mobile numbers are allowed)
//                             </span> */}

//                                       <p style={{}}>
//                                         {" "}
//                                         <span
//                                           style={{
//                                             color: "red",
//                                             fontWeight: "bold",
//                                           }}
//                                         >
//                                           *
//                                         </span>
//                                         Only 10 mobile numbers are allowed
//                                       </p>
//                                       <div className="">
//                                         {formik.errors.textarea && (
//                                           <h4
//                                             className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained MuiFormHelperText-filled Mui-required css-k4qjio-MuiFormHelperText-root"
//                                             style={{ color: "red" }}
//                                           >
//                                             {formik.errors.textarea}
//                                           </h4>
//                                         )}
//                                       </div>
//                                     </>
//                                   )}
//                                   {radiobutton == "2" && (
//                                     <div className="w-90">
//                                       {/* <TargettedSelect
//                                     parentCallback={callbackTarget}
//                                     data={TargettedArray}
//                                   /> */}

//                                       <>
//                                         <div id="bxg" className="bxg66">
//                                           {showradioerror == true ? (
//                                             <div
//                                               style={{
//                                                 color: "#d32f2f",
//                                                 textAlign: "center",
//                                               }}
//                                             >
//                                               Please Select One Of These Options
//                                             </div>
//                                           ) : (
//                                             <div></div>
//                                           )}
//                                           <div className="" id="dv_bxg">
//                                             <FormControl
//                                               value={RadioGroupValues}
//                                               onChange={handleChangeRadio}
//                                             >
//                                               <RadioGroup
//                                                 // value={RadioGroupValues1}
//                                                 row
//                                                 aria-labelledby="demo-row-radio-buttons-group-label"
//                                                 name="row-radio-buttons-group"
//                                               >
//                                                 <div
//                                                   className="row"
//                                                   id="row_input"
//                                                 >
//                                                   <div className="col-md-6">
//                                                     <div className="d-flex">
//                                                       <FormControlLabel
//                                                         value={2}
//                                                         control={<Radio />}
//                                                         onChange={(event) => {
//                                                           setOnchangeRadio(
//                                                             event.target.value
//                                                           );
//                                                         }}
//                                                       />

//                                                       <BulkSelect
//                                                         parentCallback={
//                                                           callbackBulkSelector
//                                                         }
//                                                         ContactArray={
//                                                           ContactArray
//                                                         }
//                                                         disabledval={
//                                                           Radiosdisabled.bulk
//                                                         }
//                                                       />
//                                                     </div>
//                                                   </div>

//                                                   <div className="col-md-6 mt_3">
//                                                     <div className="d-flex">
//                                                       <FormControlLabel
//                                                         value={3}
//                                                         control={<Radio />}
//                                                         onChange={(event) => {
//                                                           setonchangeradioBulkGroup(
//                                                             event.target.value
//                                                           );
//                                                         }}
//                                                       />

//                                                       <BulkSelect1
//                                                         parentCallback={
//                                                           callbackBulkSelector1
//                                                         }
//                                                         data={data}
//                                                         disabledval={
//                                                           Radiosdisabled.bulk1
//                                                         }
//                                                       />
//                                                     </div>
//                                                   </div>
//                                                 </div>
//                                               </RadioGroup>
//                                             </FormControl>
//                                           </div>
//                                         </div>
//                                       </>
//                                     </div>
//                                   )}
//                                   {radiobutton == "4" && (
//                                     <div className="w-50">
//                                       <>
//                                         <div id="bxg" className="bxg66">
//                                           {showradioerror == true ? (
//                                             <div
//                                               style={{
//                                                 color: "#d32f2f",
//                                                 textAlign: "center",
//                                               }}
//                                             >
//                                               Please Select One Of These Options
//                                             </div>
//                                           ) : (
//                                             <div></div>
//                                           )}
//                                           <div className="">
//                                             <FormControl
//                                               value={RadioGroupValues}
//                                               onChange={handleChangeRadio}
//                                             >
//                                               <RadioGroup
//                                                 // value={RadioGroupValues1}
//                                                 row
//                                                 // onChange={handleChangeRadio}
//                                                 // defaultValue={1}
//                                                 aria-labelledby="demo-row-radio-buttons-group-label"
//                                                 name="row-radio-buttons-group"
//                                               >
//                                                 <div className="row align-items-center mt-2">
//                                                   <div
//                                                     className="col-md-5"
//                                                     id="choose_file_label"
//                                                   >
//                                                     {/* <div
//                                                       className="bx_flx bx_flex_1 mt-"
//                                                       id="bx_flx"
//                                                     >
//                                                       <>
//                                                         {" "}
//                                                         <div className="w-100">
//                                                           <div
//                                                             class="  input-group m-0 mb-3"
//                                                             id="input_group_8"
//                                                           >
//                                                             <Button
//                                                               variant="contained"
//                                                               component="label"
//                                                               style={{
//                                                                 backgroundColor:
//                                                                   "white",
//                                                                 boxShadow:
//                                                                   "none",
//                                                                 height: "40px",
//                                                                 border:
//                                                                   "1px solid #d2d6da",
//                                                                 padding:
//                                                                   "0px 0px 0px 0px",
//                                                                 margin:
//                                                                   "0px -3px 0px 0px",
//                                                               }}
//                                                             >
//                                                                <input
//                                                                 multiple
//                                                                 accept=".csv , .txt"
//                                                                 // multiple
//                                                                 required={
//                                                                   RadioGroupValues ==
//                                                                   4
//                                                                 }
//                                                                 id="fileName"
//                                                                 type="file"
//                                                                 style={{
//                                                                   color:
//                                                                     "#7b809a",
//                                                                 }}
//                                                                 onChange={(
//                                                                   e,
//                                                                   index
//                                                                 ) => {
//                                                                   getImage(
//                                                                     e,
//                                                                     index
//                                                                   );
//                                                                 }}
//                                                               /> *
//                                                             </Button>
//                                                           </div>
//                                                         </div>
//                                                       </>
//                                                     </div> */}

//                                                     {/* -------------------------New file----------- */}
//                                                     <div className="container px-0 mt-">
//                                                       <div>
//                                                         <Button
//                                                           className="position-relative"
//                                                           variant="contained"
//                                                           component="label"
//                                                           style={{
//                                                             backgroundColor:
//                                                               "white",
//                                                             boxShadow: "none",
//                                                             height: "40px",
//                                                             border:
//                                                               "1px solid #d2d6da",
//                                                             padding:
//                                                               "0px 0px 0px 0px",
//                                                             // margin:
//                                                             //   "0px -3px 0px 0px",
//                                                           }}
//                                                         >
//                                                           <input
//                                                             className="w-100 p-0"
//                                                             multiple
//                                                             style={{
//                                                               // display: "none",
//                                                               opacity: "0",
//                                                               height: "35px",
//                                                             }}
//                                                             //   value={state}
//                                                             onChange={(e) => {
//                                                               // alert("HII");
//                                                               UploadFiles(e);
//                                                               // console.log(
//                                                               //   e.target.files,
//                                                               //   Array.from(
//                                                               //     e.target.files
//                                                               //   )
//                                                               // );
//                                                             }}
//                                                             class="form-control form-control-lg"
//                                                             id="formFileLg"
//                                                             type="file"
//                                                           />
//                                                           <div
//                                                             className="p-2"
//                                                             style={{
//                                                               position:
//                                                                 "absolute",
//                                                               left: "0",
//                                                               right: "0",
//                                                               top: "0",
//                                                               bottom: "0",
//                                                               display: "flex",
//                                                               alignItems:
//                                                                 "center",
//                                                             }}
//                                                           >
//                                                             <button
//                                                               style={{
//                                                                 lineHeight:
//                                                                   "normal",
//                                                                 borderRadius:
//                                                                   "0",
//                                                                 background:
//                                                                   "#efefef",
//                                                                 border:
//                                                                   "1px solid #000",
//                                                                 display:
//                                                                   "block",
//                                                                 overflow:
//                                                                   "hidden",
//                                                                 textOverflow:
//                                                                   "ellipsis",
//                                                                 whiteSpace:
//                                                                   "nowrap",
//                                                                 flex: "0 0 auto",
//                                                               }}
//                                                               className="btn py-0 px-1 text-dark m-0"
//                                                               type="button"
//                                                               onClick={() =>
//                                                                 document
//                                                                   .getElementById(
//                                                                     "formFileLg"
//                                                                   )
//                                                                   ?.click()
//                                                               }
//                                                             >
//                                                               Choose Files
//                                                             </button>
//                                                             {state?.files
//                                                               ?.length > 0 ? (
//                                                               <span
//                                                                 className="ms-2 w-100 text-dark"
//                                                                 style={{
//                                                                   overflow:
//                                                                     "hidden",
//                                                                   textOverflow:
//                                                                     "ellipsis",
//                                                                   whiteSpace:
//                                                                     "nowrap",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   state?.files
//                                                                     ?.length
//                                                                 }{" "}
//                                                                 Files
//                                                               </span>
//                                                             ) : (
//                                                               <span
//                                                                 className="ms-2 w-100"
//                                                                 style={{
//                                                                   overflow:
//                                                                     "hidden",
//                                                                   textOverflow:
//                                                                     "ellipsis",
//                                                                   whiteSpace:
//                                                                     "nowrap",
//                                                                   fontSize:
//                                                                     "11px",
//                                                                   color:
//                                                                     "rgb(123, 128, 154)",
//                                                                 }}
//                                                               >
//                                                                 No file chosen
//                                                               </span>
//                                                             )}
//                                                           </div>
//                                                         </Button>
//                                                       </div>
//                                                     </div>

//                                                     {/* -------------------------------End new file--------------------------------- */}
//                                                   </div>
//                                                   <div className="col-md-6">
//                                                     <>
//                                                       <div className="mx-0 d-inline-block">
//                                                         <span>
//                                                           (Reference File)
//                                                         </span>

//                                                         <span>
//                                                           <a
//                                                             href={contactfile3}
//                                                             target="_blank"
//                                                             download="Reference.txt"
//                                                             className="xlsx"
//                                                           >
//                                                             txt
//                                                           </a>
//                                                         </span>

//                                                         <span className="mx-1">
//                                                           ,
//                                                         </span>
//                                                       </div>
//                                                       <div className="ms-1 me-0 d-inline-block">
//                                                         <span>
//                                                           <a
//                                                             href={contactfile2}
//                                                             target="_blank"
//                                                             download="Reference.csv"
//                                                             className="xlsx"
//                                                           >
//                                                             {/* Download Here
//                                                              */}
//                                                             csv
//                                                           </a>
//                                                         </span>
//                                                       </div>
//                                                     </>
//                                                   </div>
//                                                 </div>

//                                                 <div className="row">
//                                                   <div className="col-md-6">
//                                                     <div
//                                                       className="row"
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       {state?.files?.map(
//                                                         (file, index) => {
//                                                           return (
//                                                             <div className="col-6">
//                                                               <div className="d-flex align-items-center">
//                                                                 <span
//                                                                   style={{
//                                                                     overflow:
//                                                                       "hidden",
//                                                                     textOverflow:
//                                                                       "ellipsis",
//                                                                     whiteSpace:
//                                                                       "nowrap",
//                                                                     display:
//                                                                       "block",
//                                                                     width:
//                                                                       "100%",
//                                                                   }}
//                                                                 >
//                                                                   {file?.name}
//                                                                 </span>
//                                                                 <button
//                                                                   className="border-0 bg-transparent"
//                                                                   type="button"
//                                                                   onClick={() => {
//                                                                     let stateeCopy =
//                                                                       {
//                                                                         ...state,
//                                                                       };

//                                                                     stateeCopy.files =
//                                                                       stateeCopy?.files?.filter(
//                                                                         (
//                                                                           fileName,
//                                                                           indexx
//                                                                         ) =>
//                                                                           indexx !==
//                                                                           index
//                                                                       );
//                                                                     setState(
//                                                                       stateeCopy
//                                                                     );
//                                                                   }}
//                                                                 >
//                                                                   {/* X */}
//                                                                   <CancelIcon
//                                                                     className=" gray_text_up"
//                                                                     style={{
//                                                                       cursor:
//                                                                         "pointer",
//                                                                       flex: "0 0 auto",
//                                                                       fontSize:
//                                                                         "1.32rem",
//                                                                     }}
//                                                                   />
//                                                                 </button>
//                                                               </div>
//                                                             </div>
//                                                           );
//                                                         }
//                                                       )}
//                                                     </div>
//                                                   </div>
//                                                 </div>
//                                                 {/* <div className="row px-3 mt-2">
//                                                   <div className="col-md-6">
//                                                     <div className="row">
//                                                       {FilesImage?.map(
//                                                         (dataaaa, index) => {
//                                                           return (
//                                                             <>
//                                                               <div
//                                                                 className="col-6"
//                                                                 id="file_icon"
//                                                                 style={{
//                                                                   fontSize:
//                                                                     "12px",
//                                                                 }}
//                                                               >
//                                                                 <div className="d-flex align-items-center">
//                                                                   <div
//                                                                     className="m-0"
//                                                                     style={{
//                                                                       width:
//                                                                         "100%",
//                                                                       overflow:
//                                                                         "hidden",
//                                                                       textOverflow:
//                                                                         "ellipsis",
//                                                                       whiteSpace:
//                                                                         "nowrap",
//                                                                     }}
//                                                                   >
//                                                                     <span
//                                                                       class="d-block w-100 text-capitalize spn card_dt_UP"
//                                                                       data-bs-toggle="tooltip"
//                                                                       data-bs-placement="top"
//                                                                       title={
//                                                                         dataaaa?.name
//                                                                       }
//                                                                     >
//                                                                       {
//                                                                         dataaaa?.name
//                                                                       }
//                                                                     </span>

//                                                                   </div>
//                                                                   <div className="ms-1">
//                                                                     {" "}

//                                                                     <CancelIcon
//                                                                       className=" gray_text_up"
//                                                                       style={{
//                                                                         cursor:
//                                                                           "pointer",
//                                                                       }}
//                                                                       onClick={() => {
//                                                                         let temp_arraction =
//                                                                           [
//                                                                             ...FilesImage,
//                                                                           ];

//                                                                         const previousSecondElementOfTheArray =
//                                                                           temp_arraction.filter(
//                                                                             (
//                                                                               val,
//                                                                               indexx
//                                                                             ) => {
//                                                                               return (
//                                                                                 index !=
//                                                                                 indexx
//                                                                               );
//                                                                             }
//                                                                           );

//                                                                         setFilesImage(
//                                                                           previousSecondElementOfTheArray
//                                                                         );
//                                                                       }}
//                                                                     />
//                                                                   </div>
//                                                                 </div>
//                                                               </div>
//                                                             </>
//                                                           );
//                                                         }
//                                                       )}
//                                                     </div>
//                                                   </div>
//                                                 </div> */}
//                                               </RadioGroup>
//                                             </FormControl>
//                                           </div>
//                                         </div>
//                                         <div></div>
//                                       </>
//                                     </div>
//                                   )}{" "}
//                                 </div>
//                               </div>
//                             </section>
//                             <section></section>
//                           </Typography>
//                         </AccordionDetails>
//                       </Accordion>{" "}
//                       <section
//                         className="sms_form mt-4"
//                         id="schedule"
//                         style={{
//                           boxShadow: "0px 1px 6px #00000091",
//                           borderRadius: "20px",
//                           /* margin-top: 53px; */
//                           paddingBottom: "20px",
//                         }}
//                       >
//                         <div className="flt_start">
//                           <div className="float-start d-flex align-items-center flex-wrap"></div>
//                         </div>
//                         <div className="d-flex justify-content-center align-items-center mt-4">
//                           <button
//                             type="button"
//                             className="btn btn-danger d-flex align-items-center text-capitalize btn_9 m-0 btnapprove"
//                             data-bs-toggle="modal"
//                             data-bs-target="#exampleModal1"
//                             onClick={() => {
//                               setValue(
//                                 moment(new Date())
//                                   .subtract(5.5, "hours")
//                                   .add(16, "minutes")
//                                   .format("YYYY-MM-DD HH:mm")
//                               );
//                               setCalenderSchedule(
//                                 moment(new Date())
//                                   .subtract(5.5, "hours")
//                                   .add(16, "minutes")
//                                   .format("YYYY-MM-DD HH:mm")
//                               );
//                             }}
//                             disabled={
//                               (disableMobileNumber[0] == false ||
//                                 mobileNumbers?.split(",").length >= 11) &&
//                               Bulkselector.length === 0 &&
//                               Bulkselector1.length === 0 &&
//                               radiobutton != 3 &&
//                               // FilesImage == null
//                               //   ? true
//                               //   : false
//                               (state?.files.length == 0 ||
//                                 state?.files.length > 5)
//                             }
//                           >
//                             <i className="fas fa-calendar-alt d-block"></i>
//                             <span className="d-block ms-1">
//                               schedule for later
//                             </span>
//                           </button>
//                           <span className="d-block text-capitalize span_or mx-3">
//                             or
//                           </span>
//                           <button
//                             type="submit"
//                             className="btn btn-success d-flex align-items-center text-capitalize btn_9 m-0 btnapprove"
//                             disabled={
//                               // formik.values.textarea === "" &&
//                               (disableMobileNumber[0] == false ||
//                                 mobileNumbers?.split(",").length >= 11) &&
//                               Bulkselector.length === 0 &&
//                               Bulkselector1.length === 0 &&
//                               radiobutton != 3 &&
//                               // FilesImage == null
//                               //   ? true
//                               //   : false
//                               (state?.files.length == 0 ||
//                                 state?.files.length > 5)
//                             }
//                           >
//                             <i className="fas fa-share d-block"></i>

//                             <span className="d-block ms-1">send now</span>
//                           </button>
//                           <span className="d-block text-capitalize span_or mx-3">
//                             or
//                           </span>
//                           <button
//                             type="button"
//                             // onClick={CreateCampaignApi()}
//                             onClick={()=>{
//                               CreateCampaignApi()
//                             }}
//                             className="btn btn-primary d-flex align-items-center text-capitalize btn_9 m-0 btnapprove"
//                             disabled={
//                               // formik.values.textarea === "" &&
//                               (disableMobileNumber[0] == false ||
//                                 mobileNumbers?.split(",").length >= 11) &&
//                               Bulkselector.length === 0 &&
//                               Bulkselector1.length === 0 &&
//                               radiobutton != 3 &&
//                               // FilesImage == null
//                               //   ? true
//                               //   : false
//                               (state?.files.length == 0 ||
//                                 state?.files.length > 5)
//                             }
//                           >
//                             <i className="fas fa-share d-block"></i>

//                             <span className="d-block ms-1">create campaign</span>
//                           </button>
//                         </div>
//                       </section>
//                     </form>

//                     <section className="modal_1">
//                       {/* <!-- Modal --> */}

//                       {/* <!-- Modal   For Test Campaign--> */}
//                       <div
//                         className="modal fade"
//                         id="exampleModal51"
//                         // tabindex="-1"
//                         aria-labelledby="exampleModalLabel"
//                         aria-hidden="true"
//                       >
//                         <div className="modal-dialog">
//                           <div className="modal-content">
//                             <div className="modal-header">
//                               <h5
//                                 className="modal-title text-capitalize"
//                                 id="exampleModalLabel"
//                               >
//                                 Test Campaign
//                               </h5>
//                               <button
//                                 ref={cuttt}
//                                 type="button"
//                                 className="btn-close m-0 p-0"
//                                 data-bs-dismiss="modal"
//                                 aria-label="Close"
//                               ></button>
//                             </div>
//                             <form onSubmit={TestCampaign}>
//                               <div className="modal-body">
//                                 <TextField
//                                   autoComplete="on"
//                                   className="ms-4 w-50"
//                                   type="number"
//                                   label="Target Test Number"
//                                   value={testcampaign}
//                                   variant="outlined"
//                                   size="small"
//                                   required
//                                   onChange={(e) => {
//                                     settestcampaign(e.target.value);
//                                   }}
//                                   onInput={(e) => {
//                                     e.target.value = Math.max(
//                                       0,
//                                       parseInt(e.target.value)
//                                     )
//                                       .toString()
//                                       .slice(0, 10);
//                                   }}
//                                 />
//                               </div>

//                               <div className="modal-footer">
//                                 <button
//                                   type="submit"
//                                   className="btn btn-secondary m-0"
//                                 >
//                                   ok
//                                 </button>
//                               </div>
//                             </form>
//                           </div>
//                         </div>
//                       </div>
//                       {/* ----------schedule sms later---------- */}
//                       <div
//                         className="modal fade"
//                         id="exampleModal1"
//                         // tabindex="-1"
//                         aria-labelledby="exampleModalLabel"
//                         aria-hidden="true"
//                       >
//                         <div className="modal-dialog">
//                           <div className="modal-content">
//                             <div className="modal-header">
//                               <h5
//                                 className="modal-title text-capitalize"
//                                 id="exampleModalLabel"
//                               >
//                                 schedule sms later
//                               </h5>
//                               <button
//                                 type="button"
//                                 className="btn-close m-0 p-0"
//                                 data-bs-dismiss="modal"
//                                 aria-label="Close"
//                                 onClick={()=>{
//                                   setCheckedRecurring("")
//                                   setStatusDropDown("")
//                                 }}
//                               ></button>
//                             </div>
//                             <form onSubmit={scheduleapi}>
//                               <div className="modal-body">
//                                 {/* <NativePickers parentCallback={callbackSchedule} /> */}

//                                 <div>
//                               <span className="fw-bold">Is it recurring Campaign?</span>
//                               <Switch
//       checked={checkedRecurring}
//       onChange={handleChangetoogleRecurring}

//       inputProps={{ 'aria-label': 'controlled' }}
//     />

//                               </div>
//                               <div className="my-4 mt-2">
// {
//   checkedRecurring == true ? (<>

//     <div className="col-md-4">
// <FormControl
//  fullWidth size="small">
//                           <InputLabel id="demo-simple-select-autowidth-label">
//                             Recurring
//                           </InputLabel>
//                           <Select
//                             labelId="demo-simple-select-autowidth-label"
//                             id="demo-simple-select-autowidth"
//                             value={statusDropDown}

//                              onChange={handleChangeRecurring}
//                             autowidth
//                             label="Recurring"
//                           >
//                             <MenuItem value="daily">Daily</MenuItem>
//                             <MenuItem value="weekly">Weekly</MenuItem>
//                             <MenuItem value="monthly">Monthly</MenuItem>

//                           </Select>
//                         </FormControl>
//   </div>

//                         </>):(<>

//   </>)
// }
// </div>
// <div className="">

//                                 <>
//                                   {" "}
//                                   <LocalizationProvider

//                                     dateAdapter={AdapterDayjs}
//                                     style={{ zIndex: "10px" }}
//                                   >
//                                     <DateTimePicker
//                                     disabled={checkedRecurring == true && (statusDropDown == "" || statusDropDown == null )}
//                                       inputRef={datereff}
//                                       disablePast
//                                       // minDate={dayjs(new Date())}
//                                       minTime={moment(new Date())
//                                         .subtract(5.5, "hours")
//                                         .add(15, "minutes")}
//                                       // minTime={moment().add(15,"minutes")}
//                                       renderInput={(props) => (
//                                         <TextField
//                                           size="small"
//                                           required
//                                           style={{ zIndex: "10px" }}
//                                           {...props}
//                                           helperText={
//                                             "(Date time should be mm/dd/yyyy hh:mm)"
//                                           }
//                                         />
//                                       )}
//                                       ampm={false}
//                                       style={{ zIndex: "10px" }}
//                                       label="Select Schedule"
//                                       value={value}
//                                       onChange={(newValue) => {
//                                         setValue(newValue?.$d);
//                                         // console.log("ee",newValue)
//                                       }}
//                                     />
//                                   </LocalizationProvider>
//                                 </>

//                                 </div>

//                               </div>
//                               {/* </button> */}

//                               <div className="modal-footer mt-3 justify-content-between align-items-center">
//                                 <button
//                                   type="button"
//                                   className="btn btn-secondary m-0"
//                                   data-bs-dismiss="modal"
//                                   onClick={() => {
//                                     setValue(null);
//                                     setCheckedRecurring("")
//                                   setStatusDropDown("")
//                                   }}
//                                 >
//                                   Close
//                                 </button>

//                                 <button
//                                   type="submit"
//                                   className="btn btn-primary m-0 ms-2"
//                                   disabled={buttonDisable}
//                                   data-bs-dismiss="modal"
//                                 >
//                                   Submit Campaign
//                                 </button>
//                               </div>
//                             </form>
//                           </div>
//                         </div>
//                       </div>
//                       {/* ---------  message summary ---------- */}
//                       <div
//                         className="modal fade"
//                         id="exampleModal2"
//                         // tabindex="-1"
//                         aria-labelledby="exampleModalLabel"
//                         aria-hidden="true"
//                       >
//                         <div className="modal-dialog">
//                           <div className="modal-content">
//                             <div className="modal-header">
//                               <h5
//                                 className="modal-title text-capitalize"
//                                 id="exampleModalLabel"
//                               >
//                                 message summary
//                               </h5>
//                               <button
//                                 type="button"
//                                 className="btn-close m-0 p-0"
//                                 data-bs-dismiss="modal"
//                                 aria-label="Close"
//                               ></button>
//                             </div>
//                             <div className="modal-body">
//                               <div className="row mx-0">
//                                 <div className="col-4 px-0">
//                                   <p className="">total numbers</p>
//                                 </div>
//                                 <div className="col-8 px-0">
//                                   <p className="">3</p>
//                                 </div>
//                               </div>
//                               <div className="row mx-0">
//                                 <div className="col-4 px-0">
//                                   <p className="">message</p>
//                                 </div>
//                                 <div className="col-8 px-0">
//                                   <p className="">welcome sms</p>
//                                 </div>
//                               </div>
//                               <div className="row mx-0">
//                                 <div className="col-4 px-0">
//                                   <p className="">message type</p>
//                                 </div>
//                                 <div className="col-8 px-0">
//                                   <p className="">transactional(ENGLISH)</p>
//                                 </div>
//                               </div>
//                               <div className="row mx-0">
//                                 <div className="col-4 px-0">
//                                   <p className="">credit required</p>
//                                 </div>
//                                 <div className="col-8 px-0">
//                                   <p className="">3</p>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="modal-footer justify-content-start">
//                               <button
//                                 type="button"
//                                 className="btn btn-secondary m-0"
//                                 data-bs-dismiss="modal"
//                               >
//                                 cancel
//                               </button>
//                               <button
//                                 type="button"
//                                 className="btn btn-primary d-flex align-items-center m-0 ms-2"
//                                 id="launch_now"
//                               >
//                                 <i className="fas fa-calendar-alt d-block"></i>
//                                 <span className="d-block ms-1">launch now</span>
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       {/* ----------   my template ----------- */}
//                       <div
//                         class="modal fade"
//                         id="exampleModal3"
//                         // tabindex="-1"
//                         aria-labelledby="exampleModalLabel"
//                         aria-hidden="true"
//                       >
//                         <div class="modal-dialog modal-lg">
//                           <div class="modal-content">
//                             <div class="modal-header">
//                               <h5
//                                 class="modal-title text-capitalize"
//                                 id="exampleModalLabel"
//                               >
//                                 my template
//                               </h5>
//                               <button
//                                 type="button"
//                                 class="btn-close m-0 p-0"
//                                 data-bs-dismiss="modal"
//                                 aria-label="Close"
//                               ></button>
//                             </div>
//                             <div class="modal-body">
//                               <div class="table-responsive">
//                                 <table>
//                                   <thead>
//                                     <tr>
//                                       <th>select</th>
//                                       <th>template name</th>
//                                       <th>template</th>
//                                       <th>DLTTemplateId</th>
//                                       <th>TelemarketerId</th>
//                                     </tr>
//                                   </thead>
//                                   <tbody>
//                                     <tr>
//                                       <td>
//                                         <a href="#" class="d-block">
//                                           select
//                                         </a>
//                                       </td>
//                                       <td>for testing DLT</td>
//                                       <td>
//                                         <p>
//                                           This is testing message from ISPL
//                                           India visit on
//                                         </p>
//                                         <a class="d-inline-block">
//                                           www.innuvissolutions.com
//                                         </a>
//                                         <p>email us:</p>
//                                         <a class="d-inline-block">
//                                           support@innuvissolutions.com
//                                         </a>
//                                       </td>
//                                       <td>1707160138351612059</td>
//                                       <td>1701158159410623084</td>
//                                     </tr>
//                                     <tr>
//                                       <td>
//                                         <a href="#" class="d-block">
//                                           select
//                                         </a>
//                                       </td>
//                                       <td>for testing DLT</td>
//                                       <td>
//                                         vguvgvggvu vgyvggvvgu vgyvgvg vvggvu
//                                         vgyuvgugv vvgvugv vgyuvguufvf vguvguvu
//                                         vgyvcfufcuucf vgyctfcfcfu vucfcfcf
//                                         vucfcfcffcf vcctffctctffctuftu
//                                         vcyufucfcuucfucf ctufccfucftucfut
//                                         ctfcfccftcf vccfcfcftctyt
//                                         cfyfcyfcxdxdszwaewcfvg
//                                         vccfcftyfcyfcffchfc
//                                       </td>
//                                       <td>1707160138351612059</td>
//                                       <td>1701158159410623084</td>
//                                     </tr>
//                                     <tr>
//                                       <td>
//                                         <a href="#" class="d-block">
//                                           select
//                                         </a>
//                                       </td>
//                                       <td>for testing DLT</td>
//                                       <td>
//                                         vguvgvggvu vgyvggvvgu vgyvgvg vvggvu
//                                         vgyuvgugv vvgvugv vgyuvguufvf vguvguvu
//                                         vgyvcfufcuucf vgyctfcfcfu vucfcfcf
//                                         vucfcfcffcf vcctffctctffctuftu
//                                         vcyufucfcuucfucf ctufccfucftucfut
//                                         ctfcfccftcf vccfcfcftctyt
//                                         cfyfcyfcxdxdszwaewcfvg
//                                         vccfcftyfcyfcffchfc
//                                       </td>
//                                       <td>1707160138351612059</td>
//                                       <td>1701158159410623084</td>
//                                     </tr>
//                                     <tr>
//                                       <td>
//                                         <a href="#" class="d-block">
//                                           select
//                                         </a>
//                                       </td>
//                                       <td>for testing DLT</td>
//                                       <td>
//                                         vguvgvggvu vgyvggvvgu vgyvgvg vvggvu
//                                         vgyuvgugv vvgvugv vgyuvguufvf vguvguvu
//                                         vgyvcfufcuucf vgyctfcfcfu vucfcfcf
//                                         vucfcfcffcf vcctffctctffctuftu
//                                         vcyufucfcuucfucf ctufccfucftucfut
//                                         ctfcfccftcf vccfcfcftctyt
//                                         cfyfcyfcxdxdszwaewcfvg
//                                         vccfcftyfcyfcffchfc
//                                       </td>
//                                       <td>1707160138351612059</td>
//                                       <td>1701158159410623084</td>
//                                     </tr>
//                                     <tr>
//                                       <td>
//                                         <a href="#" class="d-block">
//                                           select
//                                         </a>
//                                       </td>
//                                       <td>for testing DLT</td>
//                                       <td>
//                                         <p>
//                                           This is testing message from ISPL
//                                           India visit on
//                                         </p>
//                                         <a class="d-inline-block">
//                                           www.innuvissolutions.com
//                                         </a>
//                                       </td>
//                                       <td>1707160138351612059</td>
//                                       <td>1701158159410623084</td>
//                                     </tr>
//                                     <tr>
//                                       <td>
//                                         <a href="#" class="d-block">
//                                           select
//                                         </a>
//                                       </td>
//                                       <td>for testing DLT</td>
//                                       <td>
//                                         vguvgvggvu vgyvggvvgu vgyvgvg vvggvu
//                                         vgyuvgugv vvgvugv vgyuvguufvf vguvguvu
//                                         vgyvcfufcuucf vgyctfcfcfu vucfcfcf
//                                         vucfcfcffcf vcctffctctffctuftu
//                                         vcyufucfcuucfucf ctufccfucftucfut
//                                         ctfcfccftcf vccfcfcftctyt
//                                         cfyfcyfcxdxdszwaewcfvg
//                                         vccfcftyfcyfcffchfc
//                                       </td>
//                                       <td>1707160138351612059</td>
//                                       <td>1701158159410623084</td>
//                                     </tr>
//                                     <tr>
//                                       <td>
//                                         <a href="#" class="d-block">
//                                           select
//                                         </a>
//                                       </td>
//                                       <td>for testing DLT</td>
//                                       <td>
//                                         vguvgvggvu vgyvggvvgu vgyvgvg vvggvu
//                                         vgyuvgugv vvgvugv vgyuvguufvf vguvguvu
//                                         vgyvcfufcuucf vgyctfcfcfu vucfcfcf
//                                         vucfcfcffcf vcctffctctffctuftu
//                                         vcyufucfcuucfucf ctufccfucftucfut
//                                         ctfcfccftcf vccfcfcftctyt
//                                         cfyfcyfcxdxdszwaewcfvg
//                                         vccfcftyfcyfcffchfc
//                                       </td>
//                                       <td>1707160138351612059</td>
//                                       <td>1701158159410623084</td>
//                                     </tr>
//                                   </tbody>
//                                 </table>
//                               </div>
//                             </div>
//                             <div class="modal-footer">
//                               <button
//                                 type="button"
//                                 class="btn btn-secondary"
//                                 data-bs-dismiss="modal"
//                               >
//                                 Close
//                               </button>
//                               <button type="button" class="btn btn-primary">
//                                 Save changes
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </section>
//                   </section>
//                 </div>
//                 {/* <!--marquee-section--> */}
//               </div>
//             </div>
//           </section>
//         </ThemeProvider>
//       </main>
//     </>
//   );
// }

import {
  Backdrop,
  FormControl,
  Radio,
  RadioGroup,
  TextareaAutosize,
  TextField,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useEffect } from "react";
import "../../../../src/assets/css/material-dashboard_1.css";
import MessageChannelSelect from "./MessageChannelSelect";
import MessageRouteSelect from "./MessageRouteSelect";
import MessageTextSelect from "./MessageTextSelect";
import SenderIdSelector from "./SenderIdSelector";
import TestRadio from "./TestRadio";
import TemplateSelect from "./MessageTemplateSelect";
import { useRef } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useState } from "react";
import TargettedSelect from "./TargettedSelect";
import BulkSelect from "./BulkSelect";
import Button from "@mui/material/Button";
import BulkSelect1 from "./BulkSelect1";
import { ThemeProvider, createTheme } from "@mui/material";
import { Formik, useFormik } from "formik";
import * as yup from "yup";
import NativePickers from "./ScheduleTimeDate";
import MessageTemplateSelect from "./MessageTemplateSelect";
import InfoIcon from "@mui/icons-material/Info";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { common_axios } from "../../../App";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import ArrowRightAltRoundedIcon from "@mui/icons-material/ArrowRightAltRounded";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import contactfile1 from "../../../file/voice_campaign.xlsx";
import contactfile2 from "../../../file/referencecsv.csv";
import contactfile3 from "../../../file/campaigntext.txt";
import CancelIcon from "@mui/icons-material/Cancel";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Chip from "@mui/material/Chip";
import DoneIcon from "@mui/icons-material/Done";
import moment from "moment";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Link } from "react-router-dom";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import ContactsIcon from "@mui/icons-material/Contacts";
import ForumIcon from "@mui/icons-material/Forum";
import { useDispatch } from "react-redux";
import { setDropDown } from "../../../redux/features/CampaignSlice";
import { setCampaignState } from "../../../redux/actions/campaignAction";
import SmsIcon from "@mui/icons-material/Sms";
import { actionid } from "../../../redux/features/pageSlices";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Swal from "sweetalert2";
import { CoPresentOutlined, InsertLinkOutlined } from "@mui/icons-material";
import Switch from "@mui/material/Switch";

export default function Sendsms() {
  const history = useHistory();
  const dispatch = useDispatch();
  // ...................................Theme Provider....................................//
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
          // "&$error": {
          //   color: "#db3131",
          // },
        },
      },
    },
  });
  const [disableMobileNumber, setDisableMobileNumber] = React.useState([]);
  const [data, setData] = useState([]);
  const [personName, setPersonName] = React.useState([]);
  const [expandedinter, setExpandedinter] = React.useState(false);
  const [disableNext, setdisableNext] = useState(true);
  const [disableNext1, setdisableNext1] = useState(false);
  const [buttonDisable, setbuttonDisable] = useState(false);
  const handleChange = (panel) => (event, newExpanded) => {
    setExpandedinter(newExpanded ? panel : false);
  };
  const [expanded, setexpanded] = useState(true);
  const [expanded1, setexpanded1] = useState(false);
  const [checkicon, setcheckicon] = useState(false);
  const [checkicon1, setcheckicon1] = useState(false);
  // const [cancleicon, setcancleicon] = useState(false);
  const [radiobutton, setradiobutton] = useState(undefined);
  const [RadioGroupValues, setRadioGroupValues] = useState("");
  // console.log("09o", radiobutton);
  // const [RadioGroupValues1, setRadioGroupValues1] = useState();
  const [val, setval] = useState(false);
  const [scheduleTime, setscheduleTime] = useState();
  const [scheduleDate, setscheduleDate] = useState();
  const [TargettedArray, setTargettedArray] = useState();
  const [TemplateArray, setTemplateArray] = useState();
  const [open, setOpen] = useState();
  const [FilesImage, setFilesImage] = useState(null);
  // console.log("kkk", FilesImage);
  const [Textarea, setTextarea] = useState("");
  const [Textarea1, setTextarea1] = useState("");
  const [Textareadisabled, setTextareadisabled] = useState(false);
  const [senderId, setsenderId] = useState("");
  const [showradioerror, setshowradioerror] = useState(false);
  const [Language, setLanguage] = useState("");
  const [MSG, setMSG] = useState("");
  const [MSR, setMSR] = useState("");
  const [MST, setMST] = useState({});
  const [Bulkselector1, setBulkselector1] = useState([]);
  const [Bulkselector, setBulkselector] = useState([]);
  const [Target, setTarget] = useState("");
  const [pairdisable, setpairdisable] = useState(true);
  const [showchoosevalue, setshowchoosevalue] = useState(false);
  // const [value, setValue] = React.useState(null);
  const [value, setValue] = React.useState(
    moment(new Date()).subtract(5.5, "hours").add(20, "minutes")
  );
  // console.log("mkkk",value)
  const [calenderSchedule, setCalenderSchedule] = useState();
  const [testcampaign, settestcampaign] = useState("");
  const [hideSkeleton, setHideSkeleton] = useState();
  const customId1 = "custom-id-yess";
  const [onchangeradio, setOnchangeRadio] = useState();
  const [onchangeradioBulkGroup, setonchangeradioBulkGroup] = useState();
  const [TextArea1, setTextArea1] = useState("");
  const [valueResponse, setValueResponse] = useState("");
  const [CamapaignDropdown, setCamapaignDropdown] = useState(true);
  const [LanguageData, setLanguageData] = useState([]);
  const [LangId, setLangId] = useState(undefined);
  const [lang, setLang] = useState();
  const [mobileNumbers, setMobileNumbers] = React.useState("");
  const [Radiosdisabled, setRadiosdisabled] = useState({
    textarea: true,
    bulk: true,
    bulk1: true,
    choose: true,
  });

  const [state, setState] = React.useState({
    files: [],
  });
  const [checked, setChecked] = React.useState(false);
  const handleChangetoogle = (event) => {
    setChecked(event.target.checked);
  };
  const [checkedRecurring, setCheckedRecurring] = React.useState(false);

  const handleChangetoogleRecurring = (event) => {
    setCheckedRecurring(event.target.checked);
    setStatusDropDown(null);
  };

  const [statusDropDown, setStatusDropDown] = React.useState("");
  const handleChangeRecurring = (event) => {
    setStatusDropDown(event.target.value);
  };

  //  console.log("first", checkedRecurring);
  const [ContactArray, SetContactArray] = useState([]);
  //  console.log("0999", checked);
  //  console.log("ab", statusDropDown);

  const FirstNext = () => {
    setexpanded1(true);
    setexpanded(false);
  };
  const SecondNext = () => {
    setexpanded1(false);
    // setexpanded(false);
  };
  const cuttt = useRef();
  const datereff = useRef();
  const initialValues = {
    campaignname: `SMS_CAMP_${Math.floor(Math.random() * 10000000000)}`,
    textarea: "",
    textarea1: "",
  };
  const regex = /^[0-9,]+$/;

  const validationSchema = yup.object({
    campaignname: yup
      .string()
      //   .min(1000000000, "Please type atleast 10 digits")
      //   .max(10000000000, "Maximum length of mobile number is 10")
      .required("Required"),
    textarea: yup
      .string("enter")
      .matches(regex, "Msisdn should be of type number only!")
      //   .min(1000000000, "Please type atleast 10 digits")
      //   .max(10000000000, "Maximum length of mobile number is 10")
      // .required("Required"),
      .nullable(),
    textarea1: yup
      .string()
      //   .min(1000000000, "Please type atleast 10 digits")
      //   .max(10000000000, "Maximum length of mobile number is 10")
      // .required("Required"),
      .nullable(),
  });
  // console.log("5t5t5t5t5t", RadioGroupValues, radiobutton);
  const formik = useFormik({
    initialValues: initialValues,
    validateOnChange: false,
    validationSchema: validationSchema,

    onSubmit: async (values) => {
      if (checkicon == false) {
        // alert("enter");
        // setexpanded(true);
      } else {
        if (radiobutton == "1" || radiobutton == undefined) {
          // alert("select 1");
          setshowradioerror(false);
          try {
            setOpen(true);

            const result = await common_axios.post(
              `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,

              {
                keywordRequest: {
                  keyword: values.textarea1,
                },
              }
              // `http://192.168.167.66:4900/user/phone-books/v1/list`
            );
            if (result.data.statusDescription.statusCode == 200) {
              setOpen(false);

              if (result.data) {
                try {
                  setOpen(true);
                  // alert("working");
                  const result = await common_axios.post(
                    `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign`,
                    {
                      campaignName: values.campaignname,
                      senderId: senderId.senderId,
                      channel: "web",
                      route: "quyeru",
                      templateId: MST == null ? "" : MST?.id,
                      templateMessage: values.textarea1,
                      smsType: MSG,
                      language: lang,
                      unicode: LangId == 1 ? "0" : "1",
                      message: values.textarea1,
                      campaignType: "Individual",
                      // manualMsisdnArray: values.textarea,
                      manualMsisdnArray: mobileNumbers,
                      campaignSource: "own_numbers_manual",
                      isRoleOver: checked,
                      // scheduledDatetime:"null"
                    }
                  );
                  // console.log("resultttttmainnnn", result);
                  if (result.data.statusDescription.statusCode == 200) {
                    setOpen(false);
                    // await setsenderId();
                    // await setMST("");
                    formik.handleReset();
                    setValue();
                    setCamapaignDropdown(!CamapaignDropdown);
                    dispatch(setCampaignState(!CamapaignDropdown));
                    setRadioGroupValues("");
                    dispatch(actionid("-1"));
                    //   dispatch(actionid("-1"));
                    history.replace("/dashboard/CampaignControl");
                    // dispatch(setDropDown(!true));
                    // setOnchangeRadio(null)
                    // formik.values.textarea==""
                    // alert("200");
                    // toast.success(result.data.statusDescription.statusMessage, {
                    //   theme: "colored",
                    //   toastId: customId1,
                    // });
                    Swal.fire({
                      icon: "success",
                      //  title: "Oops...",
                      text: result.data.statusDescription.statusMessage,
                      // footer: '<a href="">Why do I have this issue?</a>'
                    });
                    // history.replace("/dashboard/Smsdelivery");
                    // setTargettedArray(result?.data?.responseObject);
                  } else {
                    setOpen(false);
                    // toast.error(result.data.statusDescription.statusMessage, {
                    //   toastId: customId1,
                    //   theme: "colored",
                    // });
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: result.data.statusDescription.statusMessage,
                      // footer: '<a href="">Why do I have this issue?</a>'
                    });
                  }
                } catch (error) {
                  // alert("catch block");
                  setOpen(false);

                  // console.log(error);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Please Check Your Network",
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } else {
                setOpen(false);
                // toast.error("Keyword is Blocked", {
                //   toastId: customId1,
                //   theme: "colored",
                // });
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: result.data.statusDescription.statusdescription,
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
              // setValueResponse(result.data.value)
            } else if (result.data.statusDescription.statusCode == 204) {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
          } catch (error) {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Please Check Your Network",
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } else if (
          (radiobutton == "2" && RadioGroupValues == 2) ||
          RadioGroupValues == "on"
          // expandedinter === "panel2"
        ) {
          // alert("select 2");
          setshowradioerror(false);
          try {
            setOpen(true);

            const result = await common_axios.post(
              `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
              // {
              //   msisdn: "",
              //   msisdn_code: "",
              //   numberTypeB: "",
              //   numberTypeA: "",
              //   message: values.textarea1,
              // }
              {
                keywordRequest: {
                  keyword: values.textarea1,
                },
              }
              // `http://192.168.167.66:4900/user/phone-books/v1/list`
            );
            if (result.data.statusDescription.statusCode == 200) {
              setOpen(false);

              if (result.data) {
                try {
                  setOpen(true);
                  // alert("working");
                  const result = await common_axios.post(
                    `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign`,
                    {
                      campaignName: values.campaignname,
                      senderId: senderId.senderId,
                      channel: "web",
                      route: "quyeru",
                      templateId: MST == null ? "" : MST?.id,
                      language: lang,
                      templateMessage: values.textarea1,
                      smsType: MSG,
                      unicode: LangId == 1 ? "0" : "1",
                      message: values.textarea1,
                      campaignType: "Individual",
                      // manualMsisdnArray: values.textarea,
                      campaignSource: "own_numbers_phoneBook",
                      phoneBookId: Bulkselector,
                      isRoleOver: checked,
                    }
                  );
                  // console.log("resultttttmainnnn", result);
                  if (result.data.statusDescription.statusCode == 200) {
                    setOpen(false);
                    // alert("ok");
                    formik.handleReset();
                    setCamapaignDropdown(!CamapaignDropdown);
                    dispatch(setCampaignState(!CamapaignDropdown));
                    dispatch(actionid("-1"));
                    history.replace("/dashboard/CampaignControl");
                    Swal.fire({
                      icon: "success",
                      //  title: "Oops...",
                      text: result.data.statusDescription.statusMessage,
                      // footer: '<a href="">Why do I have this issue?</a>'
                    });
                    // history.replace("/dashboard/Smsdelivery");
                    // setTargettedArray(result?.data?.responseObject);
                  } else {
                    setOpen(false);
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: result.data.statusDescription.statusMessage,
                      // footer: '<a href="">Why do I have this issue?</a>'
                    });
                  }
                } catch (error) {
                  setOpen(false);
                  // });
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Please Check Your Network",
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } else {
                // toast.error("Keyword is Blocked", {
                //   toastId: customId1,
                //   theme: "colored",
                // });
                // });
                setOpen(false);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: result.data.statusDescription.statusdescription,
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
              // setValueResponse(result.data.value)
            } else if (result.data.statusDescription.statusCode == 204) {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
          } catch (error) {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Please Check Your Network",
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } else if (
          (radiobutton == "2" || radiobutton == undefined) &&
          RadioGroupValues == 3
        ) {
          // alert("select 3");
          setshowradioerror(false);
          try {
            setOpen(true);

            const result = await common_axios.post(
              `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
              // `http://192.168.167.66:4900/user/phone-books/v1/list`
              {
                keywordRequest: {
                  keyword: values.textarea1,
                },
              }
            );
            if (result.data.statusDescription.statusCode == 200) {
              setOpen(false);

              if (result.data) {
                try {
                  setOpen(true);
                  // alert("working");
                  const result = await common_axios.post(
                    `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign`,
                    {
                      campaignName: values.campaignname,
                      senderId: senderId.senderId,
                      channel: "web",
                      route: "quyeru",
                      templateId: MST == null ? "" : MST?.id,
                      language: lang,
                      templateMessage: values.textarea1,
                      smsType: MSG,
                      unicode: LangId == 1 ? "0" : "1",
                      message: values.textarea1,
                      campaignType: "Individual",
                      // manualMsisdnArray: values.textarea,
                      campaignSource: "own_numbers_bulkPhoneBook",
                      bulkPhoneBookId: Bulkselector1,
                      isRoleOver: checked,
                    }
                  );
                  // console.log("resultttttmainnnn", result);
                  if (result.data.statusDescription.statusCode == 200) {
                    setOpen(false);
                    // alert("ok");
                    formik.handleReset();
                    setCamapaignDropdown(!CamapaignDropdown);
                    dispatch(setCampaignState(!CamapaignDropdown));
                    dispatch(setDropDown(!true));
                    await dispatch(actionid("-1"));
                    history.replace("/dashboard/CampaignControl");

                    Swal.fire({
                      icon: "success",
                      //  title: "Oops...",
                      text: result.data.statusDescription.statusMessage,
                      // footer: '<a href="">Why do I have this issue?</a>'
                    });

                    // history.replace("/dashboard/Smsdelivery");
                    // setTargettedArray(result?.data?.responseObject);
                  } else {
                    setOpen(false);
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: result.data.statusDescription.statusMessage,
                      // footer: '<a href="">Why do I have this issue?</a>'
                    });
                    // toast.error(result.data.statusDescription.statusMessage, {
                    //   theme: "colored",
                    //   toastId: customId1,
                    // });
                  }
                } catch (error) {
                  setOpen(false);

                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Please Check Your Network",
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } else {
                setOpen(false);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: result.data.statusDescription.statusdescription,
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
              // setValueResponse(result.data.value)
            } else if (result.data.statusDescription.statusCode == 204) {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Please Check Your Network",
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } else if (
          (radiobutton == "1" || radiobutton == undefined) &&
          RadioGroupValues == 4
          //   ||
          // RadioGroupValues
        ) {
          // alert("select 4");
          setshowradioerror(false);
        } else if (
          radiobutton == "1" ||
          (radiobutton == undefined && RadioGroupValues == "")
        ) {
          // alert("choose numbers ");
          setshowradioerror(true);
          setexpanded(false);
          setexpanded1(true);
        }
        // else {
        //   // alert("choose numbers ");
        //   setshowradioerror(true);
        //   setexpanded(false);
        //   setexpanded1(true);
        // }
        else if (radiobutton == "4") {
          // alert("radio 3");
          setshowradioerror(false);
          setRadioGroupValues("");
          try {
            setOpen(true);

            const result = await common_axios.post(
              `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
              {
                keywordRequest: {
                  keyword: values.textarea1,
                },
              }
              // `http://192.168.167.66:4900/user/phone-books/v1/list`
            );
            if (result.data.statusDescription.statusCode == 200) {
              setOpen(false);
              if (result.data) {
                try {
                  setOpen(true);
                  const formData = new FormData();
                  // formData.append("contactListFile", FilesImage);
                  // console.log("rr", formData);

                  // formData.append("contactList", FilesImage);
                  state?.files?.map((file) => {
                    formData.append("contactList", file);
                  });
                  formData.append("campaignName", values.campaignname);
                  formData.append("senderId", senderId.senderId);
                  formData.append("channel", "web");
                  formData.append("route", "quyeru");
                  formData.append("templateId", MST == null ? "" : MST?.id);
                  formData.append("templateMessage", values.textarea1);
                  formData.append("smsType", MSG);
                  formData.append("unicode", LangId == 1 ? "0" : "1");
                  // unicode: LangId ==1 ? "0" : "1",

                  formData.append("language", lang);
                  formData.append("message", values.textarea1);
                  formData.append("campaignType", "Individual");
                  formData.append("isRoleOver", checked);

                  formData.append("campaignSource", "own_numbers_file");

                  // alert("working");
                  const result = await common_axios.post(
                    `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v2/create-campaign/file`,
                    formData
                  );
                  // console.log("resultttttmainnnn", result);
                  if (result.data.statusDescription.statusCode == 200) {
                    setOpen(false);
                    setValue();
                    // document.getElementById("fileName").value = "";
                    document.getElementById("formFileLg").value = "";
                    // setState([]);
                    formik.handleReset();
                    setCamapaignDropdown(!CamapaignDropdown);
                    dispatch(setCampaignState(!CamapaignDropdown));
                    dispatch(actionid("-1"));
                    history.replace("/dashboard/CampaignControl");

                    Swal.fire({
                      icon: "success",
                      //  title: "Oops...",
                      text: result.data.statusDescription.statusMessage,
                      // footer: '<a href="">Why do I have this issue?</a>'
                    });
                    // history.replace("/dashboard/Smsdelivery");
                    // setTargettedArray(result?.data?.responseObject);
                  } else {
                    setOpen(false);
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: result.data.statusDescription.statusMessage,
                      // footer: '<a href="">Why do I have this issue?</a>'
                    });
                  }
                } catch (error) {
                  // console.log("dd", error);
                  setOpen(false);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Please Check Your Network",
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } else {
                setOpen(false);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: result.data.statusDescription.statusdescription,
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
              // setValueResponse(result.data.value)
            } else if (result.data.statusDescription.statusCode == 204) {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
          } catch (error) {
            // console.log("ff", error);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Please Check Your Network",
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } else if (radiobutton == "3") {
          //  alert("radio 3");
          setshowradioerror(false);
          setRadioGroupValues("");
          try {
            setOpen(true);

            const result = await common_axios.post(
              `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
              {
                keywordRequest: {
                  keyword: values.textarea1,
                },
              }
              // `http://192.168.167.66:4900/user/phone-books/v1/list`
            );
            if (result.data.statusDescription.statusCode == 200) {
              setOpen(false);
              if (result.data) {
                try {
                  setOpen(true);
                  // alert("working");
                  const result = await common_axios.post(
                    `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign`,
                    {
                      campaignName: values.campaignname,
                      senderId: senderId.senderId,
                      channel: "web",
                      route: "quyeru",
                      templateId: MST == null ? "" : MST?.id,
                      language: lang,
                      templateMessage: values.textarea1,
                      smsType: MSG,
                      unicode: LangId == 1 ? "0" : "1",
                      message: values.textarea1,
                      campaignType: "Individual",
                      // manualMsisdnArray: values.textarea,
                      campaignSource: "all_numbers",
                      userId: Number(localStorage.getItem("UserId")),
                      isRoleOver: checked,
                    }
                  );
                  // console.log("resultttttmainnnn", result);
                  if (result.data.statusDescription.statusCode == 200) {
                    setOpen(false);
                    setValue();
                    formik.handleReset();
                    setCamapaignDropdown(!CamapaignDropdown);
                    // dispatch(setCampaignState(!CamapaignDropdown));
                    dispatch(actionid("-1"));
                    history.replace("/dashboard/CampaignControl");

                    Swal.fire({
                      icon: "success",
                      //  title: "Oops...",
                      text: result.data.statusDescription.statusMessage,
                      // footer: '<a href="">Why do I have this issue?</a>'
                    });
                    // history.replace("/dashboard/Smsdelivery");
                    // setTargettedArray(result?.data?.responseObject);
                  } else {
                    setOpen(false);
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: result.data.statusDescription.statusMessage,
                      // footer: '<a href="">Why do I have this issue?</a>'
                    });
                  }
                } catch (error) {
                  setOpen(false);

                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Please Check Your Network",
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } else {
                setOpen(false);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: result.data.statusDescription.statusdescription,
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
              // setValueResponse(result.data.value)
            } else if (result.data.statusDescription.statusCode == 204) {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Please Check Your Network",
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        }
      }
    },
  });

  const accordionchange = () => {
    // if (expanded != undefined) {
    setexpanded(!expanded);
    // setexpanded1(!expanded1);
    // }
    // await
  };
  const accordionchange1 = () => {
    // if (expanded != undefined) {
    setexpanded1(!expanded1);
    // setexpanded(!expanded);
  };
  const CallbackSender = (child) => {
    // console.log(child, "ddeessenedndndrr");
    setsenderId(child);
  };
  const CallbackMessage = (child) => {
    // console.log(child, "ui");
    setLanguage(child?.year);
    setLangId(child?.id);
    setLang(child?.lang);
  };
  const callbackMSG = (child) => {
    // console.log(child);
    setMSG(child?.label);
  };
  const callbackMSR = (child) => {
    // console.log(child);
    setMSR(child?.label);
  };
  const callbackMST = async (child) => {
    // console.log("88776655", child);
    await setMST(child);

    // formik.setFieldValue("textarea1", child?.year, false);
    // setTextarea1(child?.year);
  };
  const callbackTarget = (child) => {
    // console.log("targetted value", child);
    setTarget(child);
  };
  const callbackBulkSelector = (child) => {
    // console.log("parentcallfkhfsbjsb", child);
    setBulkselector(child);
  };
  // console.log("nhh", Bulkselector);
  const callbackBulkSelector1 = (child) => {
    // console.log("callbackSchedule1", child);
    setBulkselector1(child);
  };
  const callbackSchedule = (child) => {
    setscheduleTime(child?.slice("11", "16"));
    setscheduleDate(child?.slice("0", "10"));
    // setTarget(child);
  };
  const callbackRadio = (child) => {
    setradiobutton(child);
  };

  useEffect(() => {
    setFilesImage(null);
  }, [radiobutton]);

  useEffect(() => {
    setBulkselector([]);
    setBulkselector1([]);
  }, [radiobutton]);

  const handleChangeRadio = (e) => {
    if (e.target.checked == true) {
      setRadioGroupValues(e.target.value);
    }

    // setFilesImage(null)
  };

  const getImage = (e, index) => {
    let img = e.target.files;
    // console.log("imp--", img);
    let temp = [];

    for (let i = 0; i < img.length; i++) {
      temp.push(img[i]);
    }
    const allowedExtensions = [".csv", ".txt"];
    if (img?.length < 6) {
      for (let j = 0; j < img.length; j++) {
        const file = img[j];
        const fileExtension = file.name.split(".").pop();

        if (!allowedExtensions.includes(`.${fileExtension}`)) {
          // Handle invalid file extension
          // console.log(`Invalid file extension: ${file.name}`);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Csv and txt files are allowed!",
            // footer: '<a href="">Why do I have this issue?</a>'
          });

          document.getElementById("fileName").value = "";

          return;
        } else {
          setFilesImage(temp);
        }
      }
    } else {
      setFilesImage(null);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "You can only upload upto 5 files!",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // };

  const gettemplate = async () => {
    try {
      setHideSkeleton(true);
      // alert("working");
      const res1 = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/admin/templates/status`
      );
      // console.log("resultttttaaa", res1);
      if (res1.data.statusDescription.statusCode == 200) {
        setHideSkeleton(false);
        // alert("ok");
        // toast.success("api hitted");
        setTemplateArray(res1?.data?.listOfTemplates);
      } else {
        setHideSkeleton(false);
        // toast.error(res1.data.statusDescription.statusMessage, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res1.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setHideSkeleton(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const scheduleapi = async (e) => {
    e.preventDefault();
    // alert("shedule is working");

    if (checkicon == false) {
      // alert("enter");
      // setexpanded(true);
    } else {
      if (radiobutton == "1" || radiobutton == undefined) {
        // alert("select 1");
        setshowradioerror(false);
        try {
          setOpen(true);

          const result = await common_axios.post(
            `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,

            {
              keywordRequest: {
                keyword: formik.values.textarea1,
              },
            }
          );
          if (result.data.statusDescription.statusCode == 200) {
            setOpen(false);

            if (result.data) {
              try {
                setOpen(true);
                // alert("working");
                const result = await common_axios.post(
                  `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/schedule-campaign`,
                  {
                    campaignName: formik.values.campaignname,
                    senderId: senderId.senderId,
                    channel: "web",
                    route: "quyeru",
                    templateId: MST == null ? "" : MST?.id,
                    templateMessage: formik.values.textarea1,
                    smsType: MSG,
                    unicode: LangId == 1 ? "0" : "1",
                    message: formik.values.textarea1,
                    language: lang,
                    // campaignType: "Individual",
                    campaignType:
                      checkedRecurring == true
                        ? "Recurring Campaign"
                        : "Individual",
                    // manualMsisdnArray: formik.values.textarea,
                    manualMsisdnArray: mobileNumbers,
                    campaignSource: "own_numbers_manual",
                    scheduledDatetime: moment(value)?.format(
                      "YYYY-MM-DD HH:mm:ss"
                    ),
                    reccuringType: statusDropDown,
                    isRoleOver: checked,
                  }
                );
                // console.log("resultttttmainnnn", result);
                if (result.data.statusDescription.statusCode == 200) {
                  setOpen(false);
                  // alert("ok");
                  formik.handleReset();
                  setCamapaignDropdown(!CamapaignDropdown);
                  dispatch(setCampaignState(!CamapaignDropdown));
                  // dispatch(setDropDown(!true));

                  Swal.fire({
                    icon: "success",
                    //  title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                  dispatch(actionid("1"));
                  history.replace("/dashboard/CampaignControl");
                  // setTargettedArray(result?.data?.responseObject);
                } else {
                  setOpen(false);

                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } catch (error) {
                setOpen(false);

                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Please Check Your Network",
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
            // setValueResponse(result.data.value)
          } else if (result.data.statusDescription.statusCode == 204) {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          } else {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } catch (error) {
          setOpen(false);

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Please Check Your Network",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (
        (radiobutton == "2" && RadioGroupValues == 2) ||
        RadioGroupValues == "on"
        // expandedinter === "panel2"
      ) {
        // alert("select 2");
        setshowradioerror(false);
        try {
          setOpen(true);

          const result = await common_axios.post(
            `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
            {
              keywordRequest: {
                keyword: formik.values.textarea1,
              },
            }
          );
          if (result.data.statusDescription.statusCode == 200) {
            setOpen(false);

            if (result.data) {
              try {
                setOpen(true);
                // alert("working");
                const result = await common_axios.post(
                  `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/schedule-campaign`,
                  {
                    campaignName: formik.values.campaignname,
                    senderId: senderId.senderId,
                    channel: "web",
                    route: "quyeru",
                    templateId: MST == null ? "" : MST?.id,
                    templateMessage: formik.values.textarea1,
                    smsType: MSG,
                    unicode: LangId == 1 ? "0" : "1",
                    language: lang,
                    message: formik.values.textarea1,
                    campaignType: "Individual",
                    campaignSource: "own_numbers_phoneBook",
                    phoneBookId: Bulkselector,
                    scheduledDatetime: moment(value)?.format(
                      "YYYY-MM-DD HH:mm:ss"
                    ),
                    reccuringType: statusDropDown,
                    isRoleOver: checked,
                  }
                );
                if (result.data.statusDescription.statusCode == 200) {
                  setOpen(false);
                  formik.handleReset();
                  setCamapaignDropdown(!CamapaignDropdown);
                  dispatch(setCampaignState(!CamapaignDropdown));
                  dispatch(actionid("1"));
                  history.replace("/dashboard/CampaignControl");
                  Swal.fire({
                    icon: "success",
                    //  title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                } else {
                  setOpen(false);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } catch (error) {
                setOpen(false);

                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Please Check Your Network",
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
            // setValueResponse(result.data.value)
          } else if (result.data.statusDescription.statusCode == 204) {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          } else {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } catch (error) {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Please Check Your Network",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (
        (radiobutton == "2" || radiobutton == undefined) &&
        RadioGroupValues == 3
      ) {
        // alert("select 3");
        setshowradioerror(false);
        try {
          setOpen(true);

          const result = await common_axios.post(
            `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
            {
              keywordRequest: {
                keyword: formik.values.textarea1,
              },
            }
          );
          if (result.data.statusDescription.statusCode == 200) {
            setOpen(false);

            if (result.data) {
              try {
                setOpen(true);
                // alert("working");
                const result = await common_axios.post(
                  `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/schedule-campaign`,
                  {
                    campaignName: formik.values.campaignname,
                    senderId: senderId.senderId,
                    channel: "web",
                    route: "quyeru",
                    templateId: MST == null ? "" : MST?.id,
                    language: lang,
                    templateMessage: formik.values.textarea1,
                    smsType: MSG,
                    unicode: LangId == 1 ? "0" : "1",
                    message: formik.values.textarea1,
                    campaignType: "Individual",
                    campaignSource: "own_numbers_bulkPhoneBook",
                    bulkPhoneBookId: Bulkselector1,
                    scheduledDatetime: moment(value)?.format(
                      "YYYY-MM-DD HH:mm:ss"
                    ),
                    reccuringType: statusDropDown,
                    isRoleOver: checked,
                  }
                );
                // console.log("resultttttmainnnn", result);
                if (result.data.statusDescription.statusCode == 200) {
                  setOpen(false);
                  formik.handleReset();
                  setCamapaignDropdown(!CamapaignDropdown);
                  dispatch(setCampaignState(!CamapaignDropdown));
                  dispatch(actionid("1"));
                  history.replace("/dashboard/CampaignControl");
                  // dispatch(setDropDown(!true));
                  // alert("ok");
                  Swal.fire({
                    icon: "success",
                    //  title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                } else {
                  setOpen(false);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } catch (error) {
                setOpen(false);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Please Check Your Network",
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
          } else if (result.data.statusDescription.statusCode == 204) {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          } else {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } catch (error) {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Please Check Your Network",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (
        (radiobutton == "1" || radiobutton == undefined) &&
        RadioGroupValues == 4
        //   ||
        // RadioGroupValues
      ) {
        // alert("select 4");
        setshowradioerror(false);
      } else if (
        radiobutton == "1" ||
        (radiobutton == undefined && RadioGroupValues == "")
      ) {
        // alert("choose numbers ");
        setshowradioerror(true);
        setexpanded(false);
        setexpanded1(true);
      }
      // else {
      //   // alert("choose numbers ");
      //   setshowradioerror(true);
      //   setexpanded(false);
      //   setexpanded1(true);
      // }
      else if (radiobutton == "4") {
        // alert("radio 3");
        setshowradioerror(false);
        setRadioGroupValues("");
        try {
          setOpen(true);

          const result = await common_axios.post(
            `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
            {
              keywordRequest: {
                keyword: formik.values.textarea1,
              },
            }
            // `http://192.168.167.66:4900/user/phone-books/v1/list`
          );
          if (result.data.statusDescription.statusCode == 200) {
            setOpen(false);

            if (result.data) {
              try {
                setOpen(true);
                const formData = new FormData();
                // formData.append("contactListFile", FilesImage);
                // console.log("rr", formData);
                // formData.append("contactList", FilesImage);
                state?.files.map((file) => {
                  formData.append("contactList", file);
                });

                formData.append("campaignName", formik.values.campaignname);
                formData.append("senderId", senderId.senderId);
                formData.append("channel", "web");
                formData.append("route", "quyeru");
                formData.append("templateId", MST == null ? "" : MST?.id);
                formData.append("templateMessage", formik.values.textarea1);
                formData.append("smsType", MSG);
                formData.append("unicode", LangId == 1 ? "0" : "1");
                // unicode: LangId ==1 ? "0" : "1",
                formData.append("language", lang);
                formData.append("message", formik.values.textarea1);
                // formData.append("campaignType", "Individual");
                formData.append(
                  "campaignType",
                  checkedRecurring == true ? "Recurring Campaign" : "Individual"
                );

                formData.append("campaignSource", "own_numbers_file");
                formData.append("isRoleOver", checked);
                formData.append("reccuringType", statusDropDown);
                formData.append(
                  // "scheduledDatetime",
                  // // new Date().toJSON().slice(0, 16)
                  // moment(new Date())?.format("YYYY-MM-DD hh:mm:ss")
                  "scheduledDatetime",
                  moment(value)?.format("YYYY-MM-DD HH:mm:ss")
                );
                // scheduledDatetime: moment(value?.$d)?.format(
                //   "YYYY-MM-DD HH:mm:ss"
                // ),
                // alert("working");
                const result = await common_axios.post(
                  `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v2/schedule-campaign/file`,
                  formData
                );
                // console.log("resultttttmainnnn", result);
                if (result.data.statusDescription.statusCode == 200) {
                  setOpen(false);
                  // document.getElementById("fileName").value = "";
                  document.getElementById("formFileLg").value = "";
                  formik.handleReset();
                  setCamapaignDropdown(!CamapaignDropdown);
                  dispatch(setCampaignState(!CamapaignDropdown));
                  dispatch(actionid("1"));
                  history.replace("/dashboard/CampaignControl");
                  Swal.fire({
                    icon: "success",
                    //  title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                  // history.replace("/dashboard/Smsdelivery");
                  // setTargettedArray(result?.data?.responseObject);
                } else {
                  setOpen(false);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } catch (error) {
                setOpen(false);

                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Please Check Your Network",
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
            // setValueResponse(result.data.value)
          } else if (result.data.statusDescription.statusCode == 204) {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          } else {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } catch (error) {
          setOpen(false);

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Please Check Your Network",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (radiobutton == "3") {
        //  alert("radio 3");
        setshowradioerror(false);
        setRadioGroupValues("");
        try {
          setOpen(true);

          const result = await common_axios.post(
            `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
            {
              keywordRequest: {
                keyword: formik.values.textarea1,
              },
            }
            // `http://192.168.167.66:4900/user/phone-books/v1/list`
          );
          if (result.data.statusDescription.statusCode == 200) {
            setOpen(false);
            if (result.data) {
              try {
                setOpen(true);
                // alert("working");
                const result = await common_axios.post(
                  `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/schedule-campaign/file`,
                  {
                    campaignName: formik.values.campaignname,
                    senderId: senderId.senderId,
                    channel: "web",
                    route: "quyeru",
                    templateId: MST == null ? "" : MST?.id,
                    language: lang,
                    templateMessage: formik.values.textarea1,
                    smsType: MSG,
                    unicode: LangId == 1 ? "0" : "1",
                    message: formik.values.textarea1,
                    campaignType: "Individual",
                    // manualMsisdnArray: values.textarea,
                    campaignSource: "all_numbers",
                    userId: Number(localStorage.getItem("UserId")),
                    reccuringType: statusDropDown,
                    isRoleOver: checked,
                  }
                );
                // console.log("resultttttmainnnn", result);
                if (result.data.statusDescription.statusCode == 200) {
                  setOpen(false);
                  setValue();
                  formik.handleReset();
                  setCamapaignDropdown(!CamapaignDropdown);
                  // dispatch(setCampaignState(!CamapaignDropdown));
                  dispatch(actionid("-1"));
                  history.replace("/dashboard/CampaignControl");

                  Swal.fire({
                    icon: "success",
                    //  title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                  // history.replace("/dashboard/Smsdelivery");
                  // setTargettedArray(result?.data?.responseObject);
                } else {
                  setOpen(false);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } catch (error) {
                setOpen(false);

                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Please Check Your Network",
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
            // setValueResponse(result.data.value)
          } else if (result.data.statusDescription.statusCode == 204) {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          } else {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Please Check Your Network",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    }
  };

  const TestCampaign = async (e) => {
    cuttt?.current?.click();
    e.preventDefault();
    try {
      // setOpen(true);
      // if (result.data.statusDescription.statusCode == 200) {
      //   setOpen(false);
      //   // alert("ok");
      //   cuttt?.current?.click();
      //   toast.success("Campaign Tested Successfully", {
      //     theme: "colored",
      //   });
      //   // setshowsendnow(true);
      //   // setshowtextsuccessofschedule(true);
      //   // history.replace("/dashboard/ViewVoiceCampaigns");
      //   // setTargettedArray(result?.data?.responseObject);
      // } else {
      //   setOpen(false);
      //   toast.error(result.data.statusDescription.statusMessage, {
      //     theme: "colored",
      //   });
      //   cuttt?.current?.click();
      // }
    } catch (error) {
      // alert("catch block");
      cuttt?.current?.click();
      setOpen(false);
      // console.log(error);
    }
  };

  React.useEffect(() => {
    // getdetails();
    // gettemplate();
  }, []);

  useEffect(() => {
    if (MST == undefined) {
      setTextareadisabled(false);
      formik.setFieldValue("textarea1", "", false);
    } else if (MST == null) {
      setMST("");
    } else {
      setTextareadisabled(true);
      formik.setFieldValue("textarea1", MST?.year, false);
    }
  }, [MST]);

  useEffect(() => {
    if (RadioGroupValues == 1) {
      setRadiosdisabled({
        textarea: false,
        bulk: true,
        bulk1: true,
        choose: true,
      });
      setshowradioerror(false);
    } else if (RadioGroupValues == 2) {
      setRadiosdisabled({
        textarea: true,
        bulk: false,
        bulk1: true,
        choose: true,
      });
      setshowradioerror(false);
    } else if (RadioGroupValues == 3) {
      setRadiosdisabled({
        textarea: true,
        bulk: true,
        bulk1: false,
        choose: true,
      });
      setshowradioerror(false);
    } else if (RadioGroupValues == 4) {
      setRadiosdisabled({
        textarea: true,
        bulk: true,
        bulk1: true,
        choose: false,
      });
      setshowradioerror(false);
    }
  }, [RadioGroupValues]);
  useEffect(() => {
    if (Radiosdisabled.choose == true) {
      setshowchoosevalue(true);
    } else {
      setshowchoosevalue(false);
    }
  }, [Radiosdisabled]);

  useEffect(() => {
    if (Radiosdisabled.textarea == true) {
      // alert("run");
      setTextarea("");
      formik.setFieldValue("textarea", "", false);
    }
  }, [Radiosdisabled]);

  useEffect(() => {
    if (radiobutton != "1") {
      setRadiosdisabled({
        textarea: true,
        bulk: true,
        bulk1: true,
        choose: true,
      });
      setRadioGroupValues("");
    }
  }, [radiobutton]);

  // useEffect(() => {
  //   document?.getElementById("area")?.addEventListener("input", function (e) {
  //     var valueeee = e.target.value;
  //     var valueeee = valueeee
  //       ?.replace(/\D/g, "")
  //       // const regex = /^[0-9\,]+$/;
  //       const regex =  /^[0-9,]+$/;
  //     formik.setFieldValue("textarea", valueeee[0], false);
  //   });
  // }, [RadioGroupValues]);

  useEffect(() => {
    if (
      formik.values.textarea1 == "" ||
      formik.values.campaignname == "" ||
      senderId == undefined ||
      MSG == undefined ||
      LangId == undefined
    ) {
      // alert("runnerrr");
      setcheckicon(false);
      setdisableNext(true);
    } else {
      setcheckicon(true);
      setdisableNext(false);
    }
  }, [
    senderId,
    MSG,
    MSR,
    Language,
    formik.values.textarea1,
    formik.values.campaignname,
  ]);

  useEffect(() => {
    if (
      (radiobutton === "1" || radiobutton == undefined) &&
      (Bulkselector != undefined ||
        Bulkselector1 != undefined ||
        formik.values.textarea != "" ||
        FilesImage != null)
    ) {
      // alert("runnner");
      setcheckicon1(true);

      setdisableNext1(false);
    } else if (radiobutton === "3") {
      // alert("runnner   3");
      setcheckicon1(true);
      setdisableNext1(false);
    } else {
      // alert("runnner else");
      setcheckicon1(false);
      setdisableNext1(true);
    }
  }, [
    radiobutton,
    Bulkselector1,
    Bulkselector,
    formik.values.textarea,
    FilesImage,
    Target,
  ]);

  useEffect(() => {
    if (checkicon == true && checkicon1 == true) {
      setpairdisable(false);
    } else {
      setpairdisable(true);
    }
    //  else if (showtextsuccessofschedule == true) {
    //   setpairdisable(true);
    // }
  }, [checkicon1, checkicon]);
  // .......................................Phonebook API.................................//

  async function PhonebookGet(values) {
    try {
      setHideSkeleton(true);
      let res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/bulk-group/get/phone-book/list`
      );
      if (res.data.statusdescription.statusCode == 200) {
        setHideSkeleton(false);
        const mapp = res.data.listOfPlaysmsPhonebook.map(
          (x) => x.phonebookDescription
        );
        if (!mapp.includes("Default")) {
          const obj = {
            id: 1,
            phonebookName: "Default",
          };
          res.data.listOfPlaysmsPhonebook.push(obj);
        }
        SetContactArray(res.data.listOfPlaysmsPhonebook);
      } else {
        // setOpen(false);
        setHideSkeleton(false);
        // toast.error(res.data.statusdescription.statusDescription, {
        //   toastId: customId1,
        //   theme: "colored",
        // });

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // setOpen(false);
      setHideSkeleton(false);

      // toast.error("Please Check Your Network", {
      //   toastId: customId1,
      //   theme: "colored",
      // });
    }
  }
  useEffect(() => {
    PhonebookGet();
  }, []);
  // .....................................................................................//
  // .....................................Bulk Group Get................................//
  async function BulkGroupGet(values) {
    try {
      const result = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/get-bulk-group`,
        {}
        // `http://192.168.167.66:4900/user/phone-books/v1/list`
      );
      if (result.data.statusdescription.statusCode == 200) {
        setHideSkeleton(false);
        const mapp = result.data.playsmsGroupPhonebooks.map(
          (x) => x.bulkGroupDescription
        );
        if (!mapp.includes("Default")) {
          const obj = {
            id: 1,
            bulkGroupName: "Default",
          };
          result.data.playsmsGroupPhonebooks.push(obj);
        }
        setData(result.data.playsmsGroupPhonebooks);

        // toast.success("Keyword deleted successfully!!", {
        //   theme: "colored",
        // });
      } else {
        setOpen(false);
        // toast.error(result.data.statusdescription.statusDescription,{
        //   toastId: customId1,
        // });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  // ........................................................................................//
  // .......................Keyword check api..............................................//
  async function LanguageGet(values) {
    try {
      const result = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/language`
        // `http://192.168.167.66:4900/user/phone-books/v1/list`
      );
      if (result.data.statusDescription.statusCode == 200) {
        setLanguageData(result.data.languages);
      } else {
        setOpen(false);
        // toast.error(result.data.statusdescription.statusDescription,{
        //   toastId: customId1,
        // });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  useEffect(() => {
    BulkGroupGet();
    LanguageGet();
  }, []);
  // useEffect(() => {
  //   let temp_arr = [];
  //   if (LangId != undefined) {
  //     for (let i = 0; i < LanguageData.length; i++) {
  //       if (LangId == LanguageData[i]?.id) {
  //         let x = LanguageData[i].templateModel;
  //         for (let j = 0; j < x.length; j++) {
  //           temp_arr.push(x[j]);
  //         }
  //       }
  //     }

  //     console.log("lkk", temp_arr);
  //     setTemplateArray(temp_arr);
  //   }
  // }, [LangId]);

  async function TemplateLanguageData(values) {
    try {
      setHideSkeleton(true);

      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v2/admin/templates/status`,
        // `http://192.168.167.66:4900/user/phone-books/v1/list`
        {
          language: LangId,
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        setHideSkeleton(false);

        setTemplateArray(result.data.listOfTemplates);
        // setLanguageData(result.data.languages);
      } else {
        // alert("hii");
        setTemplateArray([]);

        setHideSkeleton(false);
        // toast.error(result.data.statusDescription.statusMessage,{
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setHideSkeleton(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  useEffect(() => {
    if (LangId != undefined) {
      TemplateLanguageData();
    }
  }, [LangId]);

  // .................10 digit Phone number...........................//
  // console.log("first", mobileNumbers);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const handleChange10 = (event) => {
    let inputValue = event.target.value;
    if (inputValue.length < mobileNumbers.length) {
      // If a character was deleted
      const lastChar = mobileNumbers.charAt(mobileNumbers.length - 1);
      if (
        lastChar === "," &&
        inputValue.charAt(inputValue.length - 1) !== ","
      ) {
        // If the last character was a comma and the new value doesn't end with a comma
        inputValue = mobileNumbers.slice(0, -1); // Remove the comma
      }
    } else {
      // If a character was added
      inputValue = inputValue.replace(/[^0-9]/g, ""); // Remove all non-numeric characters
      inputValue = inputValue.replace(/(\d{11})/g, "$1,"); // Add a comma after every 10 digits
    }
    setMobileNumbers(inputValue);
  };

  React.useEffect(() => {
    let field = mobileNumbers?.split(",")?.map((arg) => {
      return arg.length == 11;
    });

    setDisableMobileNumber(field.splice(-1));
    // if (
    //   mobileNumbers?.split(",")?.length > 10 ||
    //   mobileNumbers?.split(",")?.length == 0
    // ) {
    //   setShowErrorMsg(false);
    // } else {
    //   setShowErrorMsg(true);
    // }
  }, [mobileNumbers]);

  // ...........................................................................................//
  const UploadFiles = (e) => {
    let fileArray = Array.from(e.target.files);
    let arrr = state.files?.length > 0 ? [...state.files] : [];
    for (let index = 0; index < fileArray.length; index++) {
      const element = fileArray[index];
      arrr.push(element);
    }

    arrr.concat(Array.from(e.target.files));
    setState({
      files: arrr,
    });

    let img = e.target.files;
    // console.log("imp--", img);
    let temp = [];

    for (let i = 0; i < img.length; i++) {
      temp.push(img[i]);
    }
    const allowedExtensions = [".csv", ".txt"];
    if (img?.length < 6) {
      for (let j = 0; j < img.length; j++) {
        const file = img[j];
        const fileExtension = file.name.split(".").pop();

        if (!allowedExtensions.includes(`.${fileExtension}`)) {
          // Handle invalid file extension
          // console.log(`Invalid file extension: ${file.name}`);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Csv and txt files are allowed!",
            // footer: '<a href="">Why do I have this issue?</a>'
          });

          document.getElementById("formFileLg").value = "";
          setState({
            files: [],
          });

          return;
        } else {
          // setFilesImage(temp);
        }
      }
    } else {
      // setFilesImage(null);
      document.getElementById("formFileLg").value = "";
      setState({
        files: [],
      });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "You can only upload upto 5 files!",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // ........................CreateCampaignApi..........................//

  const CreateCampaignApi = async () => {
    // alert("kk")
    // e.preventDefault();
    // alert("shedule is working");

    if (checkicon == false) {
      // alert("enter");
      // setexpanded(true);
    } else {
      if (radiobutton == "1" || radiobutton == undefined) {
        // alert("select 1");
        setshowradioerror(false);
        try {
          setOpen(true);

          const result = await common_axios.post(
            `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,

            {
              keywordRequest: {
                keyword: formik.values.textarea1,
              },
            }
          );
          if (result.data.statusDescription.statusCode == 200) {
            setOpen(false);
            // alert("kkkii")
            if (result.data) {
              try {
                const formData = new FormData();
                // formData.append("contactList", "");
                state?.files.map((file) => {
                  formData.append("contactList", "");
                });

                formData.append("campaignName", formik.values.campaignname);
                formData.append("senderId", senderId.senderId);
                formData.append("channel", "web");
                formData.append("route", "quyeru");
                formData.append("templateId", MST == null ? "" : MST?.id);
                formData.append("templateMessage", formik.values.textarea1);
                formData.append("smsType", MSG);
                formData.append("unicode", LangId == 1 ? "0" : "1");
                // unicode: LangId ==1 ? "0" : "1",
                formData.append("language", lang);
                formData.append("message", formik.values.textarea1);
                formData.append("campaignType", "Individual");
                formData.append("campaignSource", "own_numbers_manual");
                formData.append("manualMsisdnArray", mobileNumbers);
                formData.append("isRoleOver", checked);

                setOpen(true);
                // alert("working");
                const result = await common_axios.post(
                  `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign/later`,
                  formData
                  // {
                  //   campaignName: formik.values.campaignname,
                  //   senderId: senderId.senderId,
                  //   channel: "web",
                  //   route: "quyeru",
                  //   templateId: MST == null ? "" : MST?.id,
                  //   templateMessage: formik.values.textarea1,
                  //   smsType: MSG,
                  //   unicode: LangId == 1 ? "0" : "1",
                  //   message: formik.values.textarea1,
                  //   language: lang,
                  //   campaignType: "Individual",
                  //   manualMsisdnArray: mobileNumbers,
                  //   campaignSource: "own_numbers_manual",
                  //   contactList: null,
                  //   scheduledDatetime: moment(value)?.format(
                  //     "YYYY-MM-DD HH:mm:ss"
                  //   ),
                  // }
                );
                // console.log("resultttttmainnnn", result);
                if (result.data.statusDescription.statusCode == 200) {
                  setOpen(false);
                  //  alert("ok");
                  formik.handleReset();
                  setCamapaignDropdown(!CamapaignDropdown);
                  dispatch(setCampaignState(!CamapaignDropdown));
                  // dispatch(setDropDown(!true));

                  Swal.fire({
                    icon: "success",
                    //  title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                  dispatch(actionid("0"));
                  history.replace("/dashboard/CampaignControl");
                  // setTargettedArray(result?.data?.responseObject);
                } else {
                  setOpen(false);

                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } catch (error) {
                setOpen(false);

                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Please Check Your Network",
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
            // setValueResponse(result.data.value)
          } else if (result.data.statusDescription.statusCode == 204) {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          } else {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } catch (error) {
          setOpen(false);

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Please Check Your Network",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (
        (radiobutton == "2" && RadioGroupValues == 2) ||
        RadioGroupValues == "on"
        // expandedinter === "panel2"
      ) {
        // alert("select 2");
        setshowradioerror(false);
        try {
          setOpen(true);

          const result = await common_axios.post(
            `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
            {
              keywordRequest: {
                keyword: formik.values.textarea1,
              },
            }
          );
          if (result.data.statusDescription.statusCode == 200) {
            setOpen(false);

            if (result.data) {
              try {
                setOpen(true);
                // alert("working");
                const result = await common_axios.post(
                  `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign/later`,
                  {
                    campaignName: formik.values.campaignname,
                    senderId: senderId.senderId,
                    channel: "web",
                    route: "quyeru",
                    templateId: MST == null ? "" : MST?.id,
                    templateMessage: formik.values.textarea1,
                    smsType: MSG,
                    unicode: LangId == 1 ? "0" : "1",
                    language: lang,
                    message: formik.values.textarea1,
                    campaignType: "Individual",
                    campaignSource: "own_numbers_phoneBook",
                    phoneBookId: Bulkselector,
                    scheduledDatetime: moment(value)?.format(
                      "YYYY-MM-DD HH:mm:ss"
                    ),
                  }
                );
                if (result.data.statusDescription.statusCode == 200) {
                  setOpen(false);
                  formik.handleReset();
                  setCamapaignDropdown(!CamapaignDropdown);
                  dispatch(setCampaignState(!CamapaignDropdown));
                  dispatch(actionid("0"));
                  history.replace("/dashboard/CampaignControl");
                  Swal.fire({
                    icon: "success",
                    //  title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                } else {
                  setOpen(false);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } catch (error) {
                setOpen(false);

                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Please Check Your Network",
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
            // setValueResponse(result.data.value)
          } else if (result.data.statusDescription.statusCode == 204) {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          } else {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } catch (error) {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Please Check Your Network",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (
        (radiobutton == "2" || radiobutton == undefined) &&
        RadioGroupValues == 3
      ) {
        // alert("select 3");
        setshowradioerror(false);
        try {
          setOpen(true);

          const result = await common_axios.post(
            `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
            {
              keywordRequest: {
                keyword: formik.values.textarea1,
              },
            }
          );
          if (result.data.statusDescription.statusCode == 200) {
            setOpen(false);

            if (result.data) {
              try {
                setOpen(true);
                // alert("working");
                const result = await common_axios.post(
                  `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign/later`,
                  {
                    campaignName: formik.values.campaignname,
                    senderId: senderId.senderId,
                    channel: "web",
                    route: "quyeru",
                    templateId: MST == null ? "" : MST?.id,
                    language: lang,
                    templateMessage: formik.values.textarea1,
                    smsType: MSG,
                    unicode: LangId == 1 ? "0" : "1",
                    message: formik.values.textarea1,
                    campaignType: "Individual",
                    campaignSource: "own_numbers_bulkPhoneBook",
                    bulkPhoneBookId: Bulkselector1,
                    scheduledDatetime: moment(value)?.format(
                      "YYYY-MM-DD HH:mm:ss"
                    ),
                  }
                );
                // console.log("resultttttmainnnn", result);
                if (result.data.statusDescription.statusCode == 200) {
                  setOpen(false);
                  formik.handleReset();
                  setCamapaignDropdown(!CamapaignDropdown);
                  dispatch(setCampaignState(!CamapaignDropdown));
                  dispatch(actionid("0"));
                  history.replace("/dashboard/CampaignControl");
                  // dispatch(setDropDown(!true));
                  // alert("ok");
                  Swal.fire({
                    icon: "success",
                    //  title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                } else {
                  setOpen(false);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } catch (error) {
                setOpen(false);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Please Check Your Network",
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
          } else if (result.data.statusDescription.statusCode == 204) {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          } else {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } catch (error) {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Please Check Your Network",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (
        (radiobutton == "1" || radiobutton == undefined) &&
        RadioGroupValues == 4
        //   ||
        // RadioGroupValues
      ) {
        // alert("select 4");
        setshowradioerror(false);
      } else if (
        radiobutton == "1" ||
        (radiobutton == undefined && RadioGroupValues == "")
      ) {
        // alert("choose numbers ");
        setshowradioerror(true);
        setexpanded(false);
        setexpanded1(true);
      }
      // else {
      //   // alert("choose numbers ");
      //   setshowradioerror(true);
      //   setexpanded(false);
      //   setexpanded1(true);
      // }
      else if (radiobutton == "4") {
        // alert("radio 3");
        setshowradioerror(false);
        setRadioGroupValues("");
        try {
          setOpen(true);

          const result = await common_axios.post(
            `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
            {
              keywordRequest: {
                keyword: formik.values.textarea1,
              },
            }
            // `http://192.168.167.66:4900/user/phone-books/v1/list`
          );
          if (result.data.statusDescription.statusCode == 200) {
            setOpen(false);

            if (result.data) {
              try {
                setOpen(true);
                const formData = new FormData();
                // formData.append("contactListFile", FilesImage);
                // console.log("rr", formData);
                // formData.append("contactList", FilesImage);
                state?.files.map((file) => {
                  formData.append("contactList", file);
                });

                formData.append("campaignName", formik.values.campaignname);
                formData.append("senderId", senderId.senderId);
                formData.append("channel", "web");
                formData.append("route", "quyeru");
                formData.append("templateId", MST == null ? "" : MST?.id);
                formData.append("templateMessage", formik.values.textarea1);
                formData.append("smsType", MSG);
                formData.append("unicode", LangId == 1 ? "0" : "1");
                // unicode: LangId ==1 ? "0" : "1",
                formData.append("language", lang);
                formData.append("message", formik.values.textarea1);
                formData.append("campaignType", "Individual");
                formData.append("campaignSource", "own_numbers_file");
                formData.append("isRoleOver", checked);
                // scheduledDatetime: moment(value?.$d)?.format(
                //   "YYYY-MM-DD HH:mm:ss"
                // ),
                // alert("working");
                const result = await common_axios.post(
                  `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign/later`,
                  formData
                );
                // console.log("resultttttmainnnn", result);
                if (result.data.statusDescription.statusCode == 200) {
                  setOpen(false);
                  // document.getElementById("fileName").value = "";
                  document.getElementById("formFileLg").value = "";
                  formik.handleReset();
                  setCamapaignDropdown(!CamapaignDropdown);
                  dispatch(setCampaignState(!CamapaignDropdown));
                  dispatch(actionid("0"));
                  history.replace("/dashboard/CampaignControl");
                  Swal.fire({
                    icon: "success",
                    //  title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                  // history.replace("/dashboard/Smsdelivery");
                  // setTargettedArray(result?.data?.responseObject);
                } else {
                  setOpen(false);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } catch (error) {
                setOpen(false);

                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Please Check Your Network",
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
            // setValueResponse(result.data.value)
          } else if (result.data.statusDescription.statusCode == 204) {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          } else {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } catch (error) {
          setOpen(false);

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Please Check Your Network",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (radiobutton == "3") {
        //  alert("radio 3");
        setshowradioerror(false);
        setRadioGroupValues("");
        try {
          setOpen(true);

          const result = await common_axios.post(
            `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
            {
              keywordRequest: {
                keyword: formik.values.textarea1,
              },
            }
            // `http://192.168.167.66:4900/user/phone-books/v1/list`
          );
          if (result.data.statusDescription.statusCode == 200) {
            setOpen(false);
            if (result.data) {
              try {
                setOpen(true);
                // alert("working");
                const result = await common_axios.post(
                  `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/create-campaign/later`,
                  {
                    campaignName: formik.values.campaignname,
                    senderId: senderId.senderId,
                    channel: "web",
                    route: "quyeru",
                    templateId: MST == null ? "" : MST?.id,
                    language: lang,
                    templateMessage: formik.values.textarea1,
                    smsType: MSG,
                    unicode: LangId == 1 ? "0" : "1",
                    message: formik.values.textarea1,
                    campaignType: "Individual",
                    // manualMsisdnArray: values.textarea,
                    campaignSource: "all_numbers",
                    userId: Number(localStorage.getItem("UserId")),
                  }
                );
                // console.log("resultttttmainnnn", result);
                if (result.data.statusDescription.statusCode == 200) {
                  setOpen(false);
                  setValue();
                  formik.handleReset();
                  setCamapaignDropdown(!CamapaignDropdown);
                  // dispatch(setCampaignState(!CamapaignDropdown));
                  dispatch(actionid("0"));
                  history.replace("/dashboard/CampaignControl");

                  Swal.fire({
                    icon: "success",
                    //  title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                  // history.replace("/dashboard/Smsdelivery");
                  // setTargettedArray(result?.data?.responseObject);
                } else {
                  setOpen(false);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.data.statusDescription.statusMessage,
                    // footer: '<a href="">Why do I have this issue?</a>'
                  });
                }
              } catch (error) {
                setOpen(false);

                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Please Check Your Network",
                  // footer: '<a href="">Why do I have this issue?</a>'
                });
              }
            } else {
              setOpen(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.data.statusDescription.statusdescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
            // setValueResponse(result.data.value)
          } else if (result.data.statusDescription.statusCode == 204) {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          } else {
            setOpen(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.statusDescription.statusdescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Please Check Your Network",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    }
  };

  //...................................................................//

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <ThemeProvider theme={theme}>
          <section className="cmp">
            <div className="container-fluid">
              {/* <div className="row"> */}
              {/* <section className="col-md-9 right_panel px-0"> */}

              <div
                className="container-fluid_1 p-0"

                // style={{ border: "2px solid black", backgroundColor: "white" }}
              >
                <div className="card p-4">
                  <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 mt_n4 position-absolute">
                    <SmsIcon className="ttl_icon" />
                  </div>
                  <section className="mt-5">
                    <section className="marquee_8 modl">
                      <div className="d-flex justify-content-between">
                        <marquee>
                          This kind of ad campaign is a great wakeup call to
                          give to your target audience that is hard to miss.
                          Remind them why they should be excited about it.
                        </marquee>
                      </div>
                    </section>

                    <form
                      id="accord_8"
                      className="mt-4 m-0"
                      onSubmit={formik.handleSubmit}
                      role="form"
                    >
                      <Accordion
                        //  expanded={true}
                        expanded={expanded}
                        onChange={(e) => accordionchange()}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography>
                            <ForumIcon style={{ fontSize: "15px" }} />{" "}
                            <strong
                              style={{
                                fontWeight: "500",
                                fontFamily: "inherit",
                              }}
                            >
                              {" "}
                              Compose New Message{" "}
                            </strong>
                          </Typography>
                          <strong
                            style={{
                              color: "green",
                              fontSize: "17px",
                              // marginRight: "20px",
                            }}
                          >
                            {formik?.values?.textarea1?.length}
                          </strong>
                        </AccordionSummary>

                        <AccordionDetails>
                          <Typography>
                            {/* <div className="card shadow-none border bg_blue mt-5"> */}
                            <section className="sms_form_1" id="sms_form">
                              {/* <div className="row justify-content-between mx-0"> */}
                              <div className="sms_form_2 w- mx-auto  p-0 p-4">
                                <div className="row">
                                  <div className="col-md-6">
                                    <TextField
                                      autoComplete="on"
                                      className="ms-4 w-50"
                                      type="text"
                                      label="Campaign Name"
                                      name="campaignname"
                                      variant="outlined"
                                      size="small"
                                      required
                                      onChange={formik.handleChange}
                                      value={formik.values.campaignname}
                                      onBlur={formik.handleBlur}
                                      error={
                                        formik.touched.campaignname &&
                                        Boolean(formik.errors.campaignname)
                                      }
                                      helperText={
                                        formik.touched.campaignname &&
                                        formik.errors.campaignname
                                      }
                                    />
                                  </div>
                                  <div className="col-md-6 mt_3">
                                    <SenderIdSelector
                                      parentCallback={CallbackSender}
                                    />
                                  </div>
                                </div>
                                <div className="row my-3">
                                  <div className="col-md-6 position-relative">
                                    <label
                                      for="exampleInputText1"
                                      className="float-start d-flex align-items-center"
                                    ></label>

                                    <MessageChannelSelect
                                      required
                                      parentCallback={callbackMSG}
                                    />
                                  </div>

                                  <div className="col-md-6 mt_3">
                                    <MessageTextSelect
                                      parentCallback={CallbackMessage}
                                      LanguageData={LanguageData}
                                      MST={MST}
                                    />
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-md-6">
                                    {hideSkeleton == true ? (
                                      <>
                                        <Box sx={{ width: "100%" }}>
                                          <Skeleton />
                                          <Skeleton animation="wave" />
                                        </Box>
                                      </>
                                    ) : (
                                      <>
                                        <MessageTemplateSelect
                                          parentCallback={callbackMST}
                                          data={TemplateArray}
                                          LangId={LangId}
                                        />
                                      </>
                                    )}

                                    <div className="switch d-flex align-items-center flex-wrap mt-3">
                                      <div className="roll_over d-flex align-items-cente">
                                        <span className="fw-bold w-100 ms-2">
                                          Is it roll-over Campaign?
                                        </span>
                                      </div>
                                      <Switch
                                        checked={checked}
                                        onChange={handleChangetoogle}
                                        inputProps={{
                                          "aria-label": "controlled",
                                        }}
                                        style={{ flex: "0 0 auto" }}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6 mt_3">
                                    <TextareaAutosize
                                      // id="area"
                                      disabled={
                                        (LangId == undefined ||
                                          Textareadisabled) == true
                                          ? true
                                          : false
                                      }
                                      // disabled={Textareadisabled}
                                      className={
                                        formik.errors.message
                                          ? "border-color-red w-100 p-2"
                                          : "w-100  textarea_8 txtar_rad p-2"
                                      }
                                      textarea_8
                                      aria-label="empty textarea"
                                      placeholder=" Enter  Manually"
                                      name="textarea1"
                                      style={{
                                        width: " 650px",
                                        minHeight: "100px",
                                        // borderColor: " #48a8dd",
                                      }}
                                      maxlength="1000"
                                      // value={textarea}
                                      // required={RadioGroupValues == 1}
                                      required
                                      onChange={formik.handleChange}
                                      value={formik.values.textarea1}
                                      error={
                                        formik.touched.textarea1 &&
                                        Boolean(formik.errors.textarea1)
                                      }
                                      helperText={
                                        formik.touched.textarea1 &&
                                        formik.errors.textarea1
                                      }
                                    />
                                    <div className="d-flex justify-content-between align-items-center flex-wrap d_block mt-1">
                                      <div className="d-flex d_fx_1 align-items-center">
                                        <pre>
                                          <code>
                                            <p>
                                              Character length used:
                                              {
                                                formik?.values?.textarea1
                                                  ?.length
                                              }
                                            </p>

                                            <p>
                                              Disclaimer: This is only estimated
                                              counts
                                            </p>
                                            <p>
                                              Number of message used:
                                              {formik.values.lang == "English"
                                                ? parseInt(
                                                    formik?.values?.textarea1
                                                      ?.length /
                                                      160 +
                                                      1
                                                  )
                                                : parseInt(
                                                    formik?.values?.textarea1
                                                      ?.length /
                                                      70 +
                                                      1
                                                  )}
                                            </p>
                                            <p style={{ fontWeight: "bold" }}>
                                              {" "}
                                              <span
                                                style={{
                                                  color: "red",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                *
                                              </span>
                                              Only 1000 characters are allowed
                                            </p>
                                          </code>
                                        </pre>

                                        <div className="d-flex align-items-center ms-3 m_0">
                                          {/* <p className="text-capitalize m-0">
                                            count 0
                                          </p> */}

                                          <a
                                            href="#"
                                            className="d-block mx-2 mx_2"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal"
                                          >
                                            {/* <i className="fas fa-info-circle d-block btn_primary p-1"></i> */}
                                          </a>
                                        </div>
                                      </div>

                                      <div className="text-end mt-3">
                                        <button
                                          disabled={disableNext}
                                          type="button"
                                          // className="btn btn-success nx_pv m-0 opc_8"
                                          className={
                                            disableNext
                                              ? "btn btn-success nx_pv m-0 opc_8"
                                              : "btn btn-success nx_pv m-0"
                                          }
                                          onClick={FirstNext}
                                        >
                                          Next
                                          <ArrowRightAltRoundedIcon />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* </div> */}
                            </section>
                            {/* </div> */}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion
                        disabled={
                          formik.values.campaignname === "" ||
                          formik.values.textarea1 === "" ||
                          MSG === "" ||
                          senderId === "" ||
                          lang === ""
                            ? true
                            : false
                        }
                        expanded={expanded1}
                        onChange={(e) => accordionchange1()}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography>
                            <ContactsIcon style={{ fontSize: "15px" }} />{" "}
                            <strong
                              style={{
                                fontWeight: "500",
                                fontFamily: "inherit",
                              }}
                            >
                              Mobile Number
                            </strong>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            <section
                              className="sms_form_1 choose_file w-100"
                              id="sms_form"
                            >
                              <div className="sms_form_2 w- mx-auto p-0 p-2">
                                <div className="">
                                  {/* <label className="d-block text-capitalize">
                                numbers
                              </label> */}
                                  <TestRadio parentCallback={callbackRadio} />
                                  {(radiobutton == "1" ||
                                    radiobutton == undefined) && (
                                    <>
                                      <div id="bxg" className="bxg66">
                                        <label
                                          className="form-check-label"
                                          for="flexRadioDefault4"
                                        >
                                          <TextareaAutosize
                                            id="area"
                                            typeof="number"
                                            className={
                                              formik.errors.message
                                                ? "border-color-red w-100 w_100"
                                                : "w-100 w_100 textarea_8 label_67 p-1"
                                            }
                                            textarea_8
                                            aria-label="empty textarea"
                                            placeholder="Enter contact number( e.g. 22212345678) with comma separated"
                                            name="textarea"
                                            style={{
                                              width: " 650px",
                                              minHeight: "70px",
                                            }}
                                            minlength="10"
                                            required
                                            onChange={handleChange10}
                                            value={mobileNumbers}
                                            onKeyPress={(event) => {
                                              const keyCode =
                                                event.keyCode || event.which;

                                              if (
                                                (keyCode >= 48 &&
                                                  keyCode <= 57) ||
                                                keyCode == 44
                                              ) {
                                              } else {
                                                event.preventDefault();
                                              }
                                            }}
                                          />
                                          {mobileNumbers?.split(",").length >
                                            10 && (
                                            <>
                                              <div>
                                                <label
                                                  style={{
                                                    color: "#d32f2f",
                                                    textTransform: "initial",
                                                    fontSize: "0.95rem",
                                                    fontWeight: "400",
                                                    fontFamily:
                                                      '"Roboto","Helvetica","Arial",sans-serif',
                                                  }}
                                                >
                                                  Please provide max 10 mobile
                                                  numbers only!!
                                                </label>
                                              </div>
                                            </>
                                          )}
                                          {showErrorMsg == true &&
                                            disableMobileNumber[0] == false &&
                                            mobileNumbers?.split(",")?.length <=
                                              11 && (
                                              <>
                                                <div>
                                                  <label
                                                    style={{
                                                      color: "#d32f2f",
                                                      textTransform: "initial",
                                                      fontSize: "0.95rem",
                                                      fontWeight: "400",
                                                      fontFamily:
                                                        '"Roboto","Helvetica","Arial",sans-serif',
                                                    }}
                                                  >
                                                    {/* Please provide max 10 digits
                                                    mobile number only!! */}
                                                    Maximum length of mobile
                                                    number is 8
                                                  </label>
                                                </div>
                                              </>
                                            )}
                                        </label>
                                      </div>
                                      {/* <span className="ms-4" style={{ fontSize: "13px" }}>
                              (Only 10 mobile numbers are allowed)
                            </span> */}

                                      <p style={{}}>
                                        {" "}
                                        <span
                                          style={{
                                            color: "red",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          *
                                        </span>
                                        Only 10 mobile numbers are allowed
                                      </p>
                                      <div className="">
                                        {formik.errors.textarea && (
                                          <h4
                                            className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained MuiFormHelperText-filled Mui-required css-k4qjio-MuiFormHelperText-root"
                                            style={{ color: "red" }}
                                          >
                                            {formik.errors.textarea}
                                          </h4>
                                        )}
                                      </div>
                                    </>
                                  )}
                                  {radiobutton == "2" && (
                                    <div className="w-90">
                                      {/* <TargettedSelect
                                    parentCallback={callbackTarget}
                                    data={TargettedArray}
                                  /> */}

                                      <>
                                        <div id="bxg" className="bxg66">
                                          {showradioerror == true ? (
                                            <div
                                              style={{
                                                color: "#d32f2f",
                                                textAlign: "center",
                                              }}
                                            >
                                              Please Select One Of These Options
                                            </div>
                                          ) : (
                                            <div></div>
                                          )}
                                          <div className="" id="dv_bxg">
                                            <FormControl
                                              value={RadioGroupValues}
                                              onChange={handleChangeRadio}
                                            >
                                              <RadioGroup
                                                // value={RadioGroupValues1}
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                              >
                                                <div
                                                  className="row"
                                                  id="row_input"
                                                >
                                                  <div className="col-md-6">
                                                    <div className="d-flex">
                                                      <FormControlLabel
                                                        value={2}
                                                        control={<Radio />}
                                                        onChange={(event) => {
                                                          setOnchangeRadio(
                                                            event.target.value
                                                          );
                                                        }}
                                                      />

                                                      <BulkSelect
                                                        parentCallback={
                                                          callbackBulkSelector
                                                        }
                                                        ContactArray={
                                                          ContactArray
                                                        }
                                                        disabledval={
                                                          Radiosdisabled.bulk
                                                        }
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="col-md-6 mt_3">
                                                    <div className="d-flex">
                                                      <FormControlLabel
                                                        value={3}
                                                        control={<Radio />}
                                                        onChange={(event) => {
                                                          setonchangeradioBulkGroup(
                                                            event.target.value
                                                          );
                                                        }}
                                                      />

                                                      <BulkSelect1
                                                        parentCallback={
                                                          callbackBulkSelector1
                                                        }
                                                        data={data}
                                                        disabledval={
                                                          Radiosdisabled.bulk1
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </RadioGroup>
                                            </FormControl>
                                          </div>
                                        </div>
                                      </>
                                    </div>
                                  )}
                                  {radiobutton == "4" && (
                                    <div className="w-50">
                                      <>
                                        <div id="bxg" className="bxg66">
                                          {showradioerror == true ? (
                                            <div
                                              style={{
                                                color: "#d32f2f",
                                                textAlign: "center",
                                              }}
                                            >
                                              Please Select One Of These Options
                                            </div>
                                          ) : (
                                            <div></div>
                                          )}
                                          <div className="">
                                            <FormControl
                                              value={RadioGroupValues}
                                              onChange={handleChangeRadio}
                                            >
                                              <RadioGroup
                                                // value={RadioGroupValues1}
                                                row
                                                // onChange={handleChangeRadio}
                                                // defaultValue={1}
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                              >
                                                <div className="row align-items-center mt-2">
                                                  <div
                                                    className="col-md-5"
                                                    id="choose_file_label"
                                                  >
                                                    {/* <div
                                                      className="bx_flx bx_flex_1 mt-"
                                                      id="bx_flx"
                                                    >
                                                      <>
                                                        {" "}
                                                        <div className="w-100">
                                                          <div
                                                            class="  input-group m-0 mb-3"
                                                            id="input_group_8"
                                                          >
                                                            <Button
                                                              variant="contained"
                                                              component="label"
                                                              style={{
                                                                backgroundColor:
                                                                  "white",
                                                                boxShadow:
                                                                  "none",
                                                                height: "40px",
                                                                border:
                                                                  "1px solid #d2d6da",
                                                                padding:
                                                                  "0px 0px 0px 0px",
                                                                margin:
                                                                  "0px -3px 0px 0px",
                                                              }}
                                                            >
                                                               <input
                                                                multiple
                                                                accept=".csv , .txt"
                                                                // multiple
                                                                required={
                                                                  RadioGroupValues ==
                                                                  4
                                                                }
                                                                id="fileName"
                                                                type="file"
                                                                style={{
                                                                  color:
                                                                    "#7b809a",
                                                                }}
                                                                onChange={(
                                                                  e,
                                                                  index
                                                                ) => {
                                                                  getImage(
                                                                    e,
                                                                    index
                                                                  );
                                                                }}
                                                              /> *
                                                            </Button>
                                                          </div>
                                                        </div>
                                                      </>
                                                    </div> */}

                                                    {/* -------------------------New file----------- */}
                                                    <div className="container px-0 mt-">
                                                      <div>
                                                        <Button
                                                          className="position-relative"
                                                          variant="contained"
                                                          component="label"
                                                          style={{
                                                            backgroundColor:
                                                              "white",
                                                            boxShadow: "none",
                                                            height: "40px",
                                                            border:
                                                              "1px solid #d2d6da",
                                                            padding:
                                                              "0px 0px 0px 0px",
                                                            // margin:
                                                            //   "0px -3px 0px 0px",
                                                          }}
                                                        >
                                                          <input
                                                            className="w-100 p-0"
                                                            multiple
                                                            style={{
                                                              // display: "none",
                                                              opacity: "0",
                                                              height: "35px",
                                                            }}
                                                            //   value={state}
                                                            onChange={(e) => {
                                                              // alert("HII");
                                                              UploadFiles(e);
                                                              // console.log(
                                                              //   e.target.files,
                                                              //   Array.from(
                                                              //     e.target.files
                                                              //   )
                                                              // );
                                                            }}
                                                            class="form-control form-control-lg"
                                                            id="formFileLg"
                                                            type="file"
                                                          />
                                                          <div
                                                            className="p-2"
                                                            style={{
                                                              position:
                                                                "absolute",
                                                              left: "0",
                                                              right: "0",
                                                              top: "0",
                                                              bottom: "0",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <button
                                                              style={{
                                                                lineHeight:
                                                                  "normal",
                                                                borderRadius:
                                                                  "0",
                                                                background:
                                                                  "#efefef",
                                                                border:
                                                                  "1px solid #000",
                                                                display:
                                                                  "block",
                                                                overflow:
                                                                  "hidden",
                                                                textOverflow:
                                                                  "ellipsis",
                                                                whiteSpace:
                                                                  "nowrap",
                                                                flex: "0 0 auto",
                                                              }}
                                                              className="btn py-0 px-1 text-dark m-0"
                                                              type="button"
                                                              onClick={() =>
                                                                document
                                                                  .getElementById(
                                                                    "formFileLg"
                                                                  )
                                                                  ?.click()
                                                              }
                                                            >
                                                              Choose Files
                                                            </button>
                                                            {state?.files
                                                              ?.length > 0 ? (
                                                              <span
                                                                className="ms-2 w-100 text-dark"
                                                                style={{
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                              >
                                                                {
                                                                  state?.files
                                                                    ?.length
                                                                }{" "}
                                                                Files
                                                              </span>
                                                            ) : (
                                                              <span
                                                                className="ms-2 w-100"
                                                                style={{
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  fontSize:
                                                                    "11px",
                                                                  color:
                                                                    "rgb(123, 128, 154)",
                                                                }}
                                                              >
                                                                No file chosen
                                                              </span>
                                                            )}
                                                          </div>
                                                        </Button>
                                                      </div>
                                                    </div>

                                                    {/* -------------------------------End new file--------------------------------- */}
                                                  </div>
                                                  <div className="col-md-6">
                                                    <>
                                                      <div className="mx-0 d-inline-block">
                                                        <span>
                                                          (Reference File)
                                                        </span>

                                                        <span>
                                                          <a
                                                            href={contactfile3}
                                                            target="_blank"
                                                            download="Reference.txt"
                                                            className="xlsx"
                                                          >
                                                            txt
                                                          </a>
                                                        </span>

                                                        <span className="mx-1">
                                                          ,
                                                        </span>
                                                      </div>
                                                      <div className="ms-1 me-0 d-inline-block">
                                                        <span>
                                                          <a
                                                            href={contactfile2}
                                                            target="_blank"
                                                            download="Reference.csv"
                                                            className="xlsx"
                                                          >
                                                            {/* Download Here
                                                             */}
                                                            csv
                                                          </a>
                                                        </span>
                                                      </div>
                                                    </>
                                                  </div>
                                                </div>

                                                <div className="row">
                                                  <div className="col-md-6">
                                                    <div
                                                      className="row"
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      {state?.files?.map(
                                                        (file, index) => {
                                                          return (
                                                            <div className="col-6">
                                                              <div className="d-flex align-items-center">
                                                                <span
                                                                  style={{
                                                                    overflow:
                                                                      "hidden",
                                                                    textOverflow:
                                                                      "ellipsis",
                                                                    whiteSpace:
                                                                      "nowrap",
                                                                    display:
                                                                      "block",
                                                                    width:
                                                                      "100%",
                                                                  }}
                                                                >
                                                                  {file?.name}
                                                                </span>
                                                                <button
                                                                  className="border-0 bg-transparent"
                                                                  type="button"
                                                                  onClick={() => {
                                                                    let stateeCopy =
                                                                      {
                                                                        ...state,
                                                                      };

                                                                    stateeCopy.files =
                                                                      stateeCopy?.files?.filter(
                                                                        (
                                                                          fileName,
                                                                          indexx
                                                                        ) =>
                                                                          indexx !==
                                                                          index
                                                                      );
                                                                    setState(
                                                                      stateeCopy
                                                                    );
                                                                  }}
                                                                >
                                                                  {/* X */}
                                                                  <CancelIcon
                                                                    className=" gray_text_up"
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      flex: "0 0 auto",
                                                                      fontSize:
                                                                        "1.32rem",
                                                                    }}
                                                                  />
                                                                </button>
                                                              </div>
                                                            </div>
                                                          );
                                                        }
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                                {/* <div className="row px-3 mt-2">
                                                  <div className="col-md-6">
                                                    <div className="row">
                                                      {FilesImage?.map(
                                                        (dataaaa, index) => {
                                                          return (
                                                            <>
                                                              <div
                                                                className="col-6"
                                                                id="file_icon"
                                                                style={{
                                                                  fontSize:
                                                                    "12px",
                                                                }}
                                                              >
                                                                <div className="d-flex align-items-center">
                                                                  <div
                                                                    className="m-0"
                                                                    style={{
                                                                      width:
                                                                        "100%",
                                                                      overflow:
                                                                        "hidden",
                                                                      textOverflow:
                                                                        "ellipsis",
                                                                      whiteSpace:
                                                                        "nowrap",
                                                                    }}
                                                                  >
                                                                    <span
                                                                      class="d-block w-100 text-capitalize spn card_dt_UP"
                                                                      data-bs-toggle="tooltip"
                                                                      data-bs-placement="top"
                                                                      title={
                                                                        dataaaa?.name
                                                                      }
                                                                    >
                                                                      {
                                                                        dataaaa?.name
                                                                      }
                                                                    </span>
                                                               
                                                                  </div>
                                                                  <div className="ms-1">
                                                                    {" "}
                                                                   
                                                                    <CancelIcon
                                                                      className=" gray_text_up"
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() => {
                                                                        let temp_arraction =
                                                                          [
                                                                            ...FilesImage,
                                                                          ];

                                                                        const previousSecondElementOfTheArray =
                                                                          temp_arraction.filter(
                                                                            (
                                                                              val,
                                                                              indexx
                                                                            ) => {
                                                                              return (
                                                                                index !=
                                                                                indexx
                                                                              );
                                                                            }
                                                                          );
                                                                      
                                                                        setFilesImage(
                                                                          previousSecondElementOfTheArray
                                                                        );
                                                                      }}
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </>
                                                          );
                                                        }
                                                      )}
                                                    </div>
                                                  </div>
                                                </div> */}
                                              </RadioGroup>
                                            </FormControl>
                                          </div>
                                        </div>
                                        <div></div>
                                      </>
                                    </div>
                                  )}{" "}
                                </div>
                              </div>
                            </section>
                            <section></section>
                          </Typography>
                        </AccordionDetails>
                      </Accordion>{" "}
                      <section
                        className="sms_form mt-4"
                        id="schedule"
                        style={{
                          boxShadow: "0px 1px 6px #00000091",
                          borderRadius: "20px",
                          /* margin-top: 53px; */
                          paddingBottom: "20px",
                        }}
                      >
                        <div className="flt_start">
                          <div className="float-start d-flex align-items-center flex-wrap"></div>
                        </div>
                        <div className="d-flex justify-content-center align-items-center mt-4">
                          <button
                            type="button"
                            className="btn btn-danger d-flex align-items-center text-capitalize btn_9 m-0 btnapprove"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal1"
                            onClick={() => {

                              // setValue(moment(new Date()).add(1, "minutes"));
                              setValue(
                                moment(new Date())
                                  .subtract(5.5, "hours")
                                  .add(16, "minutes")
                                  .format("YYYY-MM-DD HH:mm")
                              );
                              setCalenderSchedule(
                                moment(new Date())
                                  .subtract(5.5, "hours")
                                  .add(16, "minutes")
                                  .format("YYYY-MM-DD HH:mm")
                              );
                            }}
                            disabled={
                              (disableMobileNumber[0] == false ||
                                mobileNumbers?.split(",").length >= 11) &&
                              Bulkselector.length === 0 &&
                              Bulkselector1.length === 0 &&
                              radiobutton != 3 &&
                              // FilesImage == null
                              //   ? true
                              //   : false
                              (state?.files.length == 0 ||
                                state?.files.length > 5)
                            }
                          >
                            <i className="fas fa-calendar-alt d-block"></i>
                            <span className="d-block ms-1">
                              schedule for later
                            </span>
                          </button>
                          <span className="d-block text-capitalize span_or mx-3">
                            or
                          </span>
                          <button
                            type="submit"
                            className="btn btn-success d-flex align-items-center text-capitalize btn_9 m-0 btnapprove"
                            disabled={
                              // formik.values.textarea === "" &&
                              (disableMobileNumber[0] == false ||
                                mobileNumbers?.split(",").length >= 11) &&
                              Bulkselector.length === 0 &&
                              Bulkselector1.length === 0 &&
                              radiobutton != 3 &&
                              // FilesImage == null
                              //   ? true
                              //   : false
                              (state?.files.length == 0 ||
                                state?.files.length > 5)
                            }
                          >
                            <i className="fas fa-share d-block"></i>

                            <span className="d-block ms-1">send now</span>
                          </button>
                          <span className="d-block text-capitalize span_or mx-3">
                            or
                          </span>
                          <button
                            type="button"
                            // onClick={CreateCampaignApi()}
                            onClick={() => {
                              CreateCampaignApi();
                            }}
                            className="btn btn-primary d-flex align-items-center text-capitalize btn_9 m-0 btnapprove"
                            disabled={
                              // formik.values.textarea === "" &&
                              (disableMobileNumber[0] == false ||
                                mobileNumbers?.split(",").length >= 11) &&
                              Bulkselector.length === 0 &&
                              Bulkselector1.length === 0 &&
                              radiobutton != 3 &&
                              // FilesImage == null
                              //   ? true
                              //   : false
                              (state?.files.length == 0 ||
                                state?.files.length > 5)
                            }
                          >
                            <i className="fas fa-share d-block"></i>

                            <span className="d-block ms-1">
                              create campaign
                            </span>
                          </button>
                        </div>
                      </section>
                    </form>

                    <section className="modal_1">
                      {/* <!-- Modal --> */}

                      {/* <!-- Modal   For Test Campaign--> */}
                      <div
                        className="modal fade"
                        id="exampleModal51"
                        // tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5
                                className="modal-title text-capitalize"
                                id="exampleModalLabel"
                              >
                                Test Campaign
                              </h5>
                              <button
                                ref={cuttt}
                                type="button"
                                className="btn-close m-0 p-0"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <form onSubmit={TestCampaign}>
                              <div className="modal-body">
                                <TextField
                                  autoComplete="on"
                                  className="ms-4 w-50"
                                  type="number"
                                  label="Target Test Number"
                                  value={testcampaign}
                                  variant="outlined"
                                  size="small"
                                  required
                                  onChange={(e) => {
                                    settestcampaign(e.target.value);
                                  }}
                                  onInput={(e) => {
                                    e.target.value = Math.max(
                                      0,
                                      parseInt(e.target.value)
                                    )
                                      .toString()
                                      .slice(0, 10);
                                  }}
                                />
                              </div>

                              <div className="modal-footer">
                                <button
                                  type="submit"
                                  className="btn btn-secondary m-0"
                                >
                                  ok
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      {/* ----------schedule sms later---------- */}
                      <div
                        className="modal fade"
                        id="exampleModal1"
                        // tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5
                                className="modal-title text-capitalize"
                                id="exampleModalLabel"
                              >
                                schedule sms later
                              </h5>
                              <button
                                type="button"
                                className="btn-close m-0 p-0"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                  setCheckedRecurring("");
                                  setStatusDropDown("");
                                  
                                }}
                              ></button>
                            </div>
                            <form onSubmit={scheduleapi}>
                              <div className="modal-body">
                                {/* <NativePickers parentCallback={callbackSchedule} /> */}

                                <div>
                                  <span className="fw-bold">
                                    Is it recurring Campaign?
                                  </span>
                                  <Switch
                                    checked={checkedRecurring}
                                    onChange={handleChangetoogleRecurring}
                                    inputProps={{ "aria-label": "controlled" }}
                                  />
                                </div>
                                <div className="my-4 mt-2">
                                  {checkedRecurring == true ? (
                                    <>
                                      <div className="col-md-4">
                                        <FormControl fullWidth size="small">
                                          <InputLabel id="demo-simple-select-autowidth-label">
                                            Recurring
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            value={statusDropDown}
                                            onChange={handleChangeRecurring}
                                            autowidth
                                            label="Recurring"
                                          >
                                            <MenuItem value="daily">
                                              Daily
                                            </MenuItem>
                                            <MenuItem value="weekly">
                                              Weekly
                                            </MenuItem>
                                            <MenuItem value="monthly">
                                              Monthly
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                <div className="">
                                  <>
                                    {" "}
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                      style={{ zIndex: "10px" }}
                                    >
                                      <DateTimePicker
                                        disabled={
                                          checkedRecurring == true &&
                                          (statusDropDown == "" ||
                                            statusDropDown == null)
                                        }
                                        inputRef={datereff}
                                        disablePast
                                        // minDate={dayjs(new Date())}
                                        // minDateTime={dayjs().subtr}

                                        minDateTime={dayjs()
                                          .subtract(5.5, "h")
                                          .add(15, "m")}
                                        // minTime={moment().add(15,"minutes")}
                                        renderInput={(props) => (
                                          <TextField
                                            size="small"
                                            required
                                            style={{ zIndex: "10px" }}
                                            {...props}
                                            helperText={
                                              "(Date time should be mm/dd/yyyy hh:mm)"
                                            }
                                          />
                                        )}
                                        ampm={false}
                                        style={{ zIndex: "10px" }}
                                        label="Select Schedule"
                                        value={value}
                                        onChange={(newValue) => {
                                          setValue(newValue?.$d);
                                          // console.log("ee",newValue)
                                        }}
                                      />
                                    </LocalizationProvider>
                                  </>
                                </div>
                              </div>
                              {/* </button> */}

                              <div className="modal-footer mt-3 justify-content-between align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-secondary m-0"
                                  data-bs-dismiss="modal"
                                  onClick={() => {
                                    setValue(null);
                                    setCheckedRecurring("");
                                    setStatusDropDown("");
                                  }}
                                >
                                  Close
                                </button>

                                <button
                                  type="submit"
                                  className="btn btn-primary m-0 ms-2"
                                  disabled={buttonDisable}
                                  data-bs-dismiss="modal"
                                >
                                  Submit Campaign
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      {/* ---------  message summary ---------- */}
                      <div
                        className="modal fade"
                        id="exampleModal2"
                        // tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5
                                className="modal-title text-capitalize"
                                id="exampleModalLabel"
                              >
                                message summary
                              </h5>
                              <button
                                type="button"
                                className="btn-close m-0 p-0"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <div className="row mx-0">
                                <div className="col-4 px-0">
                                  <p className="">total numbers</p>
                                </div>
                                <div className="col-8 px-0">
                                  <p className="">3</p>
                                </div>
                              </div>
                              <div className="row mx-0">
                                <div className="col-4 px-0">
                                  <p className="">message</p>
                                </div>
                                <div className="col-8 px-0">
                                  <p className="">welcome sms</p>
                                </div>
                              </div>
                              <div className="row mx-0">
                                <div className="col-4 px-0">
                                  <p className="">message type</p>
                                </div>
                                <div className="col-8 px-0">
                                  <p className="">transactional(ENGLISH)</p>
                                </div>
                              </div>
                              <div className="row mx-0">
                                <div className="col-4 px-0">
                                  <p className="">credit required</p>
                                </div>
                                <div className="col-8 px-0">
                                  <p className="">3</p>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer justify-content-start">
                              <button
                                type="button"
                                className="btn btn-secondary m-0"
                                data-bs-dismiss="modal"
                              >
                                cancel
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary d-flex align-items-center m-0 ms-2"
                                id="launch_now"
                              >
                                <i className="fas fa-calendar-alt d-block"></i>
                                <span className="d-block ms-1">launch now</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* ----------   my template ----------- */}
                      <div
                        class="modal fade"
                        id="exampleModal3"
                        // tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-lg">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5
                                class="modal-title text-capitalize"
                                id="exampleModalLabel"
                              >
                                my template
                              </h5>
                              <button
                                type="button"
                                class="btn-close m-0 p-0"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div class="modal-body">
                              <div class="table-responsive">
                                <table>
                                  <thead>
                                    <tr>
                                      <th>select</th>
                                      <th>template name</th>
                                      <th>template</th>
                                      <th>DLTTemplateId</th>
                                      <th>TelemarketerId</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <a href="#" class="d-block">
                                          select
                                        </a>
                                      </td>
                                      <td>for testing DLT</td>
                                      <td>
                                        <p>
                                          This is testing message from ISPL
                                          India visit on
                                        </p>
                                        <a class="d-inline-block">
                                          www.innuvissolutions.com
                                        </a>
                                        <p>email us:</p>
                                        <a class="d-inline-block">
                                          support@innuvissolutions.com
                                        </a>
                                      </td>
                                      <td>1707160138351612059</td>
                                      <td>1701158159410623084</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <a href="#" class="d-block">
                                          select
                                        </a>
                                      </td>
                                      <td>for testing DLT</td>
                                      <td>
                                        vguvgvggvu vgyvggvvgu vgyvgvg vvggvu
                                        vgyuvgugv vvgvugv vgyuvguufvf vguvguvu
                                        vgyvcfufcuucf vgyctfcfcfu vucfcfcf
                                        vucfcfcffcf vcctffctctffctuftu
                                        vcyufucfcuucfucf ctufccfucftucfut
                                        ctfcfccftcf vccfcfcftctyt
                                        cfyfcyfcxdxdszwaewcfvg
                                        vccfcftyfcyfcffchfc
                                      </td>
                                      <td>1707160138351612059</td>
                                      <td>1701158159410623084</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <a href="#" class="d-block">
                                          select
                                        </a>
                                      </td>
                                      <td>for testing DLT</td>
                                      <td>
                                        vguvgvggvu vgyvggvvgu vgyvgvg vvggvu
                                        vgyuvgugv vvgvugv vgyuvguufvf vguvguvu
                                        vgyvcfufcuucf vgyctfcfcfu vucfcfcf
                                        vucfcfcffcf vcctffctctffctuftu
                                        vcyufucfcuucfucf ctufccfucftucfut
                                        ctfcfccftcf vccfcfcftctyt
                                        cfyfcyfcxdxdszwaewcfvg
                                        vccfcftyfcyfcffchfc
                                      </td>
                                      <td>1707160138351612059</td>
                                      <td>1701158159410623084</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <a href="#" class="d-block">
                                          select
                                        </a>
                                      </td>
                                      <td>for testing DLT</td>
                                      <td>
                                        vguvgvggvu vgyvggvvgu vgyvgvg vvggvu
                                        vgyuvgugv vvgvugv vgyuvguufvf vguvguvu
                                        vgyvcfufcuucf vgyctfcfcfu vucfcfcf
                                        vucfcfcffcf vcctffctctffctuftu
                                        vcyufucfcuucfucf ctufccfucftucfut
                                        ctfcfccftcf vccfcfcftctyt
                                        cfyfcyfcxdxdszwaewcfvg
                                        vccfcftyfcyfcffchfc
                                      </td>
                                      <td>1707160138351612059</td>
                                      <td>1701158159410623084</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <a href="#" class="d-block">
                                          select
                                        </a>
                                      </td>
                                      <td>for testing DLT</td>
                                      <td>
                                        <p>
                                          This is testing message from ISPL
                                          India visit on
                                        </p>
                                        <a class="d-inline-block">
                                          www.innuvissolutions.com
                                        </a>
                                      </td>
                                      <td>1707160138351612059</td>
                                      <td>1701158159410623084</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <a href="#" class="d-block">
                                          select
                                        </a>
                                      </td>
                                      <td>for testing DLT</td>
                                      <td>
                                        vguvgvggvu vgyvggvvgu vgyvgvg vvggvu
                                        vgyuvgugv vvgvugv vgyuvguufvf vguvguvu
                                        vgyvcfufcuucf vgyctfcfcfu vucfcfcf
                                        vucfcfcffcf vcctffctctffctuftu
                                        vcyufucfcuucfucf ctufccfucftucfut
                                        ctfcfccftcf vccfcfcftctyt
                                        cfyfcyfcxdxdszwaewcfvg
                                        vccfcftyfcyfcffchfc
                                      </td>
                                      <td>1707160138351612059</td>
                                      <td>1701158159410623084</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <a href="#" class="d-block">
                                          select
                                        </a>
                                      </td>
                                      <td>for testing DLT</td>
                                      <td>
                                        vguvgvggvu vgyvggvvgu vgyvgvg vvggvu
                                        vgyuvgugv vvgvugv vgyuvguufvf vguvguvu
                                        vgyvcfufcuucf vgyctfcfcfu vucfcfcf
                                        vucfcfcffcf vcctffctctffctuftu
                                        vcyufucfcuucfucf ctufccfucftucfut
                                        ctfcfccftcf vccfcfcftctyt
                                        cfyfcyfcxdxdszwaewcfvg
                                        vccfcftyfcyfcffchfc
                                      </td>
                                      <td>1707160138351612059</td>
                                      <td>1701158159410623084</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button
                                type="button"
                                class="btn btn-secondary"
                                data-bs-dismiss="modal"
                              >
                                Close
                              </button>
                              <button type="button" class="btn btn-primary">
                                Save changes
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </section>
                </div>
                {/* <!--marquee-section--> */}
              </div>
            </div>
          </section>
        </ThemeProvider>
      </main>
    </>
  );
}
